/**
 * ACTIVE — popup-city PDP booking wizard (fork).
 * Edit assets/popup-city-wizard.js|css + snippets/popup-city-wizard-block.liquid for popup-city only.
 * Shared: workshop-city-flow-core.js + workshop-city-events-api.js
 */
(function () {
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DOW_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  var DOW_PICKER = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  var BOOKING_STEPS = ['variants', 'calendar']; /* popup single-page: both visible */
  var WL_STEPS = ['wl-notice'];
  var ALL_STEPS = WL_STEPS.concat(['calendar', 'time', 'variants', 'review']);
  var WCF_QTY_FALLBACK_MAX = 999;
  var WCF_VARIANT_ROW_MIN_PX = 86;
  var WCF_VARIANT_ROW_MIN_H_PX = 54;
  var WCF_VARIANT_GRID_GAP_PX = 4;

  function wizardViewportWidth() {
    return window.innerWidth || document.documentElement.clientWidth || 0;
  }

  function calendarDowLabels() {
    return wizardViewportWidth() < 750 ? DOW_SHORT : DOW_PICKER;
  }

  function variantCardLayout(root) {
    var layout = root && root.getAttribute('data-wcf-variant-layout');
    return layout === 'horizontal' ? 'horizontal' : 'stacked';
  }

  function isMobileViewport() {
    return wizardViewportWidth() < 750;
  }

  function bindHorizontalSwipe(el, onSwipe) {
    if (!el || el.__pcwSwipeBound || typeof onSwipe !== 'function') return;
    el.__pcwSwipeBound = true;
    var x0 = 0;
    var y0 = 0;
    var t0 = 0;
    var tracking = false;
    var axis = '';
    el.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
        t0 = Date.now();
        tracking = true;
        axis = '';
      },
      { passive: true }
    );
    el.addEventListener(
      'touchmove',
      function (e) {
        if (!tracking || !e.touches || !e.touches[0]) return;
        var dx = e.touches[0].clientX - x0;
        var dy = e.touches[0].clientY - y0;
        if (!axis && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) {
          axis = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
        }
      },
      { passive: true }
    );
    el.addEventListener(
      'touchend',
      function (e) {
        if (!tracking) return;
        tracking = false;
        if (axis !== 'h') return;
        var t = e.changedTouches && e.changedTouches[0];
        if (!t) return;
        var dx = t.clientX - x0;
        if (Math.abs(dx) < 48 || Date.now() - t0 > 800) return;
        el.__pcwSwiped = true;
        onSwipe(dx < 0 ? 1 : -1);
        window.setTimeout(function () {
          el.__pcwSwiped = false;
        }, 350);
      },
      { passive: true }
    );
  }

  function isDesktopViewport() {
    return wizardViewportWidth() >= 990;
  }

  /** Theme setting cap: mobile (<990) vs desktop (≥990). */
  function variantGridColsCap(root, count, width) {
    var useDesktop = wizardViewportWidth() >= 990 || width >= 520;
    var raw = root && root.getAttribute(useDesktop ? 'data-wcf-cols-desktop' : 'data-wcf-cols-mobile');
    var n = parseInt(String(raw), 10);
    var cap = useDesktop ? 4 : 3;
    if (Number.isFinite(n) && n >= 2) cap = Math.min(5, n);
    if (!useDesktop && width > 0 && width < 300) cap = Math.min(cap, 3);
    return Math.min(count, cap);
  }

  /** Stacked grid: use theme column count; only reduce if panel is too narrow. */
  function pickStackedGridColumns(count, width, height, gap, root) {
    var cap = variantGridColsCap(root, count, width);
    var minColPx = wizardViewportWidth() >= 990 ? 72 : 64;
    while (cap > 2 && width > 0 && cap * minColPx > width + 6) cap -= 1;
    return Math.max(1, cap);
  }

  function variantGridGapPx() {
    if (isDesktopViewport()) return 2;
    if (isMobileViewport()) return 4;
    return 4;
  }

  function fitPickerLabelSize(label, size) {
    if (!label) return size;
    var min = 8;
    var next = size;
    label.style.fontSize = next + 'px';
    var guard = 0;
    while (guard++ < 16 && next > min && label.scrollWidth > label.clientWidth + 1) {
      next -= 0.5;
      label.style.fontSize = next + 'px';
    }
    return next;
  }

  function fitWizardPickerLabels(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var labels = scope.querySelectorAll('[data-pcw-date-label], [data-pcw-time-label]');
    if (!labels.length) return;
    var size = 14;
    labels.forEach(function (label) {
      label.style.fontSize = size + 'px';
    });
    labels.forEach(function (label) {
      size = Math.min(size, fitPickerLabelSize(label, size));
    });
    labels.forEach(function (label) {
      label.style.fontSize = size + 'px';
    });
  }

  function scheduleFitPickerLabels(scope) {
    window.requestAnimationFrame(function () {
      fitWizardPickerLabels(scope);
    });
  }

  function stackedThumbPx(cols, width, height, count, gap) {
    var mobile = isMobileViewport();
    var desktop = isDesktopViewport() || width >= 520;
    var rows = Math.ceil(count / cols);
    var g = gap >= 0 ? gap : variantGridGapPx();
    var colW = width > 0 ? (width - g * Math.max(0, cols - 1)) / cols : 100;
    var innerPad = desktop ? 18 : 12;
    var cardW = Math.max(44, colW);
    var thumbByW;
    if (desktop) {
      thumbByW = Math.max(72, Math.min(112, Math.floor(cardW - innerPad)));
    } else {
      var maxThumb = mobile ? 56 : 64;
      var minThumb = cols >= 4 ? 32 : 36;
      thumbByW = Math.max(minThumb, Math.min(maxThumb, Math.floor(colW - 30)));
    }
    if (height <= 0 || rows <= 0) return thumbByW;
    var rowBudget = Math.floor((height - Math.max(0, rows - 1) * g) / rows) - (desktop ? 32 : 34);
    var minThumb = desktop ? 44 : cols >= 4 ? 32 : 36;
    return Math.max(minThumb, Math.min(thumbByW, rowBudget));
  }

  function ensureAddonThumb(root) {
    if (!root) return;
    var thumb = root.querySelector('[data-wcf-addon-thumb]');
    var src = (root.getAttribute('data-addon-image') || '').trim();
    if (!thumb || !src) return;
    if (thumb.tagName === 'IMG') {
      if (!thumb.getAttribute('src')) thumb.setAttribute('src', src);
      return;
    }
    var img = document.createElement('img');
    img.className = 'wcf-review-addon__thumb';
    img.setAttribute('data-wcf-addon-thumb', '');
    img.setAttribute('src', src);
    img.setAttribute('width', '43');
    img.setAttribute('height', '43');
    img.setAttribute('loading', 'lazy');
    img.setAttribute('decoding', 'async');
    img.setAttribute('alt', (root.getAttribute('data-addon-title') || 'Turkish Coffee').trim());
    thumb.replaceWith(img);
  }

  function formatBookingSubLabel(slot) {
    if (!slot) return '';
    var dateKey = slot.date_key || '';
    var timeLabel = String(slot.time_label || '').trim();
    if (dateKey && timeLabel) return dateKey + ' | ' + timeLabel;
    if (dateKey) return dateKey;
    var label = String(slot.display_label || '').trim();
    if (!label) return '';
    label = label.replace(/\s*[·•]\s*.+$/u, '').trim();
    return label;
  }

  /** Columns: fit width, minimize rows so everything fits height without scroll. */
  function pickVariantGridColumns(count, containerWidth, containerHeight, layout) {
    if (count <= 0) return 1;
    if (count === 1) return 1;
    layout = layout === 'horizontal' ? 'horizontal' : 'stacked';
    var width = containerWidth || 0;
    var height = containerHeight || 0;
    var gap = WCF_VARIANT_GRID_GAP_PX;

    var bestCols = 1;
    var bestScore = -Infinity;
    var minColPx = WCF_VARIANT_ROW_MIN_PX;
    var maxCols = count;

    if (width > 0) {
      if (layout === 'horizontal' && width < 990) {
        maxCols = Math.min(count, isMobileViewport() ? 2 : 3);
        minColPx = 110;
      } else if (width >= 420 && count >= 6) {
        maxCols = Math.min(count, 4);
      }
    }

    for (var cols = maxCols; cols >= 1; cols--) {
      if (width > 0 && cols * minColPx > width) continue;
      var rows = Math.ceil(count / cols);
      var needH = rows * WCF_VARIANT_ROW_MIN_H_PX + Math.max(0, rows - 1) * gap;
      if (height > 0 && needH > height) continue;

      var lastRow = count % cols || cols;
      var fullness = lastRow / cols;
      var score = fullness * 400 + cols * 28 - rows * 18;
      if (width >= 420 && count >= 6 && cols >= 4) score += 120;
      if (height > 0) score += (height - needH) * 0.35;
      if (score > bestScore) {
        bestScore = score;
        bestCols = cols;
      }
    }
    return Math.max(1, bestCols);
  }

  var PCW_CARD_GAP_PX = 12;

  function bindVariantRailMotion(wrap) {
    if (window.WorkshopCityFlow && typeof window.WorkshopCityFlow.bindVariantRailMotion === 'function') {
      window.WorkshopCityFlow.bindVariantRailMotion(wrap);
    }
  }

  /**
   * How far the rail sits inside the page (mobile) or product column (desktop).
   * The track uses those side gutters so extra cards scroll off the column edge.
   */
  function variantRailBleed(rail, box) {
    if (!box) return { bleedLeft: 0, bleedRight: 0 };
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var edgeLeft = 0;
    var edgeRight = document.documentElement.clientWidth || window.innerWidth || 0;
    if (!mobile) {
      var column =
        (rail &&
          rail.closest &&
          (rail.closest('.product-info') || rail.closest('.product-content-container'))) ||
        null;
      if (!column || !column.getBoundingClientRect) return { bleedLeft: 0, bleedRight: 0 };
      var col = column.getBoundingClientRect();
      edgeLeft = col.left;
      edgeRight = col.right;
    }
    return {
      bleedLeft: Math.max(0, Math.round(box.left - edgeLeft)),
      bleedRight: Math.max(0, Math.round(edgeRight - box.right))
    };
  }

  /**
   * Size cards to the real rail width so 2–3 whole cards always fit.
   * Extra cards stay on the row and scroll through the left/right gutters.
   */
  function carouselMetrics(wrap, count) {
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var rootEl = wrap && wrap.closest ? wrap.closest('.pcw-root') : null;
    var ss23 = !!(rootEl && rootEl.classList && rootEl.classList.contains('pcw-root--ss23'));
    /* ss23 mint: slightly smaller cards so the next one peeks */
    var design = ss23 ? (mobile ? 112 : 148) : mobile ? 112 : 168;
    var minSize = ss23 ? (mobile ? 86 : 110) : mobile ? 86 : 120;
    var gap = PCW_CARD_GAP_PX;
    var total = Math.max(1, count || 0);
    var rail = wrap && wrap.closest ? wrap.closest('.pcw-variants-rail') : null;
    var box = rail && rail.getBoundingClientRect ? rail.getBoundingClientRect() : null;
    var avail = box ? Math.round(box.width) : 0;
    if (!avail && wrap) avail = wrap.clientWidth || 0;
    var bleed = variantRailBleed(rail, box);
    if (ss23) {
      bleed = { bleedLeft: 0, bleedRight: 0 };
    }
    if (avail <= 0) {
      return {
        size: design,
        width: 0,
        inner: 0,
        cols: total,
        bleedLeft: bleed.bleedLeft,
        bleedRight: bleed.bleedRight
      };
    }

    var size3 = (avail - gap * 2) / 3;
    var size2 = (avail - gap) / 2;
    var size;
    var visible;
    if (total >= 3 && size3 >= minSize) {
      visible = 3;
      size = Math.min(design, size3);
    } else if (total >= 2 && size2 >= minSize) {
      visible = 2;
      size = Math.min(design, size2);
    } else {
      visible = 1;
      size = Math.min(design, Math.max(minSize, avail));
    }

    /* Mint shell: fit ~4 cards + peek of 5th inside padding */
    if (ss23 && total >= 5) {
      var peek5 = mobile ? 28 : 36;
      var size4 = (avail - peek5 - gap * 4) / 4;
      if (size4 >= minSize) {
        visible = 4;
        size = Math.min(design, size4);
      } else {
        var size3p = (avail - peek5 - gap * 3) / 3;
        if (size3p >= minSize) {
          visible = 3;
          size = Math.min(design, size3p);
        }
      }
    } else if (total > visible && bleed.bleedLeft <= 0 && bleed.bleedRight <= 0) {
      /* Gutters already peek the next card; only shrink when the rail is boxed in. */
      var peek = ss23
        ? mobile
          ? 28
          : 36
        : Math.min(20, Math.max(12, Math.round(size * 0.14)));
      var withPeek = (avail - peek - gap * visible) / visible;
      if (withPeek >= minSize) size = Math.min(size, withPeek);
    }

    size = Math.max(1, Math.round(size * 100) / 100);
    return {
      size: size,
      width: total * size + gap * Math.max(0, total - 1),
      inner: avail,
      cols: total,
      bleedLeft: bleed.bleedLeft,
      bleedRight: bleed.bleedRight
    };
  }

  function applySingleVariantSpacing(wrap, root, sizePx, metrics) {
    if (!wrap || !root || !root.classList.contains('pcw-root--single')) return;
    if (root.classList.contains('pcw-root--ss23')) {
      var mobileSs23 = window.matchMedia('(max-width: 749px)').matches;
      var sizeSs = parseFloat(sizePx);
      if (!isFinite(sizeSs) || sizeSs <= 0) {
        sizeSs = metrics && metrics.size ? parseFloat(metrics.size) : mobileSs23 ? 112 : 128;
      }
      if (!isFinite(sizeSs) || sizeSs <= 0) sizeSs = mobileSs23 ? 112 : 128;
      var sizeSsCss = Math.round(sizeSs) + 'px';
      wrap.style.setProperty('--pcw-variant-size', sizeSsCss);
      wrap.style.setProperty('--wcf-variant-thumb', sizeSsCss);
      root.style.setProperty('--pcw-variant-size', sizeSsCss);
      if (mobileSs23) {
        /* Mobile: hub-style peek — px slide width (same as --wbw-slide-w). */
        wrap.style.setProperty('display', 'flex', 'important');
        wrap.style.setProperty('flex-direction', 'row', 'important');
        wrap.style.setProperty('flex-wrap', 'nowrap', 'important');
        wrap.style.setProperty('align-items', 'stretch', 'important');
        wrap.style.setProperty('grid-template-columns', 'none', 'important');
        wrap.style.setProperty('overflow-x', 'auto', 'important');
        wrap.style.setProperty('overflow-y', 'visible', 'important');
        wrap.style.setProperty('gap', '0.4rem', 'important');
        wrap.style.setProperty('width', '100%', 'important');
        wrap.style.setProperty('max-width', '100%', 'important');
        wrap.style.setProperty('margin-left', '0', 'important');
        wrap.style.setProperty('margin-right', '0', 'important');
        wrap.style.setProperty('padding-left', '0', 'important');
        wrap.style.setProperty('padding-right', '0', 'important');
        wrap.style.setProperty('scroll-padding-left', '0', 'important');
        wrap.style.setProperty('scroll-padding-right', '0', 'important');
        wrap.style.removeProperty('--pcw-variant-size');
        wrap.style.removeProperty('--wcf-variant-thumb');
        root.style.removeProperty('--pcw-variant-size');
        var trackWSs = wrap.clientWidth || 0;
        if (trackWSs <= 0 && wrap.getBoundingClientRect) {
          trackWSs = Math.round(wrap.getBoundingClientRect().width);
        }
        var slidePxSs = Math.max(160, Math.round(trackWSs * 0.6));
        var slideCssSs = slidePxSs + 'px';
        wrap.style.setProperty('--pcw-slide-w', slideCssSs);
        wrap.style.setProperty('--wcf-variant-gap', '6px');
        wrap.querySelectorAll('.wcf-variant-row').forEach(function (row) {
          row.style.setProperty('display', 'flex', 'important');
          row.style.setProperty('flex-direction', 'column', 'important');
          row.style.setProperty('align-items', 'stretch', 'important');
          row.style.setProperty('flex', '0 0 ' + slideCssSs, 'important');
          row.style.setProperty('width', slideCssSs, 'important');
          row.style.setProperty('min-width', slideCssSs, 'important');
          row.style.setProperty('max-width', slideCssSs, 'important');
          var media = row.querySelector('.wcf-variant-card__media');
          if (media) {
            media.style.setProperty('width', '100%', 'important');
            media.style.setProperty('height', 'auto', 'important');
            media.style.setProperty('min-width', '0', 'important');
            media.style.setProperty('min-height', '0', 'important');
            media.style.setProperty('max-width', '100%', 'important');
            media.style.setProperty('max-height', 'none', 'important');
            media.style.setProperty('aspect-ratio', '1 / 1', 'important');
            media.style.setProperty('flex', 'none', 'important');
          }
        });
        return;
      }
      /* Desktop ss23: stylesheet grid owns layout. */
      ['display', 'flex-wrap', 'flex-direction', 'grid-template-columns', 'grid-template-rows', 'gap', 'column-gap', 'row-gap', 'overflow', 'overflow-x'].forEach(function (prop) {
        wrap.style.removeProperty(prop);
      });
      wrap.querySelectorAll('.wcf-variant-row, .wcf-variant-card, .wcf-variant-card__title, .wcf-variant-card__media, .wcf-variant-qty-col, .wcf-qty--variant').forEach(function (el) {
        ['flex', 'flex-basis', 'width', 'min-width', 'max-width', 'height', 'min-height', 'max-height', 'margin-left', 'margin-right'].forEach(function (prop) {
          el.style.removeProperty(prop);
        });
      });
      return;
    }
    /* Non-ss23 mobile: same hub-style peek (px slide) as ss23. */
    if (window.matchMedia('(max-width: 749px)').matches) {
      wrap.style.setProperty('display', 'flex', 'important');
      wrap.style.setProperty('flex-direction', 'row', 'important');
      wrap.style.setProperty('flex-wrap', 'nowrap', 'important');
      wrap.style.setProperty('align-items', 'stretch', 'important');
      wrap.style.setProperty('grid-template-columns', 'none', 'important');
      wrap.style.setProperty('overflow-x', 'auto', 'important');
      wrap.style.setProperty('overflow-y', 'visible', 'important');
      wrap.style.setProperty('gap', '0.4rem', 'important');
      wrap.style.setProperty('width', '100%', 'important');
      wrap.style.setProperty('max-width', '100%', 'important');
      wrap.style.setProperty('margin-left', '0', 'important');
      wrap.style.setProperty('margin-right', '0', 'important');
      wrap.style.setProperty('padding-left', '0', 'important');
      wrap.style.setProperty('padding-right', '0', 'important');
      wrap.style.setProperty('scroll-padding-left', '0', 'important');
      wrap.style.setProperty('scroll-padding-right', '0', 'important');
      wrap.style.removeProperty('--pcw-variant-size');
      wrap.style.removeProperty('--wcf-variant-thumb');
      root.style.removeProperty('--pcw-variant-size');
      var trackW = wrap.clientWidth || 0;
      if (trackW <= 0 && wrap.getBoundingClientRect) {
        trackW = Math.round(wrap.getBoundingClientRect().width);
      }
      var slidePx = Math.max(160, Math.round(trackW * 0.6));
      var slideCss = slidePx + 'px';
      wrap.style.setProperty('--pcw-slide-w', slideCss);
      wrap.style.setProperty('--wcf-variant-gap', '6px');
      wrap.querySelectorAll('.wcf-variant-row').forEach(function (row) {
        row.style.setProperty('display', 'flex', 'important');
        row.style.setProperty('flex-direction', 'column', 'important');
        row.style.setProperty('align-items', 'stretch', 'important');
        row.style.setProperty('flex', '0 0 ' + slideCss, 'important');
        row.style.setProperty('width', slideCss, 'important');
        row.style.setProperty('min-width', slideCss, 'important');
        row.style.setProperty('max-width', slideCss, 'important');
        var media = row.querySelector('.wcf-variant-card__media');
        if (media) {
          media.style.setProperty('width', '100%', 'important');
          media.style.setProperty('height', 'auto', 'important');
          media.style.setProperty('min-width', '0', 'important');
          media.style.setProperty('min-height', '0', 'important');
          media.style.setProperty('max-width', '100%', 'important');
          media.style.setProperty('max-height', 'none', 'important');
          media.style.setProperty('aspect-ratio', '1 / 1', 'important');
          media.style.setProperty('flex', 'none', 'important');
        }
      });
      return;
    }

    var gapPx = PCW_CARD_GAP_PX;
    var size = parseFloat(sizePx);
    if (!isFinite(size) || size <= 0) size = 168;
    /* Mint shell (ss23): never stretch past design size (peek sizing comes from carouselMetrics). */
    if (root.classList.contains('pcw-root--ss23')) {
      var mobileSs = window.matchMedia('(max-width: 749px)').matches;
      var designSs = mobileSs ? 132 : 148;
      size = Math.min(size, designSs);
    }
    size = Math.round(size * 100) / 100;
    var sizeCss = size + 'px';
    var qtyCss = Math.min(88, Math.max(68, Math.round(size - 16))) + 'px';
    var trackWidth = metrics ? parseFloat(metrics.width) : 0;
    if (!isFinite(trackWidth) || trackWidth <= 0) trackWidth = 0;
    var bleedLeft = (metrics && metrics.bleedLeft) || 0;
    var bleedRight = (metrics && metrics.bleedRight) || 0;
    /* ss23: no edge bleed / 100vw — scroll stays inside mint padding */
    if (root.classList.contains('pcw-root--ss23')) {
      bleedLeft = 0;
      bleedRight = 0;
    }
    var inner = metrics && metrics.inner ? parseFloat(metrics.inner) : 0;
    if (!isFinite(inner) || inner <= 0) inner = 0;
    if (bleedLeft > 0 || bleedRight > 0) {
      wrap.style.setProperty('box-sizing', 'border-box', 'important');
      wrap.style.setProperty('margin-left', -bleedLeft + 'px', 'important');
      wrap.style.setProperty('margin-right', -bleedRight + 'px', 'important');
      wrap.style.setProperty('padding-left', bleedLeft + 'px', 'important');
      wrap.style.setProperty('padding-right', bleedRight + 'px', 'important');
      wrap.style.setProperty('scroll-padding-left', bleedLeft + 'px', 'important');
      wrap.style.setProperty('scroll-padding-right', bleedRight + 'px', 'important');
      wrap.style.setProperty('max-width', 'none', 'important');
      if (window.matchMedia('(max-width: 749px)').matches) {
        wrap.style.setProperty('width', '100vw', 'important');
      } else {
        var outer = inner + bleedLeft + bleedRight;
        if (outer > 0) wrap.style.setProperty('width', outer + 'px', 'important');
        else wrap.style.removeProperty('width');
      }
    } else {
      wrap.style.removeProperty('margin-left');
      wrap.style.removeProperty('margin-right');
      wrap.style.removeProperty('padding-left');
      wrap.style.removeProperty('padding-right');
      wrap.style.removeProperty('scroll-padding-left');
      wrap.style.removeProperty('scroll-padding-right');
      wrap.style.removeProperty('width');
      wrap.style.removeProperty('max-width');
    }
    wrap.style.setProperty('--wcf-variant-gap', gapPx + 'px');
    wrap.style.setProperty('--wcf-variant-thumb', sizeCss);
    wrap.style.setProperty('--pcw-variant-size', sizeCss);
    wrap.style.setProperty('display', 'flex', 'important');
    wrap.style.setProperty('flex-wrap', 'nowrap', 'important');
    wrap.style.setProperty('grid-template-columns', 'none', 'important');
    wrap.style.setProperty('gap', gapPx + 'px', 'important');
    wrap.style.setProperty('column-gap', gapPx + 'px', 'important');
    wrap.style.setProperty('row-gap', '0', 'important');
    wrap.querySelectorAll('.wcf-variant-row').forEach(function (row) {
      row.style.setProperty('flex', '0 0 ' + sizeCss, 'important');
      row.style.setProperty('width', sizeCss, 'important');
      row.style.setProperty('min-width', sizeCss, 'important');
      row.style.setProperty('max-width', sizeCss, 'important');
      row.style.setProperty('margin-left', '0', 'important');
      row.style.setProperty('margin-right', '0', 'important');
      row.style.setProperty('gap', '6px', 'important');
      var media = row.querySelector('.wcf-variant-card__media');
      if (media) {
        media.style.setProperty('width', sizeCss, 'important');
        media.style.setProperty('height', sizeCss, 'important');
        media.style.setProperty('min-width', sizeCss, 'important');
        media.style.setProperty('min-height', sizeCss, 'important');
        media.style.setProperty('max-width', sizeCss, 'important');
        media.style.setProperty('max-height', sizeCss, 'important');
        media.style.setProperty('flex-basis', sizeCss, 'important');
      }
      var qtyCol = row.querySelector('.wcf-variant-qty-col');
      if (qtyCol) {
        qtyCol.style.setProperty('width', qtyCss, 'important');
        qtyCol.style.setProperty('min-width', qtyCss, 'important');
        qtyCol.style.setProperty('max-width', qtyCss, 'important');
      }
      var qty = row.querySelector('.wcf-qty--variant');
      if (qty) {
        qty.style.setProperty('width', qtyCss, 'important');
        qty.style.setProperty('min-width', qtyCss, 'important');
        qty.style.setProperty('max-width', qtyCss, 'important');
      }
    });
  }

  function applyVariantGridLayout(wrap, count) {
    if (!wrap || count < 1) return;
    var body =
      wrap.closest('.wcf-step__body--variants-booking') || wrap.closest('.wcf-step__body--variants');
    var w = wrap.clientWidth || 0;
    var h = 0;
    if (body) {
      h = body.clientHeight || 0;
      if (!h && body.getBoundingClientRect) h = body.getBoundingClientRect().height;
      if (!w) w = body.clientWidth || 0;
      var addonEl = body.querySelector('[data-wcf-addon-card]');
      if (addonEl) {
        var addonH = addonEl.offsetHeight || 0;
        if (!addonH && addonEl.getBoundingClientRect) addonH = addonEl.getBoundingClientRect().height;
        h = Math.max(0, h - addonH - 8);
      }
    }
    if (!w && wrap.getBoundingClientRect) w = wrap.getBoundingClientRect().width;

    var root = wrap.closest('[data-popup-city-wizard]');
    var layout = variantCardLayout(root);
    var gap = layout === 'stacked' ? variantGridGapPx() : WCF_VARIANT_GRID_GAP_PX;
    var cols =
      layout === 'stacked'
        ? pickStackedGridColumns(count, w || 320, h, gap, root)
        : pickVariantGridColumns(count, w || 320, h, layout);
    var rows = Math.ceil(count / cols);
    wrap.style.setProperty('--wcf-variant-cols', String(cols));
    wrap.style.setProperty('--wcf-variant-rows', String(rows));
    wrap.setAttribute('data-wcf-cols', String(cols));
    wrap.setAttribute('data-wcf-rows', String(rows));
    wrap.classList.toggle('wcf-variants--layout-stacked', layout === 'stacked');
    wrap.classList.toggle('wcf-variants--layout-horizontal', layout === 'horizontal');

    var compact = layout === 'horizontal' && w > 0 && w < 990;
    wrap.classList.toggle('wcf-variants--compact', compact);

    if (layout === 'stacked' && w > 0) {
      var thumbPx = stackedThumbPx(cols, w, h, count, gap);
      var carousel = null;
      if (root && root.classList.contains('pcw-root--single')) {
        carousel = carouselMetrics(wrap, count);
        thumbPx = carousel.size;
      }
      wrap.style.setProperty('--wcf-variant-gap', gap + 'px');
      wrap.style.setProperty('--wcf-variant-thumb', thumbPx + 'px');
      wrap.setAttribute(
        'data-wcf-density',
        isMobileViewport() ? 'mobile' : isDesktopViewport() ? 'desktop' : 'tablet'
      );
      wrap.setAttribute('data-wcf-cols-target', String(variantGridColsCap(root, count, w)));
      wrap.classList.remove('wcf-variants--fit');
      wrap.style.removeProperty('--wcf-variant-title-size');
      wrap.style.removeProperty('--wcf-variant-price-size');
      wrap.style.removeProperty('--wcf-variant-pad');
      applySingleVariantSpacing(wrap, root, thumbPx, carousel);
    } else if (h > 0 && rows > 0 && !compact) {
      var rowH = Math.floor((h - Math.max(0, rows - 1) * gap) / rows);
      rowH = Math.max(WCF_VARIANT_ROW_MIN_H_PX, Math.min(rowH, 120));
      var titleSize = rowH < 62 ? '0.5625rem' : rowH < 78 ? '0.625rem' : '0.6875rem';
      var priceSize = rowH < 62 ? '0.6875rem' : '0.75rem';
      wrap.style.setProperty('--wcf-variant-title-size', titleSize);
      wrap.style.setProperty('--wcf-variant-price-size', priceSize);
      wrap.style.setProperty('--wcf-variant-pad', rowH < 58 ? '0.16rem' : '0.22rem');
      wrap.classList.add('wcf-variants--fit');
    } else {
      wrap.classList.remove('wcf-variants--fit');
      wrap.style.removeProperty('--wcf-variant-title-size');
      wrap.style.removeProperty('--wcf-variant-price-size');
      wrap.style.removeProperty('--wcf-variant-pad');
    }
  }

  function bindVariantGridResize(wrap) {
    if (!wrap) return;
    var scheduled = false;
    function relayout() {
      var n = wrap.querySelectorAll('.wcf-variant-row').length;
      if (!n) return;
      var root = wrap.closest('[data-popup-city-wizard]');
      if (root && root.classList.contains('pcw-root')) {
        var m = carouselMetrics(wrap, n);
        var sig = 'stepped:' + m.size + ':' + m.width + ':' + m.bleedLeft + ':' + m.bleedRight + ':' + n;
        if (wrap.__wcfLayoutSig === sig) return;
        wrap.__wcfLayoutSig = sig;
      }
      applyVariantGridLayout(wrap, n);
    }
    function scheduleRelayout() {
      if (scheduled) return;
      scheduled = true;
      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(function () {
          scheduled = false;
          relayout();
        });
      } else {
        scheduled = false;
        relayout();
      }
    }
    relayout();
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () {
        relayout();
      });
    }
    window.setTimeout(relayout, 60);
    if (typeof ResizeObserver === 'undefined') return;
    if (wrap.__wcfGridRo) wrap.__wcfGridRo.disconnect();
    var body =
      wrap.closest('.wcf-step__body--variants-booking') || wrap.closest('.wcf-step__body--variants');
    wrap.__wcfGridRo = new ResizeObserver(scheduleRelayout);
    wrap.__wcfGridRo.observe(body || wrap);
  }

  function clampQty(n, max) {
    var cap = max != null && max > 0 ? max : WCF_QTY_FALLBACK_MAX;
    n = parseInt(n, 10);
    if (isNaN(n) || n < 1) return 1;
    if (n > cap) return cap;
    return n;
  }

  /** Qty controls use class .wcf-qty — not a data-wcf-qty attribute. */
  function findQtyBoxFromControl(el) {
    if (!el) return null;
    return (
      el.closest('[data-wcf-variant-qty]') ||
      el.closest('[data-wcf-addon-qty-controls]') ||
      el.closest('.wcf-qty')
    );
  }

  function isAddonQtyBox(qtyBox) {
    return !!(
      qtyBox &&
      (qtyBox.hasAttribute('data-wcf-addon-qty-controls') || qtyBox.closest('[data-wcf-addon-qty]'))
    );
  }

  function totalVariantQty(variantQty) {
    var n = 0;
    Object.keys(variantQty || {}).forEach(function (k) {
      n += variantQty[k] || 0;
    });
    return n;
  }

  function slotBookable(slot) {
    var API = window.WorkshopCityEvents;
    if (API && typeof API.isSlotBookable === 'function') return API.isSlotBookable(slot);
    if (window.WorkshopCityFlow && window.WorkshopCityFlow.slotBookable) {
      return window.WorkshopCityFlow.slotBookable(slot);
    }
    if (!slot) return false;
    var st = String(slot.status || '').toLowerCase();
    if (st === 'sold_out' || st === 'cancelled') return false;
    var cap = slot.capacity_remaining;
    if (cap != null && cap !== '' && Number(cap) <= 0) return false;
    return true;
  }

  function readEnforceConfig(root) {
    var cfg =
      root && window.WorkshopCityConfig && window.WorkshopCityConfig.readBootstrap
        ? window.WorkshopCityConfig.readBootstrap(root)
        : {};
    return (cfg && cfg.enforce) || {};
  }

  function readGatesConfig(root) {
    var cfg =
      root && window.WorkshopCityConfig && window.WorkshopCityConfig.readBootstrap
        ? window.WorkshopCityConfig.readBootstrap(root)
        : {};
    return (cfg && cfg.gates) || {};
  }

  function maxBookableQty(state, root) {
    var slot = state && state.selectedSlot;
    var enforce = readEnforceConfig(root);
    var maxPerOrder =
      enforce.max_qty_per_order != null ? Number(enforce.max_qty_per_order) : Infinity;
    if (!Number.isFinite(maxPerOrder) || maxPerOrder <= 0) maxPerOrder = Infinity;

    var capMax = WCF_QTY_FALLBACK_MAX;
    if (slot && slot.capacity_remaining != null && slot.capacity_remaining !== '') {
      var cap = Number(slot.capacity_remaining);
      if (!isNaN(cap) && cap >= 0) capMax = Math.floor(cap);
    }

    var subtractCart = enforce.subtract_cart_seats !== false;
    var inCart = subtractCart ? state && state.cartSeatsForSelected != null ? state.cartSeatsForSelected : 0 : 0;
    var room = capMax - inCart;
    if (room < 0) room = 0;
    return Math.min(maxPerOrder, room);
  }

  function hasSelectedVariants(state) {
    return Object.keys(state.variantQty || {}).length > 0;
  }

  function vQtyKey(id) {
    return String(id);
  }

  function getVariantQty(state, id) {
    return state.variantQty[vQtyKey(id)] || 0;
  }

  function setVariantQty(state, id, qty) {
    var key = vQtyKey(id);
    if (!qty || qty <= 0) delete state.variantQty[key];
    else state.variantQty[key] = qty;
  }

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function formatSelectedDateLabel(dateKey) {
    var key = normalizeDateKey(dateKey);
    if (!key) return '';
    var p = key.split('-');
    if (p.length < 3) return key;
    var d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
    if (isNaN(d.getTime())) return key;
    try {
      return d.toLocaleDateString(undefined, {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      });
    } catch (_) {
      return key;
    }
  }

  function formatShortDateLabel(dateKey) {
    var key = normalizeDateKey(dateKey);
    if (!key) return '';
    var p = key.split('-');
    if (p.length < 3) return key;
    var d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
    if (isNaN(d.getTime())) return key;
    try {
      return d.toLocaleDateString(undefined, {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
      });
    } catch (_) {
      return key;
    }
  }

  function formatDatePillLabel(dateKey) {
    var key = normalizeDateKey(dateKey);
    if (!key) return '';
    var parts = key.split('-');
    if (parts.length < 3) return key;
    var d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    if (isNaN(d.getTime())) return key;
    try {
      return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    } catch (_) {
      return key;
    }
  }

  function formatDateTriggerLabel(dateKey) {
    var key = normalizeDateKey(dateKey);
    if (!key) return '';
    var parts = key.split('-');
    if (parts.length < 3) return key;
    var d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    if (isNaN(d.getTime())) return key;
    try {
      return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    } catch (_) {
      var mi = d.getMonth();
      return (MONTHS[mi] || '') + ' ' + d.getDate() + ', ' + d.getFullYear();
    }
  }

  function parseDateKeyMs(dateKey) {
    var key = normalizeDateKey(dateKey);
    if (!key) return NaN;
    var p = key.split('-');
    return Date.UTC(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
  }

  /** Dates with slots, ordered by distance from anchor: −1, +1, −2, +2, … */
  function nearbyDateKeysOrdered(anchorKey, dateKeys) {
    anchorKey = normalizeDateKey(anchorKey);
    if (!anchorKey) return [];
    var anchorMs = parseDateKeyMs(anchorKey);
    if (isNaN(anchorMs)) return [];
    var seen = {};
    (dateKeys || []).forEach(function (k) {
      k = normalizeDateKey(k);
      if (k && k !== anchorKey) seen[k] = true;
    });
    var others = Object.keys(seen);
    if (!others.length) return [];
    var buckets = {};
    others.forEach(function (k) {
      var diff = Math.round((parseDateKeyMs(k) - anchorMs) / 86400000);
      var ad = Math.abs(diff);
      if (!buckets[ad]) buckets[ad] = { before: [], after: [] };
      if (diff < 0) buckets[ad].before.push(k);
      else if (diff > 0) buckets[ad].after.push(k);
    });
    var out = [];
    Object.keys(buckets)
      .map(function (x) {
        return parseInt(x, 10);
      })
      .sort(function (a, b) {
        return a - b;
      })
      .forEach(function (dist) {
        buckets[dist].before.sort();
        buckets[dist].after.sort();
        buckets[dist].before.forEach(function (k) {
          out.push(k);
        });
        buckets[dist].after.forEach(function (k) {
          out.push(k);
        });
      });
    return out;
  }

  function collectSlotDateKeys(slots) {
    var map = {};
    (slots || []).forEach(function (s) {
      var dk = slotDateKey(s);
      if (dk) map[dk] = true;
    });
    return Object.keys(map);
  }

  function parseTimeLabel(label) {
    var s = String(label || '').trim();
    var m = s.match(/^(\d{1,2}(?::\d{2})?)\s*(a\.?m\.?|p\.?m\.?)?$/i);
    if (m) {
      var period = String(m[2] || '')
        .replace(/\./g, '')
        .toUpperCase();
      if (period === 'AM' || period === 'PM') return { when: m[1], period: period };
      return { when: m[1], period: '' };
    }
    return { when: s, period: '' };
  }

  var WCF_CLOCK_SVG =
    '<svg class="wcf-time__clock-svg" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<circle cx="10" cy="10" r="8.25" stroke="currentColor" stroke-width="1.35"/>' +
    '<path d="M10 5.5V10l3 2" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';
  var WCF_SOLD_OUT_SVG =
    '<svg class="wcf-cal-time__soldout-svg" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<circle cx="7" cy="7" r="5.75" stroke="currentColor" stroke-width="1.3"/>' +
    '<path d="M4.2 9.8 9.8 4.2" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>' +
    '</svg>';

  function buildTimeSlotHtml(label, bookable, slot) {
    var parts = parseTimeLabel(label);
    var cap = slot && slot.capacity_remaining;
    var spots =
      bookable && cap != null && cap !== '' && Number(cap) > 0
        ? '<span class="wcf-time__spots">' + escapeHtml(String(Number(cap))) + ' places left</span>'
        : '';
    var statusText = bookable ? 'Available' : 'Sold out';
    var statusClass = bookable ? 'wcf-time__pill--open' : 'wcf-time__pill--closed';
    return (
      '<span class="wcf-time__clock">' +
      WCF_CLOCK_SVG +
      '</span>' +
      '<span class="wcf-time__main">' +
      '<span class="wcf-time__when-row">' +
      '<span class="wcf-time__when">' +
      escapeHtml(parts.when) +
      '</span>' +
      (parts.period
        ? '<span class="wcf-time__period">' + escapeHtml(parts.period) + '</span>'
        : '') +
      '</span>' +
      spots +
      '</span>' +
      '<span class="wcf-time__aside">' +
      '<span class="wcf-time__pill ' +
      statusClass +
      '">' +
      statusText +
      '</span>' +
      (!bookable ? '<span class="wcf-time__hint">Join waitlist</span>' : '') +
      '</span>' +
      '<span class="wcf-time__tick" aria-hidden="true"></span>'
    );
  }

  function qtyControlHtml(extraAttrs, value) {
    return (
      '<div class="wcf-qty"' +
      (extraAttrs ? ' ' + extraAttrs : '') +
      '>' +
      '<button type="button" class="wcf-qty__btn" data-wcf-qty-dec aria-label="Decrease quantity">−</button>' +
      '<input type="number" class="wcf-qty__input" min="1" max="' +
      WCF_QTY_FALLBACK_MAX +
      '" value="' +
      value +
      '" aria-label="Quantity" inputmode="numeric">' +
      '<button type="button" class="wcf-qty__btn" data-wcf-qty-inc aria-label="Increase quantity">+</button>' +
      '</div>'
    );
  }

  function variantQtyControlHtml(variantId, qty) {
    var q = qty || 0;
    var id = vQtyKey(variantId);
    var mode = q > 0 ? 'step' : 'add';
    return (
      '<div class="wcf-qty wcf-qty--variant" data-wcf-variant-qty data-variant-id="' +
      id +
      '" data-qty-mode="' +
      mode +
      '">' +
      '<button type="button" class="wcf-qty__add" data-wcf-qty-add>Add</button>' +
      '<div class="wcf-qty__stepper">' +
      '<button type="button" class="wcf-qty__btn" data-wcf-qty-dec aria-label="Decrease quantity">−</button>' +
      '<span class="wcf-qty__val" data-wcf-qty-val aria-live="polite">' +
      q +
      '</span>' +
      '<button type="button" class="wcf-qty__btn" data-wcf-qty-inc aria-label="Increase quantity">+</button>' +
      '</div>' +
      '</div>'
    );
  }

  function getWorkshopCityDataEl(root) {
    if (!root) return null;
    var sid = root.getAttribute('data-section-id');
    var el = sid ? document.getElementById('WorkshopCityData-' + sid) : null;
    if (!el) el = root.querySelector('script[id^="WorkshopCityData-"]');
    if (!el) {
      var sectionRoot = sid ? document.getElementById('shopify-section-' + sid) : null;
      if (sectionRoot) el = sectionRoot.querySelector('script[id^="WorkshopCityData-"]');
    }
    return el;
  }

  function normalizeOptionsArray(opts) {
    if (!opts || !opts.length) return [];
    return opts
      .map(function (o) {
        if (o == null) return '';
        if (typeof o === 'string') return o;
        if (typeof o === 'object' && o.name) return String(o.name);
        return String(o);
      })
      .filter(function (s) {
        return String(s).trim() !== '';
      });
  }

  function normalizeVariantList(list) {
    if (!Array.isArray(list)) return [];
    return list
      .map(function (v) {
        if (!v || v.id == null) return null;
        var opts = normalizeOptionsArray(v.options);
        if (!opts.length) {
          opts = [v.option1, v.option2, v.option3].filter(function (x) {
            return x != null && String(x).trim() !== '';
          });
        }
        v.options = opts;
        if (!v.option1 && opts[0]) v.option1 = opts[0];
        if (!v.option2 && opts[1]) v.option2 = opts[1];
        if (!v.option3 && opts[2]) v.option3 = opts[2];
        if (v.price == null || v.price === '') v.price = 0;
        if (v.compare_at_price == null || v.compare_at_price === '') v.compare_at_price = 0;
        return v;
      })
      .filter(Boolean);
  }

  function normalizeUrl(url) {
    var u = String(url || '').trim();
    if (!u) return '';
    if (u.indexOf('//') === 0) return 'https:' + u;
    return u;
  }

  function variantThumbUrl(url, width) {
    width = width || 200;
    var u = normalizeUrl(url);
    if (!u) return '';
    if (u.indexOf('cdn.shopify.com') < 0 && u.indexOf('/cdn/shop/') < 0) return u;
    try {
      var parsed = new URL(u, window.location.href);
      parsed.searchParams.set('width', String(width));
      parsed.searchParams.delete('height');
      return parsed.toString();
    } catch (_) {
      var base = u.replace(/([?&])(width|height|crop_center|crop)=[^&]*/gi, '$1').replace(/[?&]$/, '');
      var sep = base.indexOf('?') >= 0 ? '&' : '?';
      return base + sep + 'width=' + width;
    }
  }

  function thumbImgSrc(img, maxW) {
    maxW = maxW || 220;
    if (!img) return '';
    var srcset = img.getAttribute('srcset');
    if (srcset) {
      var entries = [];
      srcset.split(',').forEach(function (part) {
        var bits = part.trim().split(/\s+/);
        var url = bits[0];
        var w = parseInt(bits[1], 10) || 0;
        if (url) entries.push({ url: url, w: w });
      });
      entries.sort(function (a, b) {
        return a.w - b.w;
      });
      var pick = entries[0];
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].w >= maxW) {
          pick = entries[i];
          break;
        }
        pick = entries[i];
      }
      if (pick && pick.url) return variantThumbUrl(pick.url, maxW);
    }
    return variantThumbUrl(img.src || img.getAttribute('data-src') || '', maxW);
  }

  function isUsableImageUrl(url) {
    var u = normalizeUrl(url);
    if (!u) return false;
    if (u.indexOf('undefined') !== -1 || u.indexOf('null') !== -1) return false;
    return u.indexOf('http') === 0;
  }

  function bestImgSrc(img) {
    if (!img) return '';
    if (img.currentSrc) return normalizeUrl(img.currentSrc);
    var srcset = img.getAttribute('srcset');
    if (srcset) {
      var best = '';
      var bestW = 0;
      srcset.split(',').forEach(function (part) {
        var bits = part.trim().split(/\s+/);
        var url = bits[0];
        var w = parseInt(bits[1], 10) || 0;
        if (url && w >= bestW) {
          bestW = w;
          best = url;
        }
      });
      if (best) return normalizeUrl(best);
    }
    return normalizeUrl(img.src || img.getAttribute('data-src') || '');
  }

  function variantJsonImageUrl(v) {
    if (!v) return '';
    if (v.featured_image && v.featured_image.src) return normalizeUrl(v.featured_image.src);
    if (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) {
      return normalizeUrl(v.featured_media.preview_image.src);
    }
    if (v.image && v.image.src) return normalizeUrl(v.image.src);
    if (typeof v.image === 'string') return normalizeUrl(v.image);
    return '';
  }

  function buildMediaUrlIndex(sectionRoot, sectionId) {
    var index = {};
    if (!sectionRoot) return index;
    sectionRoot.querySelectorAll('[data-media-id] img, [data-media-id] picture img').forEach(function (img) {
      var wrap = img.closest('[data-media-id]');
      if (!wrap) return;
      var key = wrap.getAttribute('data-media-id');
      var src = thumbImgSrc(img, 240);
      if (!key || !src) return;
      index[key] = src;
      var bare = String(key).split('-').pop();
      if (bare) index[bare] = index[bare] || src;
      if (sectionId && String(key).indexOf(sectionId + '-') === 0) {
        index[String(key).slice(String(sectionId).length + 1)] = index[String(key).slice(String(sectionId).length + 1)] || src;
      }
    });
    return index;
  }

  function buildStyleImageMapFromScripts(sectionRoot, styleIdx) {
    var map = {};
    if (!sectionRoot) return map;
    var picker = sectionRoot.querySelector('.variant-selects-main') || sectionRoot;
    picker.querySelectorAll('script[data-option-value-id]').forEach(function (sc) {
      try {
        var v = JSON.parse(sc.textContent);
        var url = variantJsonImageUrl(v);
        if (!url) return;
        var key = normalizeOptionValue(styleValueFromVariant(v, styleIdx));
        if (key && !map[key]) map[key] = variantThumbUrl(url, 200);
      } catch (_) {}
    });
    picker.querySelectorAll('label.color-watches').forEach(function (lab) {
      var inputId = lab.getAttribute('for');
      var input = inputId ? document.getElementById(inputId) : null;
      if (!input || !input.value) return;
      var key = normalizeOptionValue(input.value);
      if (!key || map[key]) return;
      var bg = window.getComputedStyle(lab, ':before').backgroundImage || window.getComputedStyle(lab).backgroundImage;
      var m = String(bg).match(/url\(["']?([^"')]+)["']?\)/);
      if (m && m[1]) map[key] = variantThumbUrl(m[1], 200);
      var img = lab.querySelector('img');
      if (img && !map[key]) map[key] = thumbImgSrc(img, 200);
    });
    return map;
  }

  function scrapeVariantCatalogFromDom(sectionRoot) {
    var byId = {};
    if (!sectionRoot) return [];
    sectionRoot.querySelectorAll('script[data-option-value-id]').forEach(function (sc) {
      try {
        var v = JSON.parse(sc.textContent);
        if (v && v.id != null) byId[v.id] = v;
      } catch (_) {}
    });
    return Object.keys(byId).map(function (id) {
      return byId[id];
    });
  }

  function scrapeVariantPricesFromDom(sectionRoot) {
    var map = {};
    if (!sectionRoot) return map;
    sectionRoot.querySelectorAll('script[data-option-value-id]').forEach(function (sc) {
      try {
        var v = JSON.parse(sc.textContent);
        if (v && v.id != null) {
          map[v.id] = {
            price: v.price != null ? Number(v.price) : 0,
            compare_at_price: v.compare_at_price != null ? Number(v.compare_at_price) : 0,
          };
        }
      } catch (_) {}
    });
    var jsonEl = sectionRoot.querySelector('[data-product-variants-json]');
    if (jsonEl && jsonEl.textContent) {
      try {
        var rows = JSON.parse(jsonEl.textContent);
        (Array.isArray(rows) ? rows : []).forEach(function (row) {
          if (!row || row.id == null) return;
          var existing = map[row.id] || {};
          map[row.id] = {
            price:
              row.price != null
                ? Number(row.price)
                : existing.price != null
                  ? existing.price
                  : 0,
            compare_at_price:
              row.compare_at_price != null
                ? Number(row.compare_at_price)
                : existing.compare_at_price != null
                  ? existing.compare_at_price
                  : 0,
          };
        });
      } catch (_) {}
    }
    return map;
  }

  function resolveVariantImageUrl(v, sectionRoot, data, mediaIndex, styleImages) {
    if (!v) return '';
    if (isUsableImageUrl(v.image_url)) return variantThumbUrl(v.image_url, 200);
    var styleIdx =
      data && data.styleOptionIndex != null
        ? Number(data.styleOptionIndex)
        : pickStyleOptionIndex(sectionRoot, [v]);
    var styleKey = normalizeOptionValue(styleValueFromVariant(v, styleIdx) || v.label || v.title);
    if (styleKey && styleImages && styleImages[styleKey]) return styleImages[styleKey];
    var fromJson = variantJsonImageUrl(v);
    if (isUsableImageUrl(fromJson)) return variantThumbUrl(fromJson, 200);
    if (v.featured_media_id && sectionRoot && data) {
      var sid = data.sectionId || '';
      mediaIndex = mediaIndex || buildMediaUrlIndex(sectionRoot, sid);
      var url =
        mediaIndex[sid + '-' + v.featured_media_id] ||
        mediaIndex[String(v.featured_media_id)];
      if (isUsableImageUrl(url)) return variantThumbUrl(url, 200);
    }
    return '';
  }

  function enrichVariantsForWizard(variants, root, data) {
    var sectionRoot = getSectionRoot(root, data);
    if (!sectionRoot || !variants.length) return variants;
    var sid = data.sectionId || '';
    var styleIdx =
      data.styleOptionIndex != null ? Number(data.styleOptionIndex) : pickStyleOptionIndex(sectionRoot, variants);
    var mediaIndex = buildMediaUrlIndex(sectionRoot, sid);
    var styleImages = buildStyleImageMapFromScripts(sectionRoot, styleIdx);
    var prices = scrapeVariantPricesFromDom(sectionRoot);

    variants.forEach(function (v) {
      var key = normalizeOptionValue(styleValueFromVariant(v, styleIdx) || v.label || v.title);
      var url = resolveVariantImageUrl(v, sectionRoot, data, mediaIndex, styleImages);
      if (url) {
        if (key) styleImages[key] = styleImages[key] || url;
        v.image_url = url;
      }
      var scraped = prices[v.id];
      if (scraped) {
        if ((!v.price || Number(v.price) === 0) && scraped.price != null) {
          v.price = scraped.price;
        }
        if (scraped.compare_at_price != null && Number(scraped.compare_at_price) > 0) {
          v.compare_at_price = scraped.compare_at_price;
        }
      }
    });

    root.__wcfStyleImages = styleImages;
    root.__wcfMediaIndex = mediaIndex;
    return variants;
  }

  function loadVariantsFromProductJson(root, data) {
    var sectionRoot = getSectionRoot(root, data);
    if (!sectionRoot) return [];
    var jsonEl = sectionRoot.querySelector('[data-product-variants-json]');
    if (!jsonEl || !jsonEl.textContent) return [];
    try {
      var rows = JSON.parse(jsonEl.textContent);
      var prices = scrapeVariantPricesFromDom(sectionRoot);
      return (Array.isArray(rows) ? rows : []).map(function (row) {
        if (!row || row.id == null) return null;
        var opts = normalizeOptionsArray(row.options);
        var scraped = prices[row.id];
        var price = row.price != null ? Number(row.price) : 0;
        var compare = row.compare_at_price != null ? Number(row.compare_at_price) : 0;
        if (scraped) {
          if ((!price || price === 0) && scraped.price != null) price = Number(scraped.price) || 0;
          if ((!compare || compare === 0) && scraped.compare_at_price) {
            compare = Number(scraped.compare_at_price) || 0;
          }
        }
        return {
          id: row.id,
          title: row.title || '',
          price: price,
          compare_at_price: compare,
          available: row.available !== false,
          option1: opts[0] || null,
          option2: opts[1] || null,
          option3: opts[2] || null,
          options: opts,
          featured_media_id: row.featured_media_id,
          image_url: row.image_url || '',
        };
      }).filter(Boolean);
    } catch (e) {
      console.warn('[popup-city-wizard] product variants JSON parse failed', e);
      return [];
    }
  }

  function stylesToVariantList(styles) {
    return normalizeVariantList(
      (Array.isArray(styles) ? styles : []).map(function (s) {
        if (!s) return null;
        return {
          id: s.id,
          title: s.label || s.title || '',
          label: s.label || s.title || '',
          price: s.price,
          compare_at_price: s.compare_at_price,
          available: s.available !== false,
          option1: s.option1,
          option2: s.option2,
          option3: s.option3,
          options: s.options,
          featured_media_id: s.featured_media_id,
          image_url: s.image_url || '',
        };
      }).filter(Boolean)
    );
  }

  function loadProductVariants(root, data) {
    var list = [];
    var el = getWorkshopCityDataEl(root);
    if (el && el.textContent) {
      try {
        var parsed = JSON.parse(el.textContent);
        if (parsed.styleOptionIndex != null) data.styleOptionIndex = parsed.styleOptionIndex;
        if (Array.isArray(parsed.styles) && parsed.styles.length) {
          list = stylesToVariantList(parsed.styles);
        } else {
          list = normalizeVariantList(parsed.variants || []);
        }
      } catch (e) {
        console.warn('[popup-city-wizard] WorkshopCityData parse failed — using DOM fallback', e, {
          sectionId: root.getAttribute('data-section-id'),
        });
      }
    } else {
      console.warn('[popup-city-wizard] WorkshopCityData script not found', {
        sectionId: root.getAttribute('data-section-id'),
      });
    }
    if (!list.length) list = loadVariantsFromProductJson(root, data);
    list = mergeVariantMetaFromDom(list, root, data);
    list = enrichVariantsForWizard(list, root, data);
    root.__wcfVariantCatalog = scrapeVariantCatalogFromDom(getSectionRoot(root, data));
    return list;
  }

  function parseData(root) {
    var sid = root.getAttribute('data-section-id');
    var el = getWorkshopCityDataEl(root);
    if (el && el.textContent) {
      try {
        var parsed = JSON.parse(el.textContent);
        parsed.variants = normalizeVariantList(parsed.variants || []);
        return parsed;
      } catch (e) {
        console.warn('[popup-city-wizard] bad WorkshopCityData JSON', e, { sectionId: sid });
      }
    } else if (sid) {
      console.warn('[popup-city-wizard] missing WorkshopCityData-' + sid);
    }
    var handle = root.getAttribute('data-product-handle') || '';
    var pid = root.getAttribute('data-product-id');
    if (!handle && !pid) return null;
    return {
      sectionId: sid || '',
      productFormId: 'product-form-' + (sid || ''),
      productId: pid ? parseInt(pid, 10) : null,
      productHandle: handle,
      variants: [],
      slots: [],
    };
  }

  function getSectionRoot(root, data) {
    var sid = (data && data.sectionId) || (root && root.getAttribute('data-section-id')) || '';
    var sectionRoot = sid ? document.getElementById('shopify-section-' + sid) : null;
    if (!sectionRoot && root && root.closest) {
      sectionRoot = root.closest('[id^="shopify-section-"]');
    }
    return sectionRoot;
  }

  function variantImageUrl(v, root, data) {
    if (!v) return '';
    if (isUsableImageUrl(v.image_url)) return variantThumbUrl(v.image_url, 200);
    var sectionRoot = root && data ? getSectionRoot(root, data) : null;
    var styleImages = (root && root.__wcfStyleImages) || {};
    var mediaIndex = (root && root.__wcfMediaIndex) || buildMediaUrlIndex(sectionRoot, data && data.sectionId);
    return resolveVariantImageUrl(v, sectionRoot, data, mediaIndex, styleImages);
  }

  /** Lightbox / zoom: full-size CDN URL (cards keep 200px thumbs). */
  function variantLightboxImageUrl(v, root, data) {
    if (!v) return '';
    var raw =
      variantJsonImageUrl(v) ||
      (isUsableImageUrl(v.image_url) ? v.image_url : '') ||
      variantImageUrl(v, root, data) ||
      '';
    if (!raw) return '';
    return variantThumbUrl(raw, 1600);
  }

  function normalizeOptionValue(val) {
    return String(val || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }

  function primaryStyleOptionIndex(sectionRoot) {
    if (!sectionRoot) return 0;
    var optEl = sectionRoot.querySelector('[data-product-options-json]');
    if (!optEl || !optEl.textContent) return 0;
    try {
      var opts = JSON.parse(optEl.textContent);
      if (!Array.isArray(opts)) return 0;
      for (var i = 0; i < opts.length; i++) {
        var n = String(opts[i] || '').toLowerCase();
        if (n.indexOf('date') === -1 && n.indexOf('time') === -1 && n.indexOf('session') === -1) {
          return i;
        }
      }
    } catch (_) {}
    return 0;
  }

  function pickStyleOptionIndex(sectionRoot, variants) {
    if (!variants || !variants.length) return 0;
    var optNames = [];
    if (sectionRoot) {
      var optEl = sectionRoot.querySelector('[data-product-options-json]');
      if (optEl && optEl.textContent) {
        try {
          optNames = JSON.parse(optEl.textContent) || [];
        } catch (_) {}
      }
    }
    var limit = Math.max(optNames.length, 3);
    var best = -1;
    var bestScore = 0;
    for (var i = 0; i < limit; i++) {
      var name = String(optNames[i] || '').toLowerCase();
      if (name.indexOf('date') !== -1 || name.indexOf('time') !== -1 || name.indexOf('session') !== -1) {
        continue;
      }
      var uniq = {};
      variants.forEach(function (v) {
        var k = normalizeOptionValue(styleValueFromVariant(v, i));
        if (k) uniq[k] = 1;
      });
      var n = Object.keys(uniq).length;
      if (n > bestScore) {
        bestScore = n;
        best = i;
      }
    }
    if (best >= 0 && bestScore > 0) return best;
    return primaryStyleOptionIndex(sectionRoot);
  }

  function styleValueFromVariant(v, styleIdx) {
    if (!v) return '';
    if (v.options && v.options[styleIdx] != null && String(v.options[styleIdx]).trim() !== '') {
      return String(v.options[styleIdx]);
    }
    if (styleIdx === 0) return v.option1 || '';
    if (styleIdx === 1) return v.option2 || '';
    return v.option3 || '';
  }

  function variantsForStylePicker(variants, sectionRoot) {
    if (!variants.length) return [];
    var styleIdx = pickStyleOptionIndex(sectionRoot, variants);
    var seen = {};
    var out = [];
    variants.forEach(function (v) {
      var key = normalizeOptionValue(styleValueFromVariant(v, styleIdx));
      if (!key) key = 'id-' + String(v.id);
      if (seen[key]) return;
      seen[key] = true;
      out.push(v);
    });
    return out.length ? out : variants;
  }

  function variantCardImageFromPicker(sectionRoot, styleValue) {
    if (!sectionRoot || !styleValue) return '';
    var want = normalizeOptionValue(styleValue);
    var picker = sectionRoot.querySelector('.variant-selects-main');
    if (!picker) return '';
    var radios = picker.querySelectorAll('input.input-radio[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (normalizeOptionValue(radios[i].value) !== want) continue;
      var lab = radios[i].id ? document.querySelector('label[for="' + radios[i].id + '"]') : null;
      if (lab) {
        var img = lab.querySelector('img');
        if (img && (img.currentSrc || img.src)) return img.currentSrc || img.src;
      }
    }
    return '';
  }

  function getVariantCatalog(root, data, displayVariants) {
    var cat = root && root.__wcfVariantCatalog;
    if (cat && cat.length) return cat;
    var scraped = scrapeVariantCatalogFromDom(getSectionRoot(root, data));
    if (scraped.length) return scraped;
    return displayVariants || [];
  }

  function resolveVariantForSlot(styleVariant, slot, allVariants, sectionRoot, root, data) {
    var catalog = getVariantCatalog(root, data, allVariants);
    if (!styleVariant || !slot || !catalog.length) return styleVariant ? styleVariant.id : null;
    var styleIdx =
      data && data.styleOptionIndex != null
        ? Number(data.styleOptionIndex)
        : pickStyleOptionIndex(sectionRoot, catalog);
    var styleKey = normalizeOptionValue(styleValueFromVariant(styleVariant, styleIdx));
    var dateKey = normalizeDateKey(slot.date_key);
    var timeKey = normalizeOptionValue(slot.time_label);
    var dateOpts = sectionRoot ? sectionRoot.querySelectorAll('[data-option-name*="date"]') : [];
    var timeOpts = sectionRoot ? sectionRoot.querySelectorAll('[data-option-name*="time"]') : [];
    var hasDateOpt = dateOpts.length > 0;
    var hasTimeOpt = timeOpts.length > 0;
    if (!hasDateOpt && !hasTimeOpt) return styleVariant.id;

    for (var i = 0; i < catalog.length; i++) {
      var v = catalog[i];
      if (normalizeOptionValue(styleValueFromVariant(v, styleIdx)) !== styleKey) continue;
      var opts = v.options || [v.option1, v.option2, v.option3];
      var dateOk = !hasDateOpt;
      var timeOk = !hasTimeOpt;
      opts.forEach(function (o) {
        if (o == null || String(o).trim() === '') return;
        var n = normalizeOptionValue(o);
        if (dateKey && (n === dateKey || n.indexOf(dateKey) !== -1 || dateKey.indexOf(n) !== -1)) {
          dateOk = true;
        }
        if (timeKey && (n === timeKey || n.indexOf(timeKey) !== -1 || timeKey.indexOf(n) !== -1)) {
          timeOk = true;
        }
      });
      if (dateOk && timeOk) return v.id;
    }
    return styleVariant.id;
  }

  function triggerAlpineVariantUpdate(sectionRoot, inputEl) {
    if (!sectionRoot || !inputEl || !window.Alpine) return;
    var picker = sectionRoot.querySelector('.variant-selects-main.x-variant-picker');
    if (!picker) return;
    try {
      var alpineData = window.Alpine.$data(picker);
      if (alpineData && typeof alpineData.updateVariantSelector === 'function') {
        var url = inputEl.dataset && inputEl.dataset.productUrl ? inputEl.dataset.productUrl : picker.getAttribute('data-product-url') || '';
        alpineData.updateVariantSelector(inputEl.id, url);
      }
    } catch (_) {}
  }

  function mergeVariantMetaFromDom(variants, root, data) {
    var sectionRoot = getSectionRoot(root, data);
    if (!sectionRoot || !variants.length) return variants;
    var jsonEl = sectionRoot.querySelector('[data-product-variants-json]');
    if (!jsonEl || !jsonEl.textContent) return variants;
    try {
      var list = JSON.parse(jsonEl.textContent);
      var byId = {};
      (Array.isArray(list) ? list : []).forEach(function (row) {
        if (row && row.id != null) byId[row.id] = row;
      });
      return variants.map(function (v) {
        var row = byId[v.id];
        if (!row) return v;
        if (row.featured_media_id != null) v.featured_media_id = row.featured_media_id;
        if (!isUsableImageUrl(v.image_url) && row.featured_media_id) {
          var sid = data.sectionId || '';
          var slide = sectionRoot.querySelector('[data-media-id="' + sid + '-' + row.featured_media_id + '"] img');
          if (slide) v.image_url = thumbImgSrc(slide, 200);
        }
        return v;
      });
    } catch (_) {
      return variants;
    }
  }

  function ensureVariantMediaMeta(variant, sectionRoot, root) {
    if (!variant) return variant;
    if (variant.featured_media_id) return variant;
    var catalog =
      (root && root.__wcfVariantCatalog) || scrapeVariantCatalogFromDom(sectionRoot);
    for (var i = 0; i < catalog.length; i++) {
      var row = catalog[i];
      if (row && String(row.id) === String(variant.id)) {
        if (row.featured_media && row.featured_media.id != null) {
          variant.featured_media_id = row.featured_media.id;
        } else if (row.featured_media_id != null) {
          variant.featured_media_id = row.featured_media_id;
        }
        break;
      }
    }
    return variant;
  }

  function forceAlpineVariantMedia(sectionRoot, sectionId) {
    if (!sectionRoot || !window.Alpine) return;
    var picker = sectionRoot.querySelector('.variant-selects-main.x-variant-picker');
    if (!picker) return;
    try {
      var alpineData = window.Alpine.$data(picker);
      if (!alpineData) return;
      if (typeof alpineData._goToSelectedVariantMedia === 'function') {
        alpineData._goToSelectedVariantMedia();
      } else if (typeof alpineData.updateMultiMediaWithVariant === 'function') {
        alpineData.updateMultiMediaWithVariant();
      } else if (typeof alpineData._updateMedia === 'function') {
        alpineData._updateMedia();
      }
    } catch (_) {}
  }

  function extractMediaIdFromThumb(thumb, sectionId) {
    if (!thumb) return '';
    var sid = String(sectionId || '');
    var idAttr = thumb.getAttribute('data-thumbnail-id') || thumb.getAttribute('data-target') || '';
    if (idAttr) return String(idAttr);
    var className = String(thumb.className || '');
    var m = className.match(new RegExp('x-thumbnail-' + sid.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '-(\\d+)'));
    if (m && m[1]) return m[1];
    var elId = String(thumb.id || '');
    if (sid && elId.indexOf('x-thumbnail-' + sid + '-') === 0) {
      return elId.slice(('x-thumbnail-' + sid + '-').length);
    }
    return '';
  }

  function extractMediaIdFromSlide(slide, sectionId) {
    if (!slide) return '';
    var sid = String(sectionId || '');
    var mediaOption = slide.getAttribute('data-media-option') || slide.getAttribute('data-media-id') || '';
    if (mediaOption && sid && mediaOption.indexOf(sid + '-') === 0) {
      return mediaOption.slice((sid + '-').length);
    }
    if (mediaOption && mediaOption.indexOf('-') === -1) return mediaOption;
    var className = String(slide.className || '');
    var m = className.match(new RegExp('(\\d+)-' + sid.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b'));
    if (m && m[1]) return m[1];
    return '';
  }

  function syncPdpThumbnailsActive(sectionRoot, sectionId, mediaId) {
    if (!sectionRoot) return;
    var sid = String(sectionId || '');
    var thumbs = sectionRoot.querySelectorAll('.x-thumbnail.media-thumbnail, .media-thumbnail.x-thumbnail');
    if (!thumbs.length) {
      thumbs = sectionRoot.querySelectorAll('.x-thumbnail');
    }
    if (!thumbs.length) return;

    var activeId = mediaId ? String(mediaId) : '';
    if (!activeId) {
      var splideEl = document.getElementById('x-product-' + sid);
      if (splideEl && splideEl.splide && typeof splideEl.splide.index === 'number') {
        var slides = splideEl.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
        var slide = slides[splideEl.splide.index];
        activeId = extractMediaIdFromSlide(slide, sid);
      }
    }
    if (!activeId) {
      var activeSlide =
        sectionRoot.querySelector('.splide__slide.is-active:not(.splide__slide--clone)') ||
        sectionRoot.querySelector('[data-media-option].media_active') ||
        sectionRoot.querySelector('[data-media-id].media_active');
      activeId = extractMediaIdFromSlide(activeSlide, sid);
    }

    thumbs.forEach(function (thumb) {
      var tid = extractMediaIdFromThumb(thumb, sid);
      var on = !!(activeId && tid && tid === activeId);
      thumb.classList.toggle('is-active', on);
      thumb.classList.remove('opacity-30');
      thumb.style.opacity = '';
    });
  }

  function bindPdpThumbnailSync(sectionRoot, sectionId) {
    if (!sectionRoot || sectionRoot.__pcwThumbSyncBound) return;
    sectionRoot.__pcwThumbSyncBound = true;
    var sid = String(sectionId || '');

    function fromSplide() {
      syncPdpThumbnailsActive(sectionRoot, sid, '');
    }

    function attach() {
      var splideEl = document.getElementById('x-product-' + sid);
      if (!splideEl || !splideEl.splide || splideEl.__pcwThumbSyncSplide) return;
      splideEl.__pcwThumbSyncSplide = true;
      splideEl.splide.on('mounted move moved active', fromSplide);
      fromSplide();
    }

    attach();
    window.setTimeout(attach, 400);
    window.setTimeout(attach, 1200);
    document.addEventListener('eurus:media-gallery-ready:' + sid, function () {
      window.setTimeout(attach, 50);
      window.setTimeout(fromSplide, 120);
    });

    sectionRoot.addEventListener(
      'click',
      function (e) {
        var thumb = e.target.closest && e.target.closest('.x-thumbnail, .media-thumbnail');
        if (!thumb || !sectionRoot.contains(thumb)) return;
        window.setTimeout(function () {
          var mid = extractMediaIdFromThumb(thumb, sid);
          syncPdpThumbnailsActive(sectionRoot, sid, mid);
        }, 30);
      },
      true
    );
  }

  function goToVariantMedia(sectionRoot, sectionId, variant) {
    if (!sectionRoot || !variant) return;
    variant = ensureVariantMediaMeta(variant, sectionRoot, null);
    var mediaId = variant.featured_media_id;
    if (!mediaId) return;

    var mediaIdStr = String(mediaId);
    var fullKey = sectionId + '-' + mediaId;
    var didNavigate = false;

    bindPdpThumbnailSync(sectionRoot, sectionId);

    var thumb =
      sectionRoot.querySelector('.x-thumbnail-' + fullKey) ||
      sectionRoot.querySelector('[data-target="' + mediaIdStr + '"]') ||
      sectionRoot.querySelector('[data-thumbnail-id="' + mediaIdStr + '"]');
    if (thumb && thumb.click) {
      thumb.click();
      didNavigate = true;
    }

    var slides = sectionRoot.getElementsByClassName(mediaIdStr + '-' + sectionId);
    var splideEl = document.getElementById('x-product-' + sectionId);
    if (slides.length && splideEl && splideEl.splide) {
      var index = parseInt(slides[0].getAttribute('index'), 10);
      if (!isNaN(index)) {
        splideEl.splide.go(index);
        didNavigate = true;
      }
    }

    var mediaEl =
      sectionRoot.querySelector('[data-media-id="' + fullKey + '"]') ||
      sectionRoot.querySelector('[data-media-option="' + fullKey + '"]') ||
      document.getElementById('postion-image-' + fullKey);
    if (mediaEl) {
      var clickTarget = mediaEl.querySelector('button, a, [role="button"]') || mediaEl;
      if (clickTarget.click) {
        clickTarget.click();
        didNavigate = true;
      }
      mediaEl.classList.add('is-active', 'active', 'media_active');
      mediaEl.removeAttribute('aria-hidden');
    }

    if (!didNavigate) {
      forceAlpineVariantMedia(sectionRoot, sectionId);
    }

    syncPdpThumbnailsActive(sectionRoot, sectionId, mediaIdStr);
    window.setTimeout(function () {
      syncPdpThumbnailsActive(sectionRoot, sectionId, mediaIdStr);
    }, 80);
    window.setTimeout(function () {
      syncPdpThumbnailsActive(sectionRoot, sectionId, mediaIdStr);
    }, 360);
  }

  function syncVariantToPdp(root, data, variant) {
    if (!variant || !variant.id) return;
    var sectionRoot = getSectionRoot(root, data);
    if (!sectionRoot) return;
    variant = ensureVariantMediaMeta(variant, sectionRoot, root);
    var sectionId = (data && data.sectionId) || root.getAttribute('data-section-id') || '';
    var picker = sectionRoot.querySelector('.variant-selects-main.x-variant-picker');
    var styleIdx = primaryStyleOptionIndex(sectionRoot);
    var styleVal = styleValueFromVariant(variant, styleIdx);
    var styleInput = null;

    function finishMediaSync() {
      goToVariantMedia(sectionRoot, sectionId, variant);
      window.setTimeout(function () {
        forceAlpineVariantMedia(sectionRoot, sectionId);
        goToVariantMedia(sectionRoot, sectionId, variant);
        syncPdpThumbnailsActive(
          sectionRoot,
          sectionId,
          variant.featured_media_id ? String(variant.featured_media_id) : ''
        );
      }, 320);
      window.setTimeout(function () {
        syncPdpThumbnailsActive(
          sectionRoot,
          sectionId,
          variant.featured_media_id ? String(variant.featured_media_id) : ''
        );
      }, 700);
    }

    if (picker && styleVal) {
      var groups = picker.querySelectorAll('[data-option-name][data-option-index]');
      var styleGroup = null;
      for (var g = 0; g < groups.length; g++) {
        if (String(groups[g].getAttribute('data-option-index')) === String(styleIdx)) {
          styleGroup = groups[g];
          break;
        }
      }
      if (!styleGroup && groups.length) styleGroup = groups[styleIdx] || groups[0];
      if (styleGroup) {
        var want = normalizeOptionValue(styleVal);
        var radios = styleGroup.querySelectorAll('input.input-radio[type="radio"]');
        radios.forEach(function (radio) {
          if (normalizeOptionValue(radio.value) === want) {
            styleInput = radio;
          }
        });
        if (styleInput) {
          radios.forEach(function (radio) {
            radio.checked = radio === styleInput;
          });
          styleInput.dispatchEvent(new Event('change', { bubbles: true }));
          triggerAlpineVariantUpdate(sectionRoot, styleInput);
        }
      }
      window.setTimeout(finishMediaSync, styleInput ? 300 : 100);
    } else {
      finishMediaSync();
    }
  }

  function relaxNativeVariantInventory(root, data, enabled) {
    var sectionRoot = getSectionRoot(root, data);
    if (!sectionRoot) return;
    sectionRoot.classList.toggle('wcf-event-capacity-mode', !!enabled);
    if (!enabled) return;
    sectionRoot.querySelectorAll('.input-radio.disabled').forEach(function (inp) {
      inp.classList.remove('disabled');
      inp.removeAttribute('disabled');
    });
  }

  function normalizeDateKey(raw) {
    if (raw == null || raw === '') return '';
    var s = String(raw).trim();
    if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
    var d = new Date(s);
    if (!isNaN(d.getTime())) {
      var y = d.getFullYear();
      var m = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      return y + '-' + m + '-' + day;
    }
    return '';
  }

  /** Myrtle Beach city PDPs: January sessions use Hilton address; other months keep catalog venue. */
  var MYRTLE_BEACH_ADDRESS_HANDLES = {
    'ceramic-painting-workshop-in-myrtle-beach': true,
    'mosaic-lamp-workshop-in-myrtle-beach': true,
  };
  var MYRTLE_BEACH_JANUARY_ADDRESS =
    'Hilton Garden Inn Grand Coastal Mall / Myrtle Beach Airport - 2383 Coastal Grand Cir, Myrtle Beach, SC 29577, United States';
  var MYRTLE_BEACH_JANUARY_TITLE = 'Hilton Garden Inn Grand Coastal Mall / Myrtle Beach Airport';

  function isMyrtleBeachAddressHandle(handle) {
    return !!MYRTLE_BEACH_ADDRESS_HANDLES[String(handle || '').trim()];
  }

  function ensureMyrtleBeachAddressDefaults(root) {
    if (!root || !root.getAttribute || root.getAttribute('data-wcf-myrtle-addr-defaults') === '1') return;
    root.setAttribute('data-wcf-myrtle-addr-defaults', '1');
    root.setAttribute('data-venue-address-default', root.getAttribute('data-venue-address') || '');
    root.setAttribute('data-venue-address-full-default', root.getAttribute('data-venue-address-full') || '');
    root.setAttribute('data-venue-name-default', root.getAttribute('data-venue-name') || '');
  }

  function syncMyrtleBeachVenueAddress(root, data, dateKey) {
    var handle =
      (data && data.productHandle) || (root && root.getAttribute && root.getAttribute('data-product-handle')) || '';
    if (!root || !isMyrtleBeachAddressHandle(handle)) return;

    ensureMyrtleBeachAddressDefaults(root);
    var dk = normalizeDateKey(dateKey);
    var useJanuary = !!(dk && dk.slice(5, 7) === '01');
    var address = useJanuary
      ? MYRTLE_BEACH_JANUARY_ADDRESS
      : root.getAttribute('data-venue-address-default') || '';
    var full = useJanuary
      ? MYRTLE_BEACH_JANUARY_ADDRESS
      : root.getAttribute('data-venue-address-full-default') || address;
    var title = useJanuary
      ? MYRTLE_BEACH_JANUARY_TITLE
      : root.getAttribute('data-venue-name-default') || '';

    if (address) root.setAttribute('data-venue-address', address);
    else root.removeAttribute('data-venue-address');
    if (full) root.setAttribute('data-venue-address-full', full);
    else root.removeAttribute('data-venue-address-full');
    if (title) root.setAttribute('data-venue-name', title);
    else root.removeAttribute('data-venue-name');

    try {
      document.dispatchEvent(
        new CustomEvent('wbw:venue-selected', {
          detail: { title: title, address: full || address },
        })
      );
    } catch (_) {}
  }

  function slotDateKey(slot) {
    if (!slot) return '';
    var dk = normalizeDateKey(slot.date_key);
    if (dk) return dk;
    if (slot.schema_start) {
      dk = normalizeDateKey(slot.schema_start);
      if (dk) return dk;
    }
    if (slot.display_label) {
      var m = String(slot.display_label).match(/(\d{4}-\d{2}-\d{2})/);
      if (m) return m[1];
    }
    return '';
  }

  function formatMoney(cents) {
    var shopify = window.Shopify;
    var format = shopify && shopify.money_format;
    if (shopify && typeof shopify.formatMoney === 'function' && format) {
      try {
        return shopify.formatMoney(cents, format);
      } catch (e) {}
    }
    var helper = window.Alpine && Alpine.store && Alpine.store('xHelper');
    if (helper && typeof helper.formatMoney === 'function' && format) {
      try {
        return helper.formatMoney(cents, format);
      } catch (e) {}
    }
    if (!format) return '';
    return String(format).replace(/\{\{\s*\w+\s*\}\}/, (Number(cents) / 100).toFixed(2));
  }

  function variantCompareAtCents(v) {
    var price = Number(v && v.price) || 0;
    var compare = Number(v && v.compare_at_price) || 0;
    return compare > price ? compare : 0;
  }

  function formatVariantPriceHtml(v) {
    var price = Number(v && v.price) || 0;
    var compare = variantCompareAtCents(v);
    var current =
      '<span class="wcf-price-current">' + escapeHtml(formatMoney(price)) + '</span>';
    if (!compare) return current;
    return (
      '<s class="wcf-price-compare">' +
      escapeHtml(formatMoney(compare)) +
      '</s> ' +
      current
    );
  }

  function buildEventProperties(slot, data, root) {
    var seo = parseSeoPayload(root, data);
    var cityName = String(seo.cityName || '').trim();
    var venueName = String(seo.venueName || '').trim();
    var displayDatetime = String(slot.display_label || slot.time_label || '').trim();
    var bookingParts = [];
    if (cityName) bookingParts.push(cityName);
    if (venueName && venueName !== cityName) bookingParts.push(venueName);
    var bookingDetails = bookingParts.join(' — ');
    if (displayDatetime) {
      bookingDetails = bookingDetails ? bookingDetails + ' · ' + displayDatetime : displayDatetime;
    }

    var props = {
      _workshop: 'true',
      _is_workshop: '1',
      _workshop_city: '1',
      _product_handle: String(data.productHandle || ''),
      _event_metaobject_gid: String(slot.gid || ''),
      _slot_handle: String(slot.handle || ''),
    };
    if (bookingDetails) props['Booking Details'] = bookingDetails;
    if (cityName) props._display_city = cityName;
    if (venueName) props._display_venue = venueName;
    if (displayDatetime) props._display_datetime = displayDatetime;
    if (slot.schema_start) props._schema_start = String(slot.schema_start);
    if (slot.schema_end) props._schema_end = String(slot.schema_end);
    if (slot.date_key) props._date_key = String(slot.date_key);
    if (slot.time_label) props._time_label = String(slot.time_label);
    if (slot.display_label) props._session_label = String(slot.display_label);
    if (window.WorkshopCityFlow && window.WorkshopCityFlow.appendVenueContactProperties) {
      window.WorkshopCityFlow.appendVenueContactProperties(root, props);
    }

    if (window.WorkshopCityFlow && window.WorkshopCityFlow.appendCartValidationProperties) {
      window.WorkshopCityFlow.appendCartValidationProperties(slot, props);
    } else {
      var gid = String(slot.gid || '').trim();
      if (gid) {
        props._event_id = gid;
        props._event_metaobject_gid = gid;
      }
      if (slot.capacity_remaining != null && slot.capacity_remaining !== '') {
        var cap = Number(slot.capacity_remaining);
        if (Number.isFinite(cap) && cap >= 0) {
          props._capacity_remaining = String(Math.floor(cap));
          props._capacity_source = 'events_api';
        }
      }
      props._event_status = String(slot.status || 'active').toLowerCase() || 'active';
    }

    return props;
  }

  function getCartSections() {
    try {
      if (window.Alpine && window.Alpine.store && window.Alpine.store('xCartHelper')) {
        return window.Alpine.store('xCartHelper').getSectionsToRender().map(function (s) {
          return s.id;
        });
      }
    } catch (_) {}
    return [];
  }

  function dispatchCartUi(body) {
    try {
      if (body && body.sections && window.Alpine && window.Alpine.store && window.Alpine.store('xCartHelper')) {
        window.Alpine.store('xCartHelper').reRenderSections(body.sections);
      }
    } catch (_) {}
    try {
      if (window.Alpine && window.Alpine.store && window.Alpine.store('xCartHelper')) {
        var bubble = document.querySelector('#cart-icon-bubble span');
        window.Alpine.store('xCartHelper').currentItemCount = parseInt((bubble && bubble.innerHTML) || '0', 10);
      }
    } catch (_) {}
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: body } }));
    document.dispatchEvent(new CustomEvent('cart:open'));
    try {
      if (window.Alpine && window.Alpine.store && window.Alpine.store('xMiniCart')) {
        if (!window.Alpine.store('xCartNoti') || !window.Alpine.store('xCartNoti').enable) {
          window.Alpine.store('xMiniCart').openCart();
        }
      }
    } catch (_) {}
  }

  function setLoading(root, on) {
    if (on && root && (root.__wcfUiReady || root.__wcfHadSlots)) return;
    var shell = root.querySelector('[data-wcf-shell]');
    var el = root.querySelector('[data-wcf-loading]');
    if (shell) shell.classList.toggle('is-loading', !!on);
    if (root) root.classList.toggle('is-searching', !!on);
    if (el) el.hidden = !on;
  }

  function revealBookingSkeleton(root) {
    if (!root) return;
    root.classList.add('pcw-root--single');
    ['variants', 'calendar'].forEach(function (id) {
      var el = root.querySelector('[data-wcf-step="' + id + '"]');
      if (!el) return;
      el.hidden = false;
      el.classList.add('wcf-step--on');
    });
    setLoading(root, true);
  }

  function flattenEventsBatchProducts(body) {
    var out = [];
    (body && body.products ? body.products : []).forEach(function (row) {
      (row && row.slots ? row.slots : []).forEach(function (slot) {
        if (!slot || typeof slot !== 'object') return;
        var id = String(slot.event_id || slot.id || '').trim();
        if (!id) return;
        var gid = id.indexOf('gid://') === 0 ? id : 'gid://shopify/Metaobject/' + id.replace(/\D/g, '');
        out.push(
          Object.assign({}, slot, {
            id: id,
            gid: gid,
            event_id: id,
            metaobject_gid: gid,
            status: slot.status || 'active',
            display_status: slot.display_status || 'bookable',
            schema_start: slot.schema_start || slot.starts_at || '',
            product_gid: row.product_gid || slot.product_gid || '',
            product_handle: row.product_handle || slot.product_handle || '',
          })
        );
      });
    });
    return out;
  }

  function extractSlotsFromBody(body) {
    if (window.WorkshopCityEvents && typeof window.WorkshopCityEvents.extractSlotsPayload === 'function') {
      var fromApi = window.WorkshopCityEvents.extractSlotsPayload(body);
      if (fromApi && fromApi.length) return fromApi;
      /* Old events-api ignored body.products — fall through for events-batch. */
    }
    if (!body) return [];
    if (Array.isArray(body)) return body;
    if (typeof body !== 'object') return [];
    if (Array.isArray(body.products)) return flattenEventsBatchProducts(body);
    if (Array.isArray(body.slots)) return body.slots;
    if (Array.isArray(body.events)) return body.events;
    if (Array.isArray(body.sessions)) return body.sessions;
    if (body.slots && typeof body.slots === 'object') {
      return Object.keys(body.slots)
        .sort()
        .map(function (k) {
          return body.slots[k];
        })
        .filter(Boolean);
    }
    if (body.data && Array.isArray(body.data.slots)) return body.data.slots;
    if (body.data && Array.isArray(body.data.events)) return body.data.events;
    if (body.result && Array.isArray(body.result.slots)) return body.result.slots;
    if (body.payload && Array.isArray(body.payload.slots)) return body.payload.slots;
    return [];
  }

  function normalizeSlotsList(list) {
    if (window.WorkshopCityEvents && typeof window.WorkshopCityEvents.normalizeSlot === 'function') {
      return list.map(window.WorkshopCityEvents.normalizeSlot).filter(Boolean);
    }
    return list.filter(function (raw) {
      return raw && typeof raw === 'object' && (raw.date_key || raw.schema_start || raw.gid);
    });
  }

  function resolveLiveStateCatalogUrl(root) {
    return (
      (root && root.getAttribute('data-live-state-api-url')) ||
      (root && root.getAttribute('data-events-api-url')) ||
      ''
    );
  }

  function enrichSlotsWithLive(root, skeletonSlots) {
    var API = window.WorkshopCityEvents;
    var skeleton = Array.isArray(skeletonSlots) ? skeletonSlots.slice() : [];
    if (root) root.__wcfSkeletonSlots = skeleton;
    if (!API || typeof API.fetchLiveState !== 'function') return Promise.resolve(skeleton);

    var gids = typeof API.collectEventGids === 'function' ? API.collectEventGids(skeleton) : [];
    if (!gids.length) return Promise.resolve(skeleton);

    var url =
      typeof API.resolveLiveStateApiUrl === 'function'
        ? API.resolveLiveStateApiUrl(root, resolveLiveStateCatalogUrl(root))
        : resolveLiveStateCatalogUrl(root);

    return API.fetchLiveState(gids, { url: url, root: root })
      .then(function (r) {
        var merged = typeof API.mergeSlotsWithLive === 'function'
          ? API.mergeSlotsWithLive(skeleton, (r && r.states) || {}, r && r.as_of)
          : skeleton;
        if (root) root.__wcfCurrentSlots = merged.slice();
        return merged;
      })
      .catch(function () {
        return skeleton;
      });
  }

  function loadSlotsWithLive(root, data) {
    return loadSlots(root, data).then(function (slots) {
      var skeleton = Array.isArray(slots) ? slots : [];
      if (root) root.__wcfSkeletonSlots = skeleton.slice();
      enrichSlotsWithLive(root, skeleton).then(function (merged) {
        if (!root) return;
        var list = Array.isArray(merged) ? merged : skeleton;
        var cacheKey = slotsCacheKey(data);
        slotsLoaded[cacheKey] = list;
        root.__wcfCurrentSlots = list.slice();
        if (root.__wcfCtrl && typeof root.__wcfCtrl.applySlots === 'function') {
          root.__wcfCtrl.applySlots(list, { silent: true });
        } else {
          root.__wcfPendingSilentSlots = list;
        }
      });
      return skeleton;
    });
  }

  function stopWizardLivePoll(root) {
    if (root && root.__wcfLivePoll && typeof root.__wcfLivePoll.stop === 'function') {
      root.__wcfLivePoll.stop();
    }
    if (root) delete root.__wcfLivePoll;
  }

  function startWizardLivePoll(root, onMergedSlots) {
    stopWizardLivePoll(root);
    var API = window.WorkshopCityEvents;
    if (!API || typeof API.startLiveStatePoll !== 'function') return;

    var CFG = window.WorkshopBookingConfig || window.WorkshopCityConfig;
    if (CFG) {
      CFG.readBootstrap(root);
      if (CFG.pollEnabled(root) === false) return;
    }

    root.__wcfOnMergedSlots = onMergedSlots;
    root.__wcfRestartLivePoll = function () {
      startWizardLivePoll(root, root.__wcfOnMergedSlots);
    };

    function deliverMerged(states, asOf) {
      var skeleton = root.__wcfSkeletonSlots || [];
      var merged =
        typeof API.mergeSlotsWithLive === 'function'
          ? API.mergeSlotsWithLive(skeleton, states, asOf)
          : skeleton;
      if (typeof onMergedSlots === 'function') onMergedSlots(merged);
    }

    root.__wcfLivePoll = API.startLiveStatePoll({
      root: root,
      catalogUrl: resolveLiveStateCatalogUrl(root),
      getPollContext: function () {
        return typeof root.__wcfGetPollContext === 'function' ? root.__wcfGetPollContext() : null;
      },
      getSlotGids: function () {
        return typeof API.collectEventGids === 'function'
          ? API.collectEventGids(root.__wcfSkeletonSlots || [])
          : [];
      },
      onCatalog: function () {
        if (typeof root.__wcfRetrySlots === 'function') root.__wcfRetrySlots();
      },
      onUpdate: function (states, meta) {
        if (meta && CFG && typeof CFG.applyMetaFromResponse === 'function') {
          CFG.applyMetaFromResponse(root, meta).then(function () {
            deliverMerged(states, meta && meta.as_of);
          });
          return;
        }
        deliverMerged(states, meta && meta.as_of);
      },
    });
    if (CFG) root.__wcfLastPollIntervalMs = CFG.activePollIntervalMs ? CFG.activePollIntervalMs(root) : CFG.pollIntervalMs(root);
    root.__wcfLivePoll.start();
  }

  function parseSeoPayload(root, data) {
    if (data && data.seo && typeof data.seo === 'object') return data.seo;
    return {
      cityName: (root && root.getAttribute('data-city-name')) || '',
      venueName: (root && root.getAttribute('data-venue-name')) || '',
      venueAddress: (root && root.getAttribute('data-venue-address')) || '',
      stateName: (root && root.getAttribute('data-state-name')) || '',
      country: (root && root.getAttribute('data-address-country')) || 'US',
      latitude: root && root.getAttribute('data-latitude'),
      longitude: root && root.getAttribute('data-longitude'),
      productTitle: (root && root.getAttribute('data-product-title')) || '',
      productUrl: (root && root.getAttribute('data-product-url')) || '',
      featuredImage: (root && root.getAttribute('data-featured-image')) || '',
      offerPrice: (root && root.getAttribute('data-offer-price')) || '',
      shopName: (window.Shopify && window.Shopify.shop) || '',
      shopUrl: (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/',
    };
  }

  function firstBookableSlot(slots) {
    var list = (slots || []).slice().sort(function (a, b) {
      var da = String((a && a.date_key) || '').slice(0, 10);
      var db = String((b && b.date_key) || '').slice(0, 10);
      if (da !== db) return da.localeCompare(db);
      return String((a && a.time_label) || '').localeCompare(String((b && b.time_label) || ''));
    });
    for (var i = 0; i < list.length; i++) {
      if (slotBookable(list[i])) return list[i];
    }
    return null;
  }

  function shouldEmitClientEventJsonLd(root) {
    var mode = String((root && root.getAttribute('data-schema-events-mode')) || 'metafield').trim();
    if (mode === 'off') return false;
    if (mode === 'js_fallback') return true;
    return !document.querySelector(
      'script[type="application/ld+json"][data-schema-source="metafield"]'
    );
  }

  function removeClientEventJsonLd() {
    var existing = document.getElementById('wcf-event-jsonld');
    if (existing) existing.remove();
  }

  function maybeUpdateEventJsonLd(slots, root, data) {
    if (!shouldEmitClientEventJsonLd(root)) {
      removeClientEventJsonLd();
      return;
    }
    if (root && root.__wcfEventJsonLdDone) return;

    var slot = firstBookableSlot(slots);
    if (!slot || !slot.schema_start) {
      removeClientEventJsonLd();
      return;
    }

    var seo = parseSeoPayload(root, data);
    var shopOrigin = window.location && window.location.origin ? window.location.origin : '';
    var productPath = seo.productUrl || '/products/' + ((data && data.productHandle) || '');
    var eventUrl = shopOrigin + productPath;
    var evName = seo.productTitle || (data && data.productHandle) || 'Workshop';
    if (seo.cityName) evName = titleWithMapCity(evName, seo.cityName);
    var dl = slot.display_label || slot.date_key || '';
    if (dl) evName += ' - ' + dl;

    var payload = {
      '@context': 'https://schema.org',
      '@type': 'Event',
      '@id': eventUrl + '#workshop-slot-live',
      name: evName,
      startDate: slot.schema_start,
      endDate: slot.schema_end || slot.schema_start,
      eventStatus: 'https://schema.org/EventScheduled',
      eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
      location: {
        '@type': 'Place',
        name: seo.venueName || seo.cityName || seo.shopName || 'Workshop venue',
        address: {
          '@type': 'PostalAddress',
          streetAddress: seo.venueAddress || '',
          addressLocality: seo.cityName || '',
          addressRegion: seo.stateName || '',
          addressCountry: seo.country || 'US',
        },
      },
      offers: {
        '@type': 'Offer',
        url: eventUrl,
        price: seo.offerPrice || '',
        priceCurrency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
        availability: 'https://schema.org/InStock',
        validFrom: slot.schema_start,
        validThrough: slot.schema_end || slot.schema_start,
      },
    };

    if (seo.featuredImage) payload.image = seo.featuredImage;
    if (seo.latitude && seo.longitude) {
      payload.location.geo = {
        '@type': 'GeoCoordinates',
        latitude: Number(seo.latitude),
        longitude: Number(seo.longitude),
      };
    }

    var existing = document.getElementById('wcf-event-jsonld');
    var el = existing || document.createElement('script');
    el.type = 'application/ld+json';
    el.id = 'wcf-event-jsonld';
    el.setAttribute('data-schema-source', 'js');
    el.textContent = JSON.stringify(payload);
    if (!existing) document.head.appendChild(el);
    if (root) root.__wcfEventJsonLdDone = true;
  }

  function loadSlots(root, data) {
    var timeoutMs =
      window.WorkshopCityEvents && window.WorkshopCityEvents.DEFAULT_FETCH_TIMEOUT_MS
        ? window.WorkshopCityEvents.DEFAULT_FETCH_TIMEOUT_MS
        : 15000;
    var venueId = root.getAttribute('data-map-city-venue-id') || '';
    if (window.WorkshopCityEvents && typeof window.WorkshopCityEvents.fetchSlots === 'function') {
      return window.WorkshopCityEvents.fetchSlots(root, data, timeoutMs, {
        venue_id: venueId,
        venue_ref_id: venueId,
        openEnded: true,
      }).then(function (slots) {
        var list = Array.isArray(slots) ? slots : [];
        root.setAttribute('data-wcf-raw-slot-count', String(list.length));
        return list;
      });
    }

    var url =
      (window.WorkshopCityEvents && typeof window.WorkshopCityEvents.resolveEventsApiUrl === 'function'
        ? window.WorkshopCityEvents.resolveEventsApiUrl(root)
        : '') || root.getAttribute('data-events-api-url') || '';
    if (!url) {
      return Promise.reject(new Error('Workshop events API URL is not configured.'));
    }
    var shop = '';
    try {
      if (window.Shopify && window.Shopify.shop) shop = String(window.Shopify.shop);
    } catch (_) {}
    var productId =
      (data && (data.productId || data.product_id)) ||
      (root && root.getAttribute && root.getAttribute('data-product-id')) ||
      '';
    var productGid = '';
    if (productId) {
      var rawPid = String(productId).trim();
      if (rawPid.indexOf('gid://') === 0) productGid = rawPid;
      else {
        var digits = rawPid.replace(/\D/g, '');
        if (digits) productGid = 'gid://shopify/Product/' + digits;
      }
    }
    var payload = {
      shop_domain: shop,
      product_id: productId || undefined,
      product_handle: data && data.productHandle,
      section_id: data && data.sectionId,
      source: 'workshop_city_flow',
      intent: 'load_slots',
    };
    if (productGid && String(url).indexOf('events-batch') !== -1) {
      payload.product_gids = [productGid];
    }
    if (data && (data.dateFrom || data.date_from)) payload.date_from = data.dateFrom || data.date_from;
    if (data && (data.dateTo || data.date_to)) payload.date_to = data.dateTo || data.date_to;
    if (data && data.workshopType) payload.workshop_type = data.workshopType;
    if (venueId) {
      payload.venue_id = venueId;
      payload.venue_ref_id = venueId;
    }
    return fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res.json().then(function (body) {
          return { ok: res.ok, status: res.status, body: body };
        });
      })
      .then(function (r) {
        if (!r.ok) {
          var msg =
            (r.body && (r.body.description || r.body.message || r.body.error)) ||
            'Events API ' + r.status;
          throw new Error(msg);
        }
        var body = r.body;
        if (typeof body === 'string') {
          try {
            body = JSON.parse(body);
          } catch (_) {
            body = {};
          }
        }
        var raw = extractSlotsFromBody(body);
        root.setAttribute('data-wcf-raw-slot-count', String(raw.length));
        var normalized = normalizeSlotsList(raw);
        if (raw.length && !normalized.length) normalized = raw;
        return normalized;
      });
  }

  var slotsInFlight = Object.create(null);
  var slotsLoaded = Object.create(null);
  var slotsSkeletonLoaded = Object.create(null);

  function slotsCacheKey(data) {
    return (
      String((data && data.productId) || '') +
      '|' +
      String((data && data.productHandle) || '') +
      '|' +
      String((data && data.venueId) || '')
    );
  }

  function loadSlotsDeduped(root, data, bustCache) {
    var key = slotsCacheKey(data);
    if (bustCache) {
      delete slotsLoaded[key];
      delete slotsSkeletonLoaded[key];
      delete slotsInFlight[key];
    }
    if (slotsLoaded[key]) {
      root.__wcfSkeletonSlots = (slotsSkeletonLoaded[key] || slotsLoaded[key]).slice();
      root.__wcfCurrentSlots = slotsLoaded[key].slice();
      return Promise.resolve(slotsLoaded[key].slice());
    }
    if (slotsInFlight[key]) {
      return slotsInFlight[key];
    }
    var promise = loadSlotsWithLive(root, data)
      .then(function (slots) {
        var list = Array.isArray(slots) ? slots : [];
        slotsLoaded[key] = list;
        root.__wcfCurrentSlots = list.slice();
        if (root.__wcfSkeletonSlots) {
          slotsSkeletonLoaded[key] = root.__wcfSkeletonSlots.slice();
        }
        return list.slice();
      })
      .finally(function () {
        delete slotsInFlight[key];
      });
    slotsInFlight[key] = promise;
    return promise;
  }

  function resolveEventsLoadStrategy(root, options) {
    /* Popup-city: always fetch on page load — deferred visible/interaction
       caused first-interaction empty → waitlist flash before slots arrived. */
    return 'page_load';
  }

  function cleanupDeferredFetch(root) {
    if (root.__wcfVisibilityObserver) {
      root.__wcfVisibilityObserver.disconnect();
      delete root.__wcfVisibilityObserver;
    }
    if (root.__wcfInteractionHandler) {
      root.removeEventListener('click', root.__wcfInteractionHandler, true);
      delete root.__wcfInteractionHandler;
    }
  }

  function readMapCityContext() {
    if (typeof URLSearchParams === 'undefined') return null;

    var params = new URLSearchParams(window.location.search || '');
    var city = String(params.get('amc_city') || '').trim();
    if (!city) return null;

    return {
      city: city,
      state: String(params.get('amc_state') || '').trim(),
      stateCode: String(params.get('amc_state_code') || '').trim(),
      venueId: String(params.get('amc_venue_id') || params.get('amc_city_key') || '').trim(),
    };
  }

  function titleWithMapCity(title, city) {
    var base = String(title || '').trim();
    if (!base || !city) return base;
    if (/\s+in\s+.+$/i.test(base)) return base.replace(/\s+in\s+.+$/i, ' in ' + city);
    return base + ' in ' + city;
  }

  function rewriteMapCityText(root, context, data) {
    var city = context && context.city;
    if (!root || !city) return;

    var sectionRoot = getSectionRoot(root, data);
    var originalCity =
      (data && data.seo && data.seo.cityName) || root.getAttribute('data-city-name') || '';
    var originalTitle =
      (data && data.seo && data.seo.productTitle) || root.getAttribute('data-product-title') || '';
    var nextTitle = titleWithMapCity(originalTitle, city);

    if (sectionRoot && nextTitle) {
      sectionRoot.querySelectorAll('.product-title').forEach(function (el) {
        if (String(el.textContent || '').trim() === originalTitle) {
          el.textContent = nextTitle;
        }
      });
    }

    if (sectionRoot && originalCity && originalCity !== city) {
      sectionRoot
        .querySelectorAll('.cwn-nearby__trigger-text, .cwn-nearby__panel-title, .cwn-types__heading')
        .forEach(function (el) {
          el.textContent = String(el.textContent || '').replace(originalCity, city);
        });
    }
  }

  function applyMapCityContext(root, data) {
    var context = readMapCityContext();
    if (!context || !context.city) return;

    rewriteMapCityText(root, context, data);

    root.setAttribute('data-city-name', context.city);
    if (context.state) root.setAttribute('data-state-name', context.state);
    root.setAttribute('data-map-city-context', 'true');
    if (context.venueId) {
      root.setAttribute('data-venue-id', context.venueId);
      root.setAttribute('data-map-city-venue-id', context.venueId);
    }

    data.seo = data.seo && typeof data.seo === 'object' ? data.seo : {};
    data.seo.cityName = context.city;
    if (context.state) data.seo.stateName = context.state;
    if (context.venueId) data.venueId = context.venueId;
    data.seo.productTitle = titleWithMapCity(
      data.seo.productTitle || root.getAttribute('data-product-title'),
      context.city
    );
    root.setAttribute('data-product-title', data.seo.productTitle || '');
  }

  function pcwFindWaitlistAogenBlock() {
    if (typeof window.wbFindWaitlistAogenBlock === 'function') {
      try {
        var viaHub = window.wbFindWaitlistAogenBlock();
        if (viaHub) {
          var hubKey = String(viaHub.getAttribute('data-form-key') || '').trim();
          if (!hubKey || hubKey === 'waitlist') return viaHub;
        }
      } catch (_) {}
    }
    var blocks = document.querySelectorAll('.aogen-forms-block');
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      if (!b) continue;
      if (b.closest('[data-amc-group-form]')) continue;
      if (b.getAttribute('data-amc-group-form-block') === '1') continue;
      if (b.getAttribute('data-wbw-aogen-skip') === '1') continue;
      if (String(b.getAttribute('data-form-key') || '').trim() === 'waitlist') return b;
    }
    return null;
  }

  function pcwHideAogenAppsSection(block) {
    if (!block) return;
    var section = block.closest('.shopify-section.section-apps') || block.__pcwAogenAppsSection;
    if (!section) return;
    block.__pcwAogenAppsSection = section;
    section.setAttribute('data-wbw-aogen-apps-hidden', '');
    section.setAttribute('hidden', '');
    section.setAttribute('aria-hidden', 'true');
    section.style.display = 'none';
  }

  function pcwRestoreAogenInlinePanel(block) {
    if (!block) return;
    var overlay = document.querySelector('.aogen-forms-overlay');
    if (overlay && overlay.classList.contains('is-open') && block.classList.contains('is-open')) {
      return;
    }
    var panel =
      block.querySelector('.aogen-forms-panel') ||
      (overlay && overlay.querySelector('.aogen-forms-panel')) ||
      null;
    if (panel && panel.parentElement !== block) {
      block.appendChild(panel);
    }
    if (panel) {
      panel.hidden = false;
      panel.removeAttribute('hidden');
      if (panel.style) {
        panel.style.transform = '';
        panel.style.left = '';
        panel.style.right = '';
        panel.style.top = '';
        panel.style.bottom = '';
        panel.style.inset = '';
      }
    }
    block.classList.remove('is-open', 'is-popup', 'is-drawer', 'is-floating');
    if (overlay) {
      overlay.classList.remove('is-open');
      overlay.hidden = true;
      overlay.setAttribute('hidden', '');
    }
    var teaser = document.querySelector('.aogen-forms-corner-teaser');
    if (teaser) teaser.hidden = true;
  }

  function pcwBuildBookingContext(root) {
    return {
      form_key: 'waitlist',
      intent: 'inline',
      venue_id: String(
        root.getAttribute('data-venue-ref-id') || root.getAttribute('data-venue-id') || ''
      ).trim(),
      venue_name: String(root.getAttribute('data-venue-name') || '').trim(),
      city: String(root.getAttribute('data-city-name') || '').trim(),
      state: String(root.getAttribute('data-state-name') || '').trim(),
      country: String(root.getAttribute('data-address-country') || 'US').trim() || 'US',
      workshop_type: String(root.getAttribute('data-workshop-type') || '').trim(),
      product_id: String(root.getAttribute('data-product-id') || '').trim(),
      product_name: String(root.getAttribute('data-product-title') || '').trim(),
      product_handle: String(root.getAttribute('data-product-handle') || '').trim(),
      available_event_dates: '',
    };
  }

  function pcwFormReady(block) {
    if (!block) return false;
    var fields = block.querySelector('[data-aogen-fields]');
    if (!fields || !fields.children.length) return false;
    return block.getAttribute('data-aogen-ready') === '1';
  }

  var PCW_WL_TITLE_HAS_SESSIONS = "Can't make these dates?";
  var PCW_WL_TITLE_NO_SESSIONS = 'There are no available dates for this location';
  var PCW_WL_BTN = 'Join Waitlist';
  var PCW_WL_BODY_FALLBACK =
    'Join the waitlist and be the first to hear when new dates are added.';

  /** Connect emits "…back in ." whenever its city merge field resolves empty. */
  function pcwPolishWaitlistIntro(block) {
    var intro = block.querySelector('.aogen-forms-intro');
    if (!intro) return;
    var root = block.closest ? block.closest('.pcw-root') : null;
    var city = String((root && root.getAttribute('data-city-name')) || '').trim();
    var body = String(intro.textContent || '')
      .replace(/\s+/g, ' ')
      .trim();
    var joinIdx = body.search(/Join the waitlist/i);
    if (joinIdx > 0) {
      body = body.slice(joinIdx);
    } else if (/^Get notified when we're back in/i.test(body)) {
      body = body.replace(/^Get notified when we're back in[^.]*\.\s*/i, '');
    }
    if (!body) body = PCW_WL_BODY_FALLBACK;
    var wanted = city ? "Get notified when we're back in " + city + '. ' + body : body;
    if (String(intro.textContent || '').trim() !== wanted) {
      intro.textContent = wanted;
    }
  }

  /** Only the "Can't make these dates?" variant collapses; with zero sessions
      the card is the sole CTA, so it stays open. */
  function pcwSyncWaitlistCollapse(block, hasSessions) {
    var title = block.querySelector('.aogen-forms-title');
    if (!hasSessions) {
      block.removeAttribute('data-pcw-wl-collapsible');
      block.removeAttribute('data-pcw-wl-open');
      if (title) {
        title.removeAttribute('role');
        title.removeAttribute('tabindex');
        title.removeAttribute('aria-expanded');
      }
      return;
    }
    block.setAttribute('data-pcw-wl-collapsible', '1');
    /* Default open; preserve user toggle after first paint. */
    if (!block.hasAttribute('data-pcw-wl-open')) {
      block.setAttribute('data-pcw-wl-open', '1');
    }
    if (title) {
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute(
        'aria-expanded',
        block.getAttribute('data-pcw-wl-open') === '1' ? 'true' : 'false'
      );
    }
  }

  function pcwWaitlistToggleHandler(ev) {
    if (!ev.target || !ev.target.closest) return;
    var title = ev.target.closest('.aogen-forms-title');
    if (!title) return;
    var block = title.closest('[data-pcw-wl-collapsible="1"]');
    if (!block) return;
    if (ev.type === 'keydown' && ev.key !== 'Enter' && ev.key !== ' ') return;
    ev.preventDefault();
    var open = block.getAttribute('data-pcw-wl-open') === '1';
    block.setAttribute('data-pcw-wl-open', open ? '0' : '1');
    title.setAttribute('aria-expanded', open ? 'false' : 'true');
  }

  /** Delegated on the root so it outlives Connect re-rendering the card. */
  function pcwBindWaitlistToggle(root) {
    if (!root || root.__pcwWlToggleBound) return;
    root.__pcwWlToggleBound = true;
    root.addEventListener('click', pcwWaitlistToggleHandler);
    root.addEventListener('keydown', pcwWaitlistToggleHandler);
  }

  /** Inplace (0 sessions): replace form H1. Below (≥1): keep hub copy. Always stamp CTA. */
  function pcwPolishWaitlistCopy(block, hasSessions) {
    if (!block) return;
    block.__pcwWlPolishing = true;
    try {
      var title = block.querySelector('.aogen-forms-title');
      if (title) {
        var wanted = hasSessions ? PCW_WL_TITLE_HAS_SESSIONS : PCW_WL_TITLE_NO_SESSIONS;
        if (String(title.textContent || '').trim() !== wanted) {
          title.textContent = wanted;
        }
        title.setAttribute('data-pcw-wl-title-mode', hasSessions ? 'has-sessions' : 'no-sessions');
      }
      var btn =
        block.querySelector('button[type="submit"]') ||
        block.querySelector('.aogen-forms-form button:not([type])');
      if (btn && String(btn.textContent || '').trim() !== PCW_WL_BTN) {
        btn.textContent = PCW_WL_BTN;
      }
      if (block.getAttribute('data-button-label') !== PCW_WL_BTN) {
        block.setAttribute('data-button-label', PCW_WL_BTN);
      }
      pcwPolishWaitlistIntro(block);
      pcwSyncWaitlistCollapse(block, hasSessions);
    } finally {
      block.__pcwWlPolishing = false;
    }
  }

  function pcwEnsureWaitlistCopyKeepalive(root, block, hasSessions) {
    if (!block || !root) return;
    if (block.__pcwWlTitleMo) {
      try {
        block.__pcwWlTitleMo.disconnect();
      } catch (_) {}
      block.__pcwWlTitleMo = null;
    }
    root.__pcwWlWantHasSessions = !!hasSessions;
    pcwBindWaitlistToggle(root);
    pcwPolishWaitlistCopy(block, hasSessions);
    if (typeof MutationObserver === 'undefined') return;

    var timer = 0;
    function reapply() {
      timer = 0;
      if (block.__pcwWlPolishing) return;
      pcwPolishWaitlistCopy(block, !!root.__pcwWlWantHasSessions);
    }

    var mo = new MutationObserver(function () {
      if (block.__pcwWlPolishing) return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(reapply, 0);
    });
    mo.observe(block, { childList: true, subtree: true, characterData: true });
    block.__pcwWlTitleMo = mo;

    /* booking-context → Connect rewrites head after our first polish */
    window.requestAnimationFrame(function () {
      pcwPolishWaitlistCopy(block, !!root.__pcwWlWantHasSessions);
      window.setTimeout(function () {
        pcwPolishWaitlistCopy(block, !!root.__pcwWlWantHasSessions);
      }, 50);
      window.setTimeout(function () {
        pcwPolishWaitlistCopy(block, !!root.__pcwWlWantHasSessions);
      }, 250);
    });
  }

  function pcwCountBookableSlots(slots) {
    var list = Array.isArray(slots) ? slots : [];
    var n = 0;
    for (var i = 0; i < list.length; i++) {
      if (slotBookable(list[i])) n += 1;
    }
    return n;
  }

  function pcwClearWaitlistWatch(root) {
    if (!root) return;
    if (root.__pcwWlRetryTimer) {
      try {
        clearTimeout(root.__pcwWlRetryTimer);
      } catch (_) {}
      root.__pcwWlRetryTimer = 0;
    }
    root.__pcwWlRetryTries = 0;
    if (root.__pcwWlReadyMo) {
      try {
        root.__pcwWlReadyMo.disconnect();
      } catch (_) {}
      root.__pcwWlReadyMo = null;
    }
  }

  function pcwScheduleWaitlistRetry(root) {
    if (!root || root.__pcwWlRetryTimer) return;
    root.__pcwWlRetryTries = 0;
    function tick() {
      root.__pcwWlRetryTimer = 0;
      root.__pcwWlRetryTries = (root.__pcwWlRetryTries || 0) + 1;
      if (root.__pcwWlRetryTries > 15) {
        root.__pcwWlRetryTries = 0;
        return;
      }
      var bookable = pcwCountBookableSlots(root.__wcfCurrentSlots);
      if (syncPcwConnectWaitlist(root, bookable, { fromRetry: true })) {
        root.__pcwWlRetryTries = 0;
        return;
      }
      root.__pcwWlRetryTimer = setTimeout(tick, 400);
    }
    root.__pcwWlRetryTimer = setTimeout(tick, 400);
  }

  function pcwWatchFormReady(root, block) {
    if (!root || !block || root.__pcwWlReadyMo) return;
    root.__pcwWlReadyMo = new MutationObserver(function () {
      if (!pcwFormReady(block)) return;
      pcwClearWaitlistWatch(root);
      syncPcwConnectWaitlist(root, pcwCountBookableSlots(root.__wcfCurrentSlots));
    });
    root.__pcwWlReadyMo.observe(block, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['data-aogen-ready'],
    });
  }

  function pcwSetMountHidden(el, hide) {
    if (!el) return;
    if (hide) {
      el.hidden = true;
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
    } else {
      el.hidden = false;
      el.removeAttribute('hidden');
      el.setAttribute('aria-hidden', 'false');
    }
  }

  /**
   * Option A: 0 bookable sessions → Connect form replaces wizard shell.
   * ≥1 bookable session → wizard stays; Connect form always under shell (hub-style).
   * @param {number} bookableCount — bookable slots only (not raw slotList.length)
   * @param {{fromRetry?: boolean}} [opts]
   */
  function syncPcwSiblingPromoVisibility(root, hasSessions) {
    if (!root || !root.querySelector) return;
    var slot = root.querySelector('[data-pcw-sibling-promo]');
    if (!slot) return;
    var wrap = slot.querySelector('[data-wbw-sibling-promo-wrap]');
    var show = !!hasSessions;
    slot.hidden = !show;
    if (show) slot.removeAttribute('hidden');
    else slot.setAttribute('hidden', '');
    slot.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (wrap) {
      wrap.hidden = !show;
      wrap.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
  }

  function syncPcwConnectWaitlist(root, bookableCount, opts) {
    opts = opts || {};
    if (!root || !root.getAttribute || !root.hasAttribute('data-popup-city-wizard')) return false;
    var inplace = root.querySelector('[data-pcw-aogen-forms-mount="inplace"]');
    var below = root.querySelector('[data-pcw-below-waitlist]');
    var belowMount = root.querySelector('[data-pcw-aogen-forms-mount="below"]');
    var shell = root.querySelector('[data-wcf-shell]');
    if (!inplace || !below || !belowMount) return false;

    /* Zero slots because the fetch failed is not the same as zero slots.
       Keep the shell's retry notice instead of claiming there are no dates. */
    if (root.getAttribute('data-wcf-slots-error') === '1') {
      pcwClearWaitlistWatch(root);
      root.removeAttribute('data-pcw-waitlist-mode');
      root.setAttribute('data-pcw-below-waitlist', '0');
      syncPcwSiblingPromoVisibility(root, false);
      pcwSetMountHidden(below, true);
      pcwSetMountHidden(inplace, true);
      if (shell) {
        shell.hidden = false;
        shell.removeAttribute('hidden');
      }
      return true;
    }

    var block = pcwFindWaitlistAogenBlock();
    var hasSessions = Number(bookableCount) > 0;
    root.setAttribute('data-wcf-slot-count', String(Math.max(0, Number(bookableCount) || 0)));
    syncPcwSiblingPromoVisibility(root, hasSessions);

    if (!block) {
      /* Keep wizard visible until Connect block exists — avoid blank inplace CSS. */
      root.removeAttribute('data-pcw-waitlist-mode');
      root.setAttribute('data-pcw-below-waitlist', '0');
      pcwSetMountHidden(below, true);
      pcwSetMountHidden(inplace, true);
      if (shell) {
        shell.hidden = false;
        shell.removeAttribute('hidden');
      }
      if (!opts.fromRetry) pcwScheduleWaitlistRetry(root);
      return false;
    }

    if (!opts.fromRetry) pcwClearWaitlistWatch(root);
    else {
      /* Success path from retry: drop timer/MO without resetting mid-tick arming. */
      if (root.__pcwWlReadyMo) {
        try {
          root.__pcwWlReadyMo.disconnect();
        } catch (_) {}
        root.__pcwWlReadyMo = null;
      }
    }
    pcwHideAogenAppsSection(block);

    var mount = hasSessions ? belowMount : inplace;
    if (block.parentElement !== mount) mount.appendChild(block);
    pcwRestoreAogenInlinePanel(block);
    var ready = pcwFormReady(block);

    if (hasSessions) {
      root.setAttribute('data-pcw-waitlist-mode', 'below');
      if (shell) {
        shell.hidden = false;
        shell.removeAttribute('hidden');
      }
      pcwSetMountHidden(inplace, true);
      root.setAttribute('data-pcw-below-waitlist', ready ? '1' : '0');
      pcwSetMountHidden(below, !ready);
      if (ready) pcwEnsureWaitlistCopyKeepalive(root, block, true);
      if (!ready) pcwWatchFormReady(root, block);
    } else if (ready) {
      root.setAttribute('data-pcw-waitlist-mode', 'inplace');
      root.setAttribute('data-pcw-below-waitlist', '0');
      pcwSetMountHidden(below, true);
      if (shell) {
        shell.hidden = true;
        shell.setAttribute('hidden', '');
      }
      pcwSetMountHidden(inplace, false);
      pcwEnsureWaitlistCopyKeepalive(root, block, false);
    } else {
      /* Form not ready — keep shell; do not set inplace mode (CSS would blank PDP). */
      root.removeAttribute('data-pcw-waitlist-mode');
      root.setAttribute('data-pcw-below-waitlist', '0');
      pcwSetMountHidden(below, true);
      pcwSetMountHidden(inplace, true);
      if (shell) {
        shell.hidden = false;
        shell.removeAttribute('hidden');
      }
      pcwWatchFormReady(root, block);
    }

    var modeAttr = root.getAttribute('data-pcw-waitlist-mode') || 'pending';
    var ctxKey =
      modeAttr +
      '|' +
      String(block.getAttribute('data-form-key') || 'waitlist') +
      '|' +
      String(root.getAttribute('data-venue-ref-id') || root.getAttribute('data-venue-id') || '');
    if (root.__pcwWlCtxKey !== ctxKey) {
      root.__pcwWlCtxKey = ctxKey;
      try {
        document.dispatchEvent(
          new CustomEvent('aogen:booking-context', { detail: pcwBuildBookingContext(root) })
        );
      } catch (_) {}
    }
    /* Connect may rewrite .aogen-forms-title on booking-context — re-stamp after. */
    if (ready) {
      window.requestAnimationFrame(function () {
        pcwPolishWaitlistCopy(block, !!hasSessions);
      });
    }
    return true;
  }

  function initRoot(root, options) {
    if (root.__wcfBound) return;

    var data = parseData(root);
    if (!data) return;
    /* Remove any cached waitlist markup — booking-only shell; Connect form mounts separately. */
    root.querySelectorAll('[data-wcf-step^="wl-"], .wcf-step--wl-single, .wcf-wl-form-wrap').forEach(function (el) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
    applyMapCityContext(root, data);
    root.__wcfBound = true;

    if (window.WorkshopCityConfig && typeof window.WorkshopCityConfig.readBootstrap === 'function') {
      window.WorkshopCityConfig.readBootstrap(root);
    }

    var variants = loadProductVariants(root, data);
    root.setAttribute('data-wcf-variant-count', String(variants.length));
    var waitlistUrl = root.getAttribute('data-waitlist-url') || 'https://adapter.aogen.com.au/api/public/waitlist';
    var cityName = root.getAttribute('data-city-name') || '';
    var addonVariantId = root.getAttribute('data-addon-variant-id');

    var track = root.querySelector('[data-wcf-track]');
    var shell = root.querySelector('[data-wcf-shell]');

    cleanupDeferredFetch(root);

    var eventsApiUrl = root.getAttribute('data-events-api-url') || '';
    var debug =
      typeof URLSearchParams !== 'undefined' &&
      new URLSearchParams(window.location.search).get('wcf_debug') === '1';

    var wizardCtx = {
      waitlistUrl: waitlistUrl,
      cityName: cityName,
      addonVariantId: addonVariantId,
      track: track,
      shell: shell,
      eventsApiUrl: eventsApiUrl,
      debug: debug,
    };

    function deliverSlots(slots) {
      setLoading(root, false);
      var slotList = Array.isArray(slots) ? slots : [];
      root.__wcfCurrentSlots = slotList.slice();
      if (root.__wcfHadSlots && slotList.length === 0) {
        console.warn('[popup-city-wizard] ignoring stale empty slots response');
        return;
      }
      if (slotList.length > 0) root.__wcfHadSlots = true;
      root.setAttribute('data-wcf-slot-count', String(slotList.length));
      console.info('[popup-city-wizard] slots for UI', {
        count: slotList.length,
        productHandle: data.productHandle,
        branch: 'booking',
      });
      if (debug) console.info('[popup-city-wizard] slots detail', slotList);
      maybeUpdateEventJsonLd(slotList, root, data);
      runWizard(root, slotList, variants, data, wizardCtx);
    }

    function deliverSlotsError(err) {
      if (root.__wcfHadSlots) {
        console.warn('[popup-city-wizard] ignoring error after slots loaded', err);
        return;
      }
      console.warn('[popup-city-wizard] events API failed', err);
      root.__wcfSlotsFetchStarted = false;
      setLoading(root, false);
      runWizard(root, [], variants, data, {
        waitlistUrl: waitlistUrl,
        cityName: cityName,
        addonVariantId: addonVariantId,
        track: track,
        shell: shell,
        apiError: err && err.message ? String(err.message) : 'Events API failed',
        eventsApiUrl: eventsApiUrl,
      });
    }

    function waitForEventsApi(attempt) {
      attempt = attempt || 0;
      if (window.WorkshopCityEvents && typeof window.WorkshopCityEvents.fetchSlots === 'function') {
        return Promise.resolve(true);
      }
      if (attempt >= 40) return Promise.resolve(false);
      return new Promise(function (resolve) {
        window.setTimeout(function () {
          resolve(waitForEventsApi(attempt + 1));
        }, 50);
      });
    }

    function beginSlotsFetch(bustCache) {
      if (root.__wcfSlotsFetchStarted && !bustCache) {
        return root.__wcfActiveFetchPromise || Promise.resolve([]);
      }
      root.__wcfSlotsFetchStarted = true;
      setLoading(root, true);
      root.setAttribute('data-wcf-branch', 'loading');

      root.__wcfLoadGen = (root.__wcfLoadGen || 0) + 1;
      var fetchGen = root.__wcfLoadGen;

      if (debug) {
        console.info('[popup-city-wizard] loading slots', {
          eventsApiUrl: eventsApiUrl,
          productHandle: data.productHandle,
          hasEventsApi: !!(window.WorkshopCityEvents && window.WorkshopCityEvents.fetchSlots),
          strategy: resolveEventsLoadStrategy(root, options),
        });
      }

      root.__wcfActiveFetchPromise = waitForEventsApi()
        .then(function (ready) {
          if (!ready) {
            console.warn(
              '[popup-city-wizard] WorkshopCityEvents.fetchSlots missing — check popup-city-wizard-scripts load order'
            );
          }
          return loadSlotsDeduped(root, data, !!bustCache);
        })
        .then(function (slots) {
          if (root.__wcfLoadGen !== fetchGen) return;
          deliverSlots(slots);
        })
        .catch(function (err) {
          if (root.__wcfLoadGen !== fetchGen) return;
          deliverSlotsError(err);
        });
      return root.__wcfActiveFetchPromise;
    }

    root.__wcfRetrySlots = function () {
      beginSlotsFetch(true);
    };

    var strategy = resolveEventsLoadStrategy(root, options);
    if (
      window.WorkshopCityFlow &&
      typeof window.WorkshopCityFlow.hasCityBookingDeepLink === 'function' &&
      window.WorkshopCityFlow.hasCityBookingDeepLink()
    ) {
      strategy = 'page_load';
    }
    revealBookingSkeleton(root);

    if (strategy === 'page_load') {
      beginSlotsFetch(options && options.sectionReload);
    } else if (strategy === 'interaction') {
      root.__wcfInteractionHandler = function () {
        if (root.__wcfSlotsFetchStarted) return;
        cleanupDeferredFetch(root);
        beginSlotsFetch(false);
      };
      root.addEventListener('click', root.__wcfInteractionHandler, true);
    } else if (typeof IntersectionObserver === 'undefined') {
      beginSlotsFetch(false);
    } else {
      root.__wcfVisibilityObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.1) return;
            cleanupDeferredFetch(root);
            beginSlotsFetch(false);
          });
        },
        { threshold: 0.1 }
      );
      root.__wcfVisibilityObserver.observe(root);
    }
  }

  function runWizard(root, slots, variants, data, ctx) {
    if (root.__wcfCtrl && typeof root.__wcfCtrl.applySlots === 'function') {
      root.__wcfCtrl.applySlots(slots, ctx);
      return;
    }

    function refreshProductVariants() {
      variants = loadProductVariants(root, data);
      root.setAttribute('data-wcf-variant-count', String(variants.length));
      return variants;
    }

    var waitlistUrl = ctx.waitlistUrl;
    var cityName = ctx.cityName;
    var addonVariantId = ctx.addonVariantId;
    var track = ctx.track;
    var shell = ctx.shell;
    var slotList = Array.isArray(slots) ? slots.slice() : [];

    var state = {
      branch: 'booking',
      stepIndex: 0,
      viewMonth: new Date(),
      selectedPopupMonth: '',
      selectedDate: '',
      selectedSlot: null,
      variantQty: {},
      cartSeatsForSelected: 0,
      focusedVariantId: '',
      addonQty: 0,
      wlDayMode: 'not_sure',
      wlPreferredDate: '',
      wlViewMonth: new Date(),
      wlContext: 'no_events',
      waitlistReturnStep: null,
      openPicker: '',
    };

    if (ctx.apiError) {
      state.wlContext = 'api_error';
      root.setAttribute('data-wcf-slots-error', '1');
      if (window.WorkshopCityFlow && typeof window.WorkshopCityFlow.syncSessionsLoadErrorUi === 'function') {
        window.WorkshopCityFlow.syncSessionsLoadErrorUi(root, ctx.apiError);
      }
    }

    var stepsByBranch = function () {
      return BOOKING_STEPS;
    };

    function stepId() {
      return stepsByBranch()[state.stepIndex];
    }

    function stepEl(id) {
      return root.querySelector('[data-wcf-step="' + id + '"]');
    }

    function syncLivePollContext() {
      var CFG = window.WorkshopBookingConfig || window.WorkshopCityConfig;
      if (CFG && typeof CFG.syncPollContext === 'function') CFG.syncPollContext(root);
    }

    root.__wcfGetPollContext = function () {
      if (state.branch !== 'booking') return 'browsing';
      if (state.selectedSlot || hasSelectedVariants(state)) return 'booking';
      return 'browsing';
    };

    function updateTrack() {
      var ids = stepsByBranch();
      var idx = state.stepIndex;
      root.setAttribute('data-wcf-branch', state.branch);
      root.classList.toggle('pcw-root--single', state.branch === 'booking');
      ALL_STEPS.forEach(function (id) {
        var el = stepEl(id);
        if (!el) return;
        el.classList.remove('wcf-step--on');
        el.hidden = true;
      });
      if (track) track.style.transform = 'none';

      if (state.branch === 'booking') {
        ['variants', 'calendar'].forEach(function (id) {
          var el = stepEl(id);
          if (!el) return;
          el.removeAttribute('hidden');
          el.classList.add('wcf-step--on');
        });
        /* SS2: session UI lives under variants; keep calendar step hooked but invisible */
        if (root.classList.contains('pcw-root--ss23')) {
          var calOnly = stepEl('calendar');
          if (calOnly) calOnly.hidden = true;
        }
        root.querySelectorAll('[data-wcf-progress]').forEach(function (p) {
          p.textContent = '';
          p.hidden = true;
        });
        var vwrap = root.querySelector('[data-wcf-variants]');
        if (vwrap) {
          var vn = vwrap.querySelectorAll('.wcf-variant-row').length;
          if (vn) {
            window.requestAnimationFrame(function () {
              applyVariantGridLayout(vwrap, vn);
            });
          }
        }
      } else {
        ids.forEach(function (id, i) {
          var el = stepEl(id);
          if (!el) return;
          if (i === idx) {
            el.removeAttribute('hidden');
            el.classList.add('wcf-step--on');
          }
        });
      }

      root.querySelectorAll('[data-wcf-wl-back]').forEach(function (btn) {
        btn.hidden = !(state.branch === 'waitlist' && !!state.waitlistReturnStep);
      });
      syncCalTimeMobileLayout();
      syncLivePollContext();
    }

    function syncBookingUrl() {
      var F = window.WorkshopCityFlow;
      if (!F || typeof F.updateCityBookingUrl !== 'function') return;
      var step = '';
      if (state.focusedVariantId || totalVariantQty(state.variantQty) > 0) step = 'variants';
      else if (state.selectedDate || state.selectedSlot) step = 'datetime';
      var vid = state.focusedVariantId || '';
      if (!vid) {
        Object.keys(state.variantQty || {}).forEach(function (k) {
          if (!vid && state.variantQty[k] > 0) vid = k;
        });
      }
      window.__WB_LOCK_VARIANT_URL__ = !!vid;
      F.updateCityBookingUrl({
        eventId: state.selectedSlot ? state.selectedSlot.gid || '' : '',
        date: state.selectedDate || '',
        variantId: vid,
        step: step,
      });
    }

    function applyDeepLinkFromUrl() {
      var F = window.WorkshopCityFlow;
      if (!F || typeof F.applyCityWizardRestore !== 'function') return;
      F.applyCityWizardRestore({
        root: root,
        state: state,
        getSlots: function () {
          return slotList;
        },
        slotDateKey: slotDateKey,
        slotBookable: slotBookable,
        stepsByBranch: stepsByBranch,
        goTo: goTo,
        focusVariant: function (id) {
          if (typeof focusVariant === 'function') focusVariant(id);
        },
        render: function () {
          updateTrack();
          if (state.branch === 'booking') {
            renderCalendar();
            if (typeof renderTimePills === 'function') renderTimePills();
            if (typeof renderVariants === 'function') renderVariants();
            if (typeof bindPickerUi === 'function') bindPickerUi();
          }
        },
        syncUrl: syncBookingUrl,
      });
    }

    function goTo(index) {
      var max = stepsByBranch().length - 1;
      state.stepIndex = Math.max(0, Math.min(index, max));
      updateTrack();
      if (state.branch === 'booking') {
        refreshProductVariants();
        renderVariants();
        renderCalendar();
        renderTimePills();
        bindPickerUi();
        syncVariantsNextBtn();
      } else {
        var id = stepId();
        if (id === 'calendar') renderCalendar();
        if (id === 'variants') {
          refreshProductVariants();
          renderVariants();
        }
      }
      syncLivePollContext();
      syncBookingUrl();
    }

    function goBack() {
      if (state.branch === 'waitlist' && state.waitlistReturnStep) {
        var ret = state.waitlistReturnStep;
        state.branch = ret.branch || 'booking';
        state.stepIndex = ret.stepIndex != null ? ret.stepIndex : 0;
        state.wlContext = 'no_events';
        state.waitlistReturnStep = null;
        if (state.branch === 'booking') {
          goTo(0);
        } else {
          updateTrack();
          if (stepId() === 'calendar') renderCalendar();
          if (stepId() === 'variants') renderVariants();
        }
        return;
      }
      if (state.stepIndex > 0) goTo(state.stepIndex - 1);
    }

    /* —— Calendar —— */
    var daysWithEvents = {};
    function rebuildDaysWithEvents() {
      daysWithEvents = {};
      slotList.forEach(function (s) {
        var dk = slotDateKey(s);
        if (!dk) return;
        if (!daysWithEvents[dk]) daysWithEvents[dk] = { bookable: false, any: true };
        if (slotBookable(s)) daysWithEvents[dk].bookable = true;
      });
    }
    rebuildDaysWithEvents();

    function slotsForSelectedDate() {
      return slotsForDateKey(state.selectedDate);
    }

    function slotsForDateKey(dateKey) {
      var sel = normalizeDateKey(dateKey);
      if (!sel) return [];
      var matches = slotList.filter(function (s) {
        return slotDateKey(s) === sel;
      });
      if (matches.length) return matches;
      if (!state.selectedDate && slotList.length <= 4) return slotList.slice();
      return [];
    }

    function firstBookableSlotOnDate(dateKey) {
      var daySlots = slotsForDateKey(dateKey);
      var i;
      for (i = 0; i < daySlots.length; i++) {
        if (slotBookable(daySlots[i])) return daySlots[i];
      }
      return null;
    }

    function applySlotDateToState(slot) {
      var dk = slot ? slotDateKey(slot) : '';
      if (!dk) return;
      state.selectedDate = dk;
      var parts = dk.split('-');
      if (parts.length >= 2) {
        state.viewMonth = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, 1);
      }
    }

    function firstBookableSlotOverall(preferDate) {
      var slot = firstBookableSlotOnDate(preferDate);
      if (slot) return slot;
      var keys = availableDateKeys();
      if (!keys.length) keys = Object.keys(daysWithEvents).sort();
      var i;
      for (i = 0; i < keys.length; i++) {
        slot = firstBookableSlotOnDate(keys[i]);
        if (slot) return slot;
      }
      return null;
    }

    function rematchSelectedSlot() {
      if (!state.selectedSlot || !state.selectedSlot.gid) return;
      var fresh = slotByGid(state.selectedSlot.gid);
      if (fresh) state.selectedSlot = fresh;
    }

    function previewMonthFromAvailable() {
      var keys = availableDateKeys();
      if (!keys.length) keys = Object.keys(daysWithEvents).sort();
      var key = normalizeDateKey(state.selectedDate);
      if (!key || keys.indexOf(key) === -1) key = keys[0] || '';
      if (!key) return;
      var parts = key.split('-');
      if (parts.length >= 2) {
        state.viewMonth = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, 1);
      }
    }

    function selectDateKey(key) {
      state.selectedDate = normalizeDateKey(key) || '';
      state.selectedSlot = null;
      if (state.selectedDate) applySlotDateToState({ date_key: state.selectedDate });
      syncMyrtleBeachVenueAddress(root, data, state.selectedDate);
      syncBookingUrl();
    }

    function ensureDefaultDateAndTime() {
      /* Keep the guest's own picks. Never invent a date or time for them. */
      var keys = availableDateKeys();
      if (!keys.length) keys = Object.keys(daysWithEvents).sort();
      var sel = normalizeDateKey(state.selectedDate);
      if (sel && keys.indexOf(sel) === -1) {
        /* Sold-out-only days stay selectable; clear only when the day vanished. */
        var dayInfo = daysWithEvents[sel];
        if (!(dayInfo && dayInfo.any)) {
          state.selectedDate = '';
          state.selectedSlot = null;
        }
      }
      rematchSelectedSlot();
      if (state.selectedSlot && state.selectedSlot.gid && !slotByGid(state.selectedSlot.gid)) {
        state.selectedSlot = null;
      }
      previewMonthFromAvailable();
      return !!keys.length;
    }

    function slotByGid(gid) {
      gid = String(gid || '');
      if (!gid) return null;
      for (var i = 0; i < slotList.length; i++) {
        if (slotList[i] && slotList[i].gid === gid) return slotList[i];
      }
      return null;
    }

    /** Wall-clock time from ISO — no timezone conversion (10:00Z → 10:00 AM, not local). */
    function extractWallClockTime24(iso) {
      if (iso == null || iso === '') return '';
      var s = String(iso).trim();
      if (!s) return '';
      var sep = s.length > 10 ? s.charAt(10) : '';
      if (sep === 'T' || sep === ' ') {
        if (s.length >= 19) return s.slice(11, 19);
        if (s.length >= 16) return s.slice(11, 16);
      }
      var match = s.match(/\d{1,2}:\d{2}(?::\d{2})?/);
      return match ? match[0] : '';
    }

    function time24hTo12h(s) {
      if (!s || typeof s !== 'string') return '';
      var parts = s.trim().split(':');
      var h = parseInt(parts[0], 10);
      var m = parts.length >= 2 && parts[1] ? parseInt(parts[1], 10) : 0;
      if (isNaN(h) || h < 0 || h > 23 || isNaN(m) || m < 0 || m > 59) return '';
      var hour12 = h % 12;
      if (hour12 === 0) hour12 = 12;
      var ampm = h < 12 ? 'AM' : 'PM';
      var mm = (m < 10 ? '0' : '') + m;
      return (hour12 < 10 ? '0' : '') + hour12 + ':' + mm + ' ' + ampm;
    }

    function formatWallClockTime12(iso) {
      var t24 = extractWallClockTime24(iso);
      return t24 ? time24hTo12h(t24) : '';
    }

    /** Popup workshops: 2.5h when Connect does not send schema_end / duration_hours. */
    var PCW_DEFAULT_DURATION_HOURS = 2.5;

    function slotDurationHours(slot) {
      var raw = slot && slot._raw && typeof slot._raw === 'object' ? slot._raw : null;
      var d =
        slot && slot.duration_hours != null
          ? slot.duration_hours
          : raw && raw.duration_hours != null
            ? raw.duration_hours
            : null;
      var n = Number(d);
      if (isFinite(n) && n > 0) return n;
      return PCW_DEFAULT_DURATION_HOURS;
    }

    function addHoursToTime24(t24, hours) {
      if (!t24 || typeof t24 !== 'string') return '';
      var parts = t24.trim().split(':');
      var h = parseInt(parts[0], 10);
      var m = parts.length >= 2 ? parseInt(parts[1], 10) : 0;
      if (isNaN(h) || isNaN(m)) return '';
      var add = Math.round(Number(hours) * 60);
      if (!isFinite(add)) return '';
      var total = h * 60 + m + add;
      total = ((total % (24 * 60)) + 24 * 60) % (24 * 60);
      var nh = Math.floor(total / 60);
      var nm = total % 60;
      return (nh < 10 ? '0' : '') + nh + ':' + (nm < 10 ? '0' : '') + nm;
    }

    function parseTimeLabelTo24(label) {
      if (!label || typeof label !== 'string') return '';
      var start = label.split(/\s*[-–—]\s*/)[0].trim();
      if (/^\d{1,2}:\d{2}/.test(start) && !/AM|PM/i.test(start)) {
        var p = start.match(/^(\d{1,2}):(\d{2})/);
        if (!p) return '';
        var hh = parseInt(p[1], 10);
        var mm = parseInt(p[2], 10);
        if (isNaN(hh) || isNaN(mm) || hh > 23) return '';
        return (hh < 10 ? '0' : '') + hh + ':' + (mm < 10 ? '0' : '') + mm;
      }
      var m = start.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
      if (!m) m = start.match(/^(\d{1,2})\s*(AM|PM)$/i);
      if (!m) return '';
      var hour = parseInt(m[1], 10);
      var min = m[2] && /\d/.test(m[2]) ? parseInt(m[2], 10) : 0;
      var ap = String(m[m.length - 1]).toUpperCase();
      if (isNaN(hour) || isNaN(min)) return '';
      if (ap === 'PM' && hour < 12) hour += 12;
      if (ap === 'AM' && hour === 12) hour = 0;
      return (hour < 10 ? '0' : '') + hour + ':' + (min < 10 ? '0' : '') + min;
    }

    /** Hub session pills: "10:00 AM - 12:30 PM". */
    function formatRangeFromStartLabel(startLabel) {
      var m = String(startLabel || '').trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
      if (!m) return '';
      var hour = parseInt(m[1], 10);
      var minute = parseInt(m[2], 10);
      var mer = m[3].toUpperCase();
      var hour24 = hour % 12;
      if (mer === 'PM') hour24 += 12;
      var startMin = hour24 * 60 + minute;
      function fmt(total) {
        total = ((total % 1440) + 1440) % 1440;
        var h24 = Math.floor(total / 60);
        var min = total % 60;
        var ap = h24 >= 12 ? 'PM' : 'AM';
        var h12 = h24 % 12;
        if (h12 === 0) h12 = 12;
        return (h12 < 10 ? '0' : '') + h12 + ':' + (min < 10 ? '0' : '') + min + ' ' + ap;
      }
      return fmt(startMin) + ' - ' + fmt(startMin + 150);
    }

    function formatHubSessionRange(label) {
      var s = String(label || '').trim();
      var range = s.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)\s*[-–—]\s*(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
      if (range) {
        function clock(h, min, ap) {
          var hour = parseInt(h, 10);
          var minute = parseInt(min, 10);
          return (hour < 10 ? '0' : '') + hour + ':' + (minute < 10 ? '0' : '') + minute + ' ' + String(ap).toUpperCase();
        }
        return clock(range[1], range[2], range[3]) + ' - ' + clock(range[4], range[5], range[6]);
      }
      return formatRangeFromStartLabel(s) || s;
    }

    function formatSlotTimeRange(slot) {
      if (!slot) return 'Session';
      /* Prefer schema_start/end — else start + duration_hours (default 2.5h). */
      var startWc = formatWallClockTime12(slot.schema_start);
      var endWc = formatWallClockTime12(slot.schema_end);
      if (startWc && endWc) return formatHubSessionRange(startWc + ' - ' + endWc);

      var timeLabel = slot.time_label ? String(slot.time_label).trim() : '';
      if (timeLabel && /-|–|—/.test(timeLabel)) return formatHubSessionRange(timeLabel);

      var start24 = extractWallClockTime24(slot.schema_start) || parseTimeLabelTo24(timeLabel);
      if (start24) {
        var end24 = addHoursToTime24(start24, slotDurationHours(slot));
        startWc = startWc || time24hTo12h(start24);
        endWc = endWc || time24hTo12h(end24);
        if (startWc && endWc) return formatHubSessionRange(startWc + ' - ' + endWc);
      }

      if (timeLabel) {
        var fromLabel = /AM|PM/i.test(timeLabel) ? timeLabel : time24hTo12h(timeLabel) || timeLabel;
        return formatHubSessionRange(fromLabel);
      }
      if (startWc) return formatHubSessionRange(startWc);
      if (slot.display_label) {
        var pipe = String(slot.display_label).split('|');
        var tail = pipe.length > 1 ? pipe[pipe.length - 1].trim() : String(slot.display_label).trim();
        return formatHubSessionRange(tail);
      }
      return 'Session';
    }

    function formatSessionMonthLabel(ym) {
      var s = String(ym || '');
      if (!/^\d{4}-\d{2}$/.test(s)) return s;
      var y = Number(s.slice(0, 4));
      var m = Number(s.slice(5, 7));
      var mon = MONTHS[m - 1] || '';
      return mon ? mon + ' ' + y : s;
    }

    function formatSessionDateLabel(dateKey) {
      var key = normalizeDateKey(dateKey);
      if (!key) return '';
      var parts = key.split('-').map(Number);
      if (parts.length < 3 || !parts[0]) return key;
      var d = new Date(parts[0], parts[1] - 1, parts[2]);
      if (isNaN(d.getTime())) return key;
      var day = parts[2];
      var j = day % 10;
      var k = day % 100;
      var ord =
        j === 1 && k !== 11
          ? day + 'st'
          : j === 2 && k !== 12
            ? day + 'nd'
            : j === 3 && k !== 13
              ? day + 'rd'
              : day + 'th';
      return DOW_PICKER[d.getDay()] + ' ' + (MONTHS[parts[1] - 1] || '') + ' ' + ord;
    }

    function formatSessionDateLabelWrapped(dateKey) {
      return String(formatSessionDateLabel(dateKey) || '').replace(/^(\S+)\s+/, '$1\n');
    }

    function formatSessionTimeLabel(slot) {
      var raw = formatSlotTimeRange(slot) || '';
      var sold = /\s[—–-]\s*Sold out$/i.test(raw);
      var base = sold ? raw.replace(/\s[—–-]\s*Sold out$/i, '').trim() : raw;
      base = compactTimeRangeLabel(base);
      return sold ? base + ' — Sold out' : base;
    }

    /** "02:00 PM – 04:30 PM" → "2:00–4:30 PM" (keeps dash, saves width for 3-up). */
    function compactTimeRangeLabel(label) {
      var s = String(label || '').trim();
      if (!s) return s;
      var m = s.match(
        /^0?(\d{1,2}):(\d{2})\s*(AM|PM)\s*[–—-]\s*0?(\d{1,2}):(\d{2})\s*(AM|PM)$/i
      );
      if (!m) {
        return s
          .replace(/\s*[–—-]\s*/g, '–')
          .replace(/\b0(\d):/g, '$1:');
      }
      var a = m[1] + ':' + m[2];
      var b = m[4] + ':' + m[5];
      var ap1 = m[3].toUpperCase();
      var ap2 = m[6].toUpperCase();
      if (ap1 === ap2) return a + '–' + b + ' ' + ap2;
      return a + ' ' + ap1 + '–' + b + ' ' + ap2;
    }

    function formatSessionTimeLabelWrapped(slot) {
      var raw = formatSlotTimeRange(slot) || '';
      var sold = /\s[—–-]\s*Sold out$/i.test(raw);
      var base = sold ? raw.replace(/\s[—–-]\s*Sold out$/i, '').trim() : raw;
      var m = base.match(
        /^0?(\d{1,2}):(\d{2})\s*(AM|PM)\s*[–—-]\s*0?(\d{1,2}):(\d{2})\s*(AM|PM)$/i
      );
      var two;
      if (m) {
        var a = Number(m[1]) + ':' + m[2] + ' ' + m[3].toUpperCase();
        var b = Number(m[4]) + ':' + m[5] + ' ' + m[6].toUpperCase();
        two = a + '\n' + b;
      } else {
        var parts = base.split(/\s*[–—-]\s*/);
        two =
          parts.length >= 2
            ? parts[0].trim().replace(/\b0(\d):/g, '$1:') +
              '\n' +
              parts.slice(1).join(' - ').trim().replace(/\b0(\d):/g, '$1:')
            : compactTimeRangeLabel(base);
      }
      return two;
    }

    function isMobileSessionPills() {
      return !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
    }

    /** Mobile: start/end stacked inside pill. Desktop: one line. */
    function formatSessionTimeLabelForPill(slot) {
      if (isMobileSessionPills()) return formatSessionTimeLabelWrapped(slot);
      return formatSlotTimeRange(slot) || '';
    }

    function stripSoldOutPillSuffix(label) {
      return String(label || '')
        .replace(/\nSold out$/i, '')
        .replace(/\s[—–-]\s*Sold out$/i, '')
        .trim();
    }

    /** Sold-out pills: "Sold out" on top, current label below (strikethrough via CSS). */
    function setSessionPillLabel(btn, labelText, soldOut) {
      if (!btn) return;
      var label = stripSoldOutPillSuffix(labelText);
      if (!soldOut) {
        btn.textContent = label;
        return;
      }
      btn.innerHTML =
        '<span class="pcw-pill__soldout" aria-hidden="true">Sold out</span>' +
        '<span class="pcw-pill__label">' +
        escapeHtml(label).replace(/\n/g, '<br>') +
        '</span>';
    }

    function ymKeyFromDateKey(dateKey) {
      var key = normalizeDateKey(dateKey);
      return key && key.length >= 7 ? key.slice(0, 7) : '';
    }

    function uniqueMonthKeysFromDates(keys) {
      var seen = Object.create(null);
      var out = [];
      (keys || []).forEach(function (dk) {
        var ym = ymKeyFromDateKey(dk);
        if (!ym || seen[ym]) return;
        seen[ym] = true;
        out.push(ym);
      });
      return out.sort();
    }

    function pickFirstKey(list, preferred) {
      var arr = list || [];
      var pref = String(preferred || '');
      if (pref && arr.indexOf(pref) >= 0) return pref;
      return arr.length ? String(arr[0]) : '';
    }


    function formatSlotOptionText(slot) {
      var label = formatSlotTimeRange(slot);
      if (!slotBookable(slot)) return label + ' — Sold out';
      return label;
    }

    function stripSoldOutSuffix(text) {
      return String(text || '').replace(/\s*[—–-]\s*Sold out\s*$/i, '').trim();
    }

    function selectedSlotUnbookable() {
      /* Same source as pill badges / missingBookingChoices — not capacity-only. */
      var slot = state.selectedSlot;
      return !!(slot && !slotBookable(slot));
    }

    function calDateKey(y, m, d) {
      return (
        y +
        '-' +
        String(m + 1).padStart(2, '0') +
        '-' +
        String(d).padStart(2, '0')
      );
    }

    function buildCalPadCellHtml() {
      return (
        '<span class="wcf-cal-day-wrap" aria-hidden="true">' +
        '<span class="wcf-cal-day wcf-cal-day--empty"></span></span>'
      );
    }

    function buildCalDayHtml(dayNum, key, opts) {
      opts = opts || {};
      var cls = 'wcf-cal-day';
      if (!opts.info) cls += ' wcf-cal-day--muted';
      else {
        cls += ' wcf-cal-day--has-event';
        if (!opts.bookable) cls += ' wcf-cal-day--soldout-only';
      }
      if (opts.selected) cls += ' wcf-cal-day--selected';
      var disabled = !opts.info ? ' disabled' : '';
      return (
        '<span class="wcf-cal-day-wrap"><button type="button" class="' +
        cls +
        '" data-wcf-cal-day="' +
        key +
        '"' +
        disabled +
        '>' +
        dayNum +
        '</button></span>'
      );
    }

    function updateCalendarContinueBtn(step) {
      var calStep = step || stepEl('calendar');
      if (!calStep) return;
      var cont = calStep.querySelector('[data-wcf-action="to-variants"]');
      if (!cont) return;
      var ready = !!(state.selectedDate && state.selectedSlot && slotBookable(state.selectedSlot));
      // Stays clickable so pressing it can explain what is still missing.
      cont.disabled = false;
      cont.classList.toggle('is-incomplete', !ready);
    }

    function closeCalTimeDd() {
      var dd = root.querySelector('[data-wcf-cal-time-dd]');
      if (!dd) return;
      var panel = dd.querySelector('[data-wcf-cal-time-dd-panel]');
      var btn = dd.querySelector('[data-wcf-cal-time-dd-btn]');
      if (panel) panel.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
      dd.classList.remove('is-open');
    }

    function openCalTimeDd() {
      if (!isMobileViewport()) return;
      var dd = root.querySelector('[data-wcf-cal-time-dd]');
      if (!dd) return;
      var panel = dd.querySelector('[data-wcf-cal-time-dd-panel]');
      var btn = dd.querySelector('[data-wcf-cal-time-dd-btn]');
      if (!panel || !btn || btn.disabled) return;
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      dd.classList.add('is-open');
      /* Scroll the panel by hand: scrollIntoView() also scrolls the page behind it. */
      var selected = panel.querySelector('.wcf-cal-time__dd-opt.is-selected');
      if (selected) {
        var top = selected.offsetTop;
        var bottom = top + selected.offsetHeight;
        if (top < panel.scrollTop) panel.scrollTop = top;
        else if (bottom > panel.scrollTop + panel.clientHeight) {
          panel.scrollTop = bottom - panel.clientHeight;
        }
      }
    }

    function syncCalTimeDdFromSelect(step) {
      var dd = step && step.querySelector('[data-wcf-cal-time-dd]');
      var select = step && step.querySelector('[data-wcf-time-select]');
      if (!dd || !select) return;

      var btn = dd.querySelector('[data-wcf-cal-time-dd-btn]');
      var panel = dd.querySelector('[data-wcf-cal-time-dd-panel]');
      var frameIcon = step && step.querySelector('[data-wcf-cal-time-frame-soldout]');
      if (!btn || !panel) return;

      btn.disabled = select.disabled;
      var selectedOpt = select.options[select.selectedIndex];
      var hasValue = !!select.value;
      var selectedSlot = hasValue ? slotByGid(select.value) : null;
      var selectedSoldOut = !!(selectedSlot && !slotBookable(selectedSlot));
      var btnLabel =
        hasValue && selectedOpt && selectedOpt.textContent
          ? stripSoldOutSuffix(selectedOpt.textContent) || selectedOpt.textContent
          : 'Select a time';
      btn.innerHTML =
        '<span class="wcf-cal-time__dd-label">' +
        escapeHtml(btnLabel) +
        '</span>' +
        (selectedSoldOut ? '<span class="wcf-cal-time__soldout-icon">' + WCF_SOLD_OUT_SVG + '</span>' : '');
      btn.classList.toggle('is-placeholder', !hasValue);
      btn.classList.toggle('is-soldout', selectedSoldOut);
      if (frameIcon) {
        frameIcon.innerHTML = WCF_SOLD_OUT_SVG;
        frameIcon.hidden = !selectedSoldOut;
      }

      panel.innerHTML = '';
      var title = document.createElement('p');
      title.className = 'wcf-cal-time__dd-panel-title';
      title.textContent = 'Select a time';
      panel.appendChild(title);

      for (var i = 0; i < select.options.length; i++) {
        var opt = select.options[i];
        if (!opt.value) continue;
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'wcf-cal-time__dd-opt';
        item.setAttribute('role', 'option');
        item.setAttribute('data-gid', opt.value);
        var optSlot = slotByGid(opt.value);
        var optSoldOut = !!(optSlot && !slotBookable(optSlot));
        item.innerHTML =
          '<span class="wcf-cal-time__dd-label">' +
          escapeHtml(opt.textContent) +
          '</span>' +
          (optSoldOut ? '<span class="wcf-cal-time__soldout-icon">' + WCF_SOLD_OUT_SVG + '</span>' : '');
        if (opt.selected) item.classList.add('is-selected');
        if (optSoldOut || /sold out/i.test(opt.textContent)) item.classList.add('is-soldout');
        item.addEventListener('click', function (ev) {
          var gid = ev.currentTarget.getAttribute('data-gid');
          if (!gid) return;
          select.value = gid;
          /* Close first: the change handler re-renders and would reopen the menu. */
          closeCalTimeDd();
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
        panel.appendChild(item);
      }
    }

    function bindCalTimeMobileDd() {
      var dd = root.querySelector('[data-wcf-cal-time-dd]');
      if (!dd || dd.__wcfDdBound) return;
      dd.__wcfDdBound = true;

      var btn = dd.querySelector('[data-wcf-cal-time-dd-btn]');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        if (!isMobileViewport()) return;
        e.preventDefault();
        e.stopPropagation();
        var panel = dd.querySelector('[data-wcf-cal-time-dd-panel]');
        if (panel && !panel.hidden) closeCalTimeDd();
        else openCalTimeDd();
      });

      if (!root.__wcfCalTimeDdDocClose) {
        root.__wcfCalTimeDdDocClose = true;
        document.addEventListener('click', function (e) {
          if (!isMobileViewport()) return;
          if (e.target.closest('[data-wcf-cal-time-dd]')) return;
          closeCalTimeDd();
        });
      }
    }

    function renderCalTimeNativeSelect(step, daySlots, sel) {
      var select = step.querySelector('[data-wcf-time-select]');
      if (!select) return;

      if (!sel) {
        select.disabled = true;
        select.innerHTML = '<option value="">Select a date first</option>';
        return;
      }

      select.innerHTML = '';
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = daySlots.length ? 'Select a time' : 'No sessions this day';
      select.appendChild(placeholder);

      daySlots.forEach(function (slot) {
        var opt = document.createElement('option');
        opt.value = slot.gid || '';
        opt.textContent = formatSlotOptionText(slot);
        if (state.selectedSlot && state.selectedSlot.gid === slot.gid) opt.selected = true;
        select.appendChild(opt);
      });

      select.disabled = !daySlots.length;
    }

    function syncPickerFilledState() {
      var dateTrigger = root.querySelector('[data-pcw-date-trigger]');
      var timeTrigger = root.querySelector('[data-pcw-time-trigger]');
      if (dateTrigger) {
        dateTrigger.classList.toggle('is-filled', !!normalizeDateKey(state.selectedDate));
      }
      if (timeTrigger) {
        var hasTime = !!(state.selectedSlot && normalizeDateKey(state.selectedDate));
        var soldOut = !!(hasTime && !slotBookable(state.selectedSlot));
        timeTrigger.classList.toggle('is-filled', hasTime && !soldOut);
        timeTrigger.classList.toggle('is-soldout', soldOut);
        if (soldOut) timeTrigger.setAttribute('aria-invalid', 'true');
        else timeTrigger.removeAttribute('aria-invalid');
      }
    }

    function syncDateTriggerLabel() {
      var label = root.querySelector('[data-pcw-date-label]');
      if (!label) return;
      var sel = normalizeDateKey(state.selectedDate);
      label.textContent = sel ? formatDateTriggerLabel(sel) : 'Pick a date';
      syncPickerFilledState();
      scheduleFitPickerLabels(root);
    }

    function formatSlotStartLabel(slot) {
      if (!slot) return 'Time';
      var startWc = formatWallClockTime12(slot.schema_start);
      if (startWc) return startWc;
      var timeLabel = slot.time_label ? String(slot.time_label).trim() : '';
      if (timeLabel) {
        var startFromLabel = timeLabel.split(/\s*[-–]\s*/)[0].trim();
        if (/AM|PM/i.test(startFromLabel)) return startFromLabel;
        return time24hTo12h(startFromLabel) || startFromLabel;
      }
      var range = formatSlotTimeRange(slot);
      if (!range || range === 'Session') return 'Time';
      return String(range).split(/\s*[-–]\s*/)[0].trim() || range;
    }

    /** Trigger pill: "10:00 AM – 12:30 PM" (end from schema_end / duration). */
    function formatSlotTriggerLabel(slot) {
      var label = formatSlotTimeRange(slot);
      if (!label || label === 'Session') return 'Time';
      return label;
    }

    function syncTimeTriggerLabel() {
      var label = root.querySelector('[data-pcw-time-label]');
      if (!label) return;
      if (!normalizeDateKey(state.selectedDate)) {
        label.textContent = 'Pick a time';
        syncPickerFilledState();
        scheduleFitPickerLabels(root);
        return;
      }
      label.textContent = state.selectedSlot ? formatSlotTriggerLabel(state.selectedSlot) : 'Pick a time';
      syncPickerFilledState();
      scheduleFitPickerLabels(root);
    }

    function currentOpenPicker() {
      if (root.querySelector('[data-pcw-date-picker].is-open')) return 'date';
      if (root.querySelector('[data-pcw-time-picker].is-open')) return 'time';
      return state.openPicker || '';
    }

    function stickyReservePx() {
      var reserve = 16;
      var sticky = document.querySelector('.sticky_book_wizard');
      if (sticky) {
        var rect = sticky.getBoundingClientRect();
        if (rect.height > 0 && rect.bottom > 0) reserve += Math.ceil(rect.height);
      }
      return reserve;
    }

    /** The menu is centred on its trigger; nudge it back inside the viewport. */
    function clampPickerMenu(menu) {
      if (!menu || menu.hidden) return;
      menu.style.setProperty('--pcw-menu-shift', '0px');
      var margin = 12;
      var rect = menu.getBoundingClientRect();
      var vw = document.documentElement.clientWidth || window.innerWidth || 0;
      var shift = 0;
      if (rect.left < margin) shift = margin - rect.left;
      else if (rect.right > vw - margin) shift = vw - margin - rect.right;
      if (shift) menu.style.setProperty('--pcw-menu-shift', Math.round(shift) + 'px');
    }

    function revealPickerMenu(menu) {
      if (!menu || menu.hidden) return;
      window.requestAnimationFrame(function () {
        clampPickerMenu(menu);
        var rect = menu.getBoundingClientRect();
        var viewportH = window.innerHeight || document.documentElement.clientHeight;
        var overflow = rect.bottom - (viewportH - stickyReservePx());
        if (overflow > 8) {
          window.scrollBy({ top: overflow, behavior: 'smooth' });
        }
      });
    }

    function setPickerOpen(kind, open, opts) {
      var picker = root.querySelector(kind === 'date' ? '[data-pcw-date-picker]' : '[data-pcw-time-picker]');
      if (!picker) return;
      var trigger = picker.querySelector(kind === 'date' ? '[data-pcw-date-trigger]' : '[data-pcw-time-trigger]');
      var menu = picker.querySelector(kind === 'date' ? '[data-pcw-date-menu]' : '[data-pcw-time-menu]');
      var wasOpen = picker.classList.contains('is-open');
      if (menu) menu.hidden = !open;
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      picker.classList.toggle('is-open', !!open);
      if (open) {
        state.openPicker = kind;
        if (!wasOpen && !(opts && opts.silent)) revealPickerMenu(menu);
        else clampPickerMenu(menu);
      } else if (state.openPicker === kind) {
        state.openPicker = '';
      }
    }

    function closeAllPickers() {
      setPickerOpen('date', false);
      setPickerOpen('time', false);
    }

    function refreshOpenPickerPills() {
      /* SS23 pills are always visible — live capacity must repaint them without a click. */
      if (isPcwSs23() && root.querySelector('[data-pcw-month-pills], [data-pcw-popup-session]')) {
        refreshSessionPills({ applyAuto: false });
        return;
      }
      var open = currentOpenPicker();
      if (!open) return;
      if (open === 'date') renderDatePills();
      if (open === 'time') renderTimePills();
      setPickerOpen(open, true, { silent: true });
    }

    function isPcwSs23() {
      return !!(root && root.classList && root.classList.contains('pcw-root--ss23'));
    }

    function bindPickerUi() {
      if (root.__pcwPickersBound) return;
      root.__pcwPickersBound = true;

      if (isPcwSs23()) {
        /* Center SS2: always-visible month/date/time pills under designs. */
        refreshSessionPills({ applyAuto: true });
        return;
      }

      var dateTrigger = root.querySelector('[data-pcw-date-trigger]');
      var timeTrigger = root.querySelector('[data-pcw-time-trigger]');

      if (dateTrigger) {
        dateTrigger.addEventListener('click', function (e) {
          var wrap = dateTrigger.closest('[data-pcw-date-picker]');
          if (wrap && wrap.__pcwSwiped) return;
          e.preventDefault();
          e.stopPropagation();
          var menu = root.querySelector('[data-pcw-date-menu]');
          var willOpen = !menu || menu.hidden;
          setPickerOpen('time', false);
          setPickerOpen('date', willOpen);
        });
      }

      if (timeTrigger) {
        timeTrigger.addEventListener('click', function (e) {
          var wrap = timeTrigger.closest('[data-pcw-time-picker]');
          if (wrap && wrap.__pcwSwiped) return;
          e.preventDefault();
          e.stopPropagation();
          if (!normalizeDateKey(state.selectedDate)) {
            setPickerOpen('date', true);
            setPickerOpen('time', false);
            return;
          }
          var menu = root.querySelector('[data-pcw-time-menu]');
          var willOpen = !menu || menu.hidden;
          setPickerOpen('date', false);
          setPickerOpen('time', willOpen);
        });
      }

      document.addEventListener('click', function (e) {
        if (!e.target || !document.contains(e.target)) return;
        if (!root.contains(e.target)) {
          closeAllPickers();
          return;
        }
        if (!e.target.closest('[data-pcw-date-picker]') && !e.target.closest('[data-pcw-time-picker]')) {
          closeAllPickers();
        }
      });

      bindHorizontalSwipe(root.querySelector('[data-pcw-date-picker]'), function (dir) {
        stopVariantAttention(root.querySelector('.pcw-variants-rail'));
        var keys = availableDateKeys();
        if (!keys.length) return;
        var cur = normalizeDateKey(state.selectedDate);
        var i = keys.indexOf(cur);
        var next = i < 0 ? (dir > 0 ? keys[0] : keys[keys.length - 1]) : keys[i + dir];
        if (!next) return;
        selectDateKey(next);
        renderDatePills();
        renderTimePills();
        renderCalendar();
        renderCalTimeSelect();
        if (state.selectedSlot) refreshCartSeatsForSelected(state.selectedSlot);
        updateBookingSummary();
      });
      bindHorizontalSwipe(root.querySelector('[data-pcw-time-picker]'), function (dir) {
        stopVariantAttention(root.querySelector('.pcw-variants-rail'));
        var slots = slotsForSelectedDate().filter(slotBookable);
        if (!slots.length) return;
        var gid = state.selectedSlot && state.selectedSlot.gid;
        var i = -1;
        for (var n = 0; n < slots.length; n++) {
          if (slots[n] && slots[n].gid === gid) {
            i = n;
            break;
          }
        }
        var next = i < 0 ? slots[0] : slots[i + dir];
        if (!next) return;
        onTimeSlotChosen(next, stepEl('variants') || stepEl('calendar'));
        renderTimePills();
        syncTimeTriggerLabel();
        updateBookingSummary();
      });
    }

    function syncVariantsNavBtns() {
      var wrap = root.querySelector('[data-wcf-variants]');
      var nextBtn = root.querySelector('[data-pcw-variants-next]');
      var prevBtn = root.querySelector('[data-pcw-variants-prev]');
      if (!wrap) return;

      function scrollStep() {
        return Math.max(140, Math.floor(wrap.clientWidth * 0.7));
      }

      function updateNavVisibility() {
        var maxScroll = Math.max(0, wrap.scrollWidth - wrap.clientWidth);
        var canScroll = maxScroll > 8;
        var atStart = wrap.scrollLeft <= 4;
        var atEnd = wrap.scrollLeft >= maxScroll - 4;
        if (prevBtn) prevBtn.hidden = !canScroll || atStart;
        if (nextBtn) nextBtn.hidden = !canScroll || atEnd;
      }

      if (nextBtn && !nextBtn.__pcwBound) {
        nextBtn.__pcwBound = true;
        nextBtn.addEventListener('click', function () {
          if (typeof wrap.__pcwStepBy === 'function') wrap.__pcwStepBy(1);
          else wrap.scrollBy({ left: scrollStep(), behavior: 'smooth' });
        });
      }
      if (prevBtn && !prevBtn.__pcwBound) {
        prevBtn.__pcwBound = true;
        prevBtn.addEventListener('click', function () {
          if (typeof wrap.__pcwStepBy === 'function') wrap.__pcwStepBy(-1);
          else wrap.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
        });
      }
      if (!wrap.__pcwNavScrollBound) {
        wrap.__pcwNavScrollBound = true;
        wrap.addEventListener('scroll', updateNavVisibility, { passive: true });
        window.addEventListener('resize', updateNavVisibility);
      }
      bindVariantRailMotion(wrap);
      updateNavVisibility();
    }

    function syncVariantsNextBtn() {
      syncVariantsNavBtns();
    }


    function sessionPillHosts() {
      return {
        month: root.querySelector('[data-pcw-month-pills]'),
        date: root.querySelector('[data-wcf-date-pills]'),
        time: root.querySelector('[data-wcf-time-pills]'),
        hint: root.querySelector('[data-wcf-cal-time-hint]')
      };
    }

    function syncSessionPillNav(host) {
      if (!host) return;
      var clip = host.closest('.pcw-popup-session__pills-clip') || host.parentElement;
      if (!clip) return;
      var prev = clip.querySelector('[data-pcw-session-prev]');
      var next = clip.querySelector('[data-pcw-session-next]');
      var pillCount = host.querySelectorAll('.pcw-session-pill, .pcw-date-pill, .pcw-time-pill').length;
      var max = Math.max(0, host.scrollWidth - host.clientWidth);
      var row = host.closest('[data-pcw-session-row]');
      var rowKind = row && row.getAttribute('data-pcw-session-row');
      /* Mobile month/time are equal-width buttons (no carousel). */
      var mobileNoCarousel =
        isMobileSessionPills() && (rowKind === 'month' || rowKind === 'time');
      var overflowAt = rowKind === 'date' ? 2 : 3;
      var show = !mobileNoCarousel && (pillCount > overflowAt || max > 1);
      if (prev) prev.hidden = !show;
      if (next) next.hidden = !show;
      if (!host.__pcwSessionNavBound) {
        host.__pcwSessionNavBound = true;
        host.addEventListener(
          'scroll',
          function () {
            var m = Math.max(0, host.scrollWidth - host.clientWidth);
            var left = host.scrollLeft || 0;
            if (prev) prev.classList.toggle('is-ghost-dim', left <= 2);
            if (next) next.classList.toggle('is-ghost-dim', left >= m - 2);
          },
          { passive: true }
        );
      }
    }

    function refreshSessionPills(opts) {
      opts = opts || {};
      var hosts = sessionPillHosts();
      if (!hosts.month || !hosts.date || !hosts.time) return;

      /* Silent live repaints must not yank carousel scroll. */
      var keepScroll = opts.applyAuto === false;
      var scrollLeft = {
        month: keepScroll ? hosts.month.scrollLeft || 0 : 0,
        date: keepScroll ? hosts.date.scrollLeft || 0 : 0,
        time: keepScroll ? hosts.time.scrollLeft || 0 : 0,
      };

      var allDates = allSessionDateKeys();
      var months = uniqueMonthKeysFromDates(allDates);
      var month = pickFirstKey(
        months,
        opts.preferredMonth || state.selectedPopupMonth || ymKeyFromDateKey(opts.preferredDate || state.selectedDate)
      );
      state.selectedPopupMonth = month;

      hosts.month.innerHTML = '';
      months.forEach(function (ym) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pcw-session-pill' + (ym === month ? ' is-selected' : '');
        btn.setAttribute('role', 'option');
        btn.setAttribute('aria-selected', ym === month ? 'true' : 'false');
        btn.dataset.value = ym;
        btn.textContent = formatSessionMonthLabel(ym);
        btn.addEventListener('click', function () {
          state.selectedPopupMonth = ym;
          state.selectedDate = '';
          state.selectedSlot = null;
          refreshSessionPills({ preferredMonth: ym, applyAuto: true });
          updateBookingSummary();
        });
        hosts.month.appendChild(btn);
      });

      var dates = month
        ? allDates.filter(function (dk) {
            return ymKeyFromDateKey(dk) === month;
          })
        : [];
      var bookableDates = dates.filter(function (dk) {
        return !dateKeySoldOutOnly(dk);
      });
      if (opts.applyAuto !== false) {
        var preferredDate = opts.preferredDate != null ? opts.preferredDate : state.selectedDate;
        var preferredNorm = preferredDate ? normalizeDateKey(preferredDate) : '';
        if (preferredNorm && bookableDates.indexOf(preferredNorm) >= 0) {
          state.selectedDate = preferredNorm;
        } else if (preferredNorm && dates.indexOf(preferredNorm) >= 0 && opts.preferredDate != null) {
          // Explicit user pick (may be sold-out-only).
          state.selectedDate = preferredNorm;
        } else {
          state.selectedDate = pickFirstKey(bookableDates, '');
        }
      } else if (state.selectedDate && dates.indexOf(normalizeDateKey(state.selectedDate)) === -1) {
        state.selectedDate = '';
        state.selectedSlot = null;
      }
      var dateKey = normalizeDateKey(state.selectedDate);

      hosts.date.innerHTML = '';
      if (!dates.length) {
        hosts.date.innerHTML = '<p class="pcw-dates__empty">No sessions available</p>';
      } else {
        dates.forEach(function (dk) {
          var soldOutOnly = dateKeySoldOutOnly(dk);
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className =
            'pcw-session-pill pcw-date-pill' +
            (dk === dateKey ? ' is-selected' : '') +
            (soldOutOnly ? ' is-soldout' : '');
          btn.setAttribute('role', 'option');
          btn.setAttribute('data-wcf-date-pill', dk);
          btn.setAttribute('aria-selected', dk === dateKey ? 'true' : 'false');
          if (soldOutOnly) btn.setAttribute('aria-label', formatSessionDateLabel(dk) + ' — Sold out');
          setSessionPillLabel(btn, formatSessionDateLabel(dk), soldOutOnly);
          btn.addEventListener('click', function () {
            selectDateKey(dk);
            refreshSessionPills({ preferredDate: dk, preferredMonth: ymKeyFromDateKey(dk), applyAuto: true });
            updateBookingSummary();
          });
          hosts.date.appendChild(btn);
        });
      }

      var daySlots = dateKey ? slotsForDateKey(dateKey) : [];
      var preferredGid = String(
        opts.preferredGid != null
          ? opts.preferredGid
          : state.selectedSlot && state.selectedSlot.gid
            ? state.selectedSlot.gid
            : ''
      );
      var bookable = daySlots.filter(slotBookable);
      var picked = null;
      for (var i = 0; i < daySlots.length; i++) {
        if (String(daySlots[i].gid) === preferredGid) {
          picked = daySlots[i];
          break;
        }
      }
      if (!picked && opts.applyAuto !== false && bookable.length) picked = bookable[0];
      if (picked) {
        state.selectedSlot = picked;
      } else if (opts.applyAuto !== false || !preferredGid) {
        state.selectedSlot = null;
      }

      hosts.time.innerHTML = '';
      if (!dateKey) {
        hosts.time.innerHTML = '<p class="pcw-times__empty">Select a date first</p>';
      } else if (!daySlots.length) {
        hosts.time.innerHTML = '<p class="pcw-times__empty">No sessions this day</p>';
      } else {
        daySlots.forEach(function (slot) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'pcw-session-pill pcw-time-pill';
          btn.setAttribute('role', 'option');
          if (slot.gid) btn.setAttribute('data-pcw-slot-gid', String(slot.gid));
          var ok = slotBookable(slot);
          if (!ok) btn.classList.add('is-soldout');
          if (state.selectedSlot && state.selectedSlot.gid === slot.gid) btn.classList.add('is-selected');
          setSessionPillLabel(btn, formatSessionTimeLabelForPill(slot), !ok);
          btn.setAttribute(
            'aria-selected',
            state.selectedSlot && state.selectedSlot.gid === slot.gid ? 'true' : 'false'
          );
          if (!ok) btn.setAttribute('aria-label', (formatSlotTimeRange(slot) || 'Session') + ' — Sold out');
          btn.addEventListener('click', function () {
            onTimeSlotChosen(slot, stepEl('variants') || root, { skipCalendar: true });
            selectTimePillInPlace(slot);
            updateBookingSummary();
          });
          hosts.time.appendChild(btn);
        });
      }

      if (hosts.hint) {
        hosts.hint.textContent = '';
        hosts.hint.hidden = true;
      }
      syncSessionPillNav(hosts.month);
      syncSessionPillNav(hosts.date);
      syncSessionPillNav(hosts.time);
      if (keepScroll) {
        hosts.month.scrollLeft = scrollLeft.month;
        hosts.date.scrollLeft = scrollLeft.date;
        hosts.time.scrollLeft = scrollLeft.time;
      }
      syncMyrtleBeachVenueAddress(root, data, dateKey);
      syncDateTriggerLabel();
      syncTimeTriggerLabel();
      updateAddCartBtn();
      if (state.selectedSlot) refreshCartSeatsForSelected(state.selectedSlot);
      scheduleFitSessionPills(true);
    }

    function selectTimePillInPlace(slot) {
      if (!slot) return;
      state.selectedSlot = slot;
      var hosts = sessionPillHosts();
      if (!hosts.time) return;
      hosts.time.querySelectorAll('.pcw-time-pill').forEach(function (btn) {
        var gid = btn.getAttribute('data-pcw-slot-gid');
        var on = gid && String(gid) === String(slot.gid);
        btn.classList.toggle('is-selected', !!on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      syncTimeTriggerLabel();
      updateAddCartBtn();
      refreshCartSeatsForSelected(slot);
    }

    function fitSessionPills(force) {
      if (!isPcwSs23()) return;
      var session = root.querySelector('[data-pcw-popup-session]');
      if (!session) return;

      function fitGroup(selector, allowWrap) {
        var pills = session.querySelectorAll(selector);
        if (!pills.length) return;
        if (!force) {
          var allDone = true;
          pills.forEach(function (btn) {
            if (btn.getAttribute('data-pcw-fit') !== '1') allDone = false;
          });
          if (allDone) return;
        }

        var sizes = [];
        pills.forEach(function (btn) {
          var sold = btn.classList.contains('is-soldout');
          btn.removeAttribute('data-pcw-fit');
          btn.style.removeProperty('font-size');
          btn.style.setProperty('white-space', sold ? 'normal' : 'nowrap', 'important');
          if (allowWrap && btn.classList.contains('pcw-date-pill')) {
            var dk = btn.getAttribute('data-wcf-date-pill');
            if (dk) setSessionPillLabel(btn, formatSessionDateLabel(dk), sold);
          }
          if (btn.classList.contains('pcw-time-pill')) {
            var gid = btn.getAttribute('data-pcw-slot-gid');
            var daySlots = slotsForDateKey(state.selectedDate) || [];
            for (var i = 0; i < daySlots.length; i++) {
              if (String(daySlots[i].gid) === String(gid)) {
                setSessionPillLabel(btn, formatSessionTimeLabelForPill(daySlots[i]), sold);
                if (!sold) {
                  btn.style.setProperty(
                    'white-space',
                    isMobileSessionPills() ? 'pre-line' : 'nowrap',
                    'important'
                  );
                }
                break;
              }
            }
          }
          var base = parseFloat(window.getComputedStyle(btn).fontSize) || 14;
          var next = base;
          var min = allowWrap ? 9 : Math.min(base, 13);
          var guard = 0;
          while (guard++ < 40 && next > min && btn.scrollWidth > btn.clientWidth + 1) {
            next -= 0.5;
            btn.style.setProperty('font-size', next + 'px', 'important');
          }
          sizes.push(next);

          if (allowWrap && btn.classList.contains('pcw-date-pill') && btn.scrollWidth > btn.clientWidth + 1) {
            var dk2 = btn.getAttribute('data-wcf-date-pill');
            if (dk2) {
              setSessionPillLabel(btn, formatSessionDateLabelWrapped(dk2), sold);
              btn.style.setProperty('white-space', sold ? 'normal' : 'pre-line', 'important');
              btn.style.removeProperty('font-size');
              base = parseFloat(window.getComputedStyle(btn).fontSize) || 14;
              next = base;
              guard = 0;
              while (guard++ < 24 && next > min && btn.scrollWidth > btn.clientWidth + 1) {
                next -= 0.5;
                btn.style.setProperty('font-size', next + 'px', 'important');
              }
              sizes[sizes.length - 1] = next;
            }
          }
          if (
            allowWrap &&
            btn.classList.contains('pcw-time-pill') &&
            isMobileSessionPills() &&
            (btn.scrollWidth > btn.clientWidth + 1 || btn.scrollHeight > btn.clientHeight + 1)
          ) {
            btn.style.removeProperty('font-size');
            base = parseFloat(window.getComputedStyle(btn).fontSize) || 14;
            next = base;
            guard = 0;
            while (
              guard++ < 28 &&
              next > min &&
              (btn.scrollWidth > btn.clientWidth + 1 || btn.scrollHeight > btn.clientHeight + 1)
            ) {
              next -= 0.5;
              btn.style.setProperty('font-size', next + 'px', 'important');
            }
            sizes[sizes.length - 1] = next;
          }
        });

        var shared = Math.min.apply(null, sizes);
        pills.forEach(function (btn) {
          btn.style.setProperty('font-size', shared + 'px', 'important');
          btn.setAttribute('data-pcw-fit', '1');
        });
      }

      fitGroup(
        '.pcw-popup-session__row[data-pcw-session-row="month"] .pcw-session-pill',
        true
      );
      fitGroup(
        '.pcw-popup-session__row[data-pcw-session-row="date"] .pcw-date-pill, .pcw-popup-session__row[data-pcw-session-row="date"] .pcw-session-pill',
        true
      );
      fitGroup(
        '.pcw-popup-session__row[data-pcw-session-row="time"] .pcw-time-pill, .pcw-popup-session__row[data-pcw-session-row="time"] .pcw-session-pill',
        true
      );
    }

    function scheduleFitSessionPills(force) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          fitSessionPills(!!force);
        });
      });
    }

    function renderTimePills() {
      if (isPcwSs23() && root.querySelector('[data-pcw-month-pills]')) {
        refreshSessionPills({ applyAuto: false });
        return;
      }
      var wrap = root.querySelector('[data-wcf-time-pills]');
      var hint = root.querySelector('[data-wcf-cal-time-hint]');
      if (!wrap) return;

      var sel = normalizeDateKey(state.selectedDate);
      var daySlots = slotsForSelectedDate();
      wrap.innerHTML = '';

      if (!sel) {
        wrap.innerHTML = '<p class="pcw-times__empty">Select a date first</p>';
        if (hint) {
          hint.textContent = '';
          hint.hidden = true;
        }
        syncTimeTriggerLabel();
        updateAddCartBtn();
        return;
      }

      if (!daySlots.length) {
        wrap.innerHTML = '<p class="pcw-times__empty">No sessions this day</p>';
        if (hint) {
          hint.textContent = 'Pick another date with a session.';
          hint.hidden = false;
        }
        syncTimeTriggerLabel();
        updateAddCartBtn();
        return;
      }

      if (hint) {
        hint.textContent = '';
        hint.hidden = true;
      }

      daySlots.forEach(function (slot) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pcw-time-pill';
        btn.setAttribute('role', 'option');
        var bookable = slotBookable(slot);
        if (!bookable) btn.classList.add('is-soldout');
        if (state.selectedSlot && state.selectedSlot.gid === slot.gid) btn.classList.add('is-selected');
        /* Badge markup is SS23-only; picker dropdown keeps class + plain label. */
        if (isPcwSs23()) {
          setSessionPillLabel(btn, formatSlotTimeRange(slot), !bookable);
        } else {
          btn.textContent = formatSlotTimeRange(slot) || '';
        }
        if (!bookable) {
          btn.setAttribute('aria-label', (formatSlotTimeRange(slot) || 'Session') + ' — Sold out');
        }
        btn.setAttribute(
          'aria-selected',
          state.selectedSlot && state.selectedSlot.gid === slot.gid ? 'true' : 'false'
        );
        btn.addEventListener('click', function () {
          onTimeSlotChosen(slot, step);
          syncTimeTriggerLabel();
          closeAllPickers();
        });
        wrap.appendChild(btn);
      });
      syncTimeTriggerLabel();
      updateAddCartBtn();
    }

    function renderCalTimeSelect() {
      renderTimePills();
    }

    /** Popup single-page: keep time picker inside the calendar body pickers row. */
    function syncCalTimeMobileLayout() {
      var step = stepEl('calendar');
      if (!step) return;
      root.classList.remove('wcf-root--calendar-mobile');
      if (step.querySelector('.pcw-pickers')) return;
      var calTime = step.querySelector('[data-wcf-cal-time]');
      var body = step.querySelector('.wcf-step__body--calendar');
      if (calTime && body && calTime.parentElement !== body) body.appendChild(calTime);
    }

    function clampVariantQtyToCapacity() {
      var max = maxBookableQty(state, root);
      var total = totalVariantQty(state.variantQty);
      if (total <= max) return false;
      var over = total - max;
      var changed = false;
      Object.keys(state.variantQty).forEach(function (k) {
        if (over <= 0) return;
        var q = state.variantQty[k] || 0;
        var drop = Math.min(q, over);
        setVariantQty(state, k, q - drop);
        over -= drop;
        if (drop > 0) changed = true;
      });
      return changed;
    }

    function refreshCartSeatsForSelected(slot) {
      var gid = slot && slot.gid;
      var F = window.WorkshopCityFlow;
      if (!gid || !F || typeof F.fetchCartSeatsForEvent !== 'function') {
        state.cartSeatsForSelected = 0;
        var changedNoCart = clampVariantQtyToCapacity();
        if (changedNoCart) syncVariantRowsState();
        updateBookingSummary();
        return Promise.resolve(0);
      }
      return F.fetchCartSeatsForEvent(gid).then(function (n) {
        var prevSeats = state.cartSeatsForSelected || 0;
        state.cartSeatsForSelected = n || 0;
        var changed = clampVariantQtyToCapacity();
        if (changed) {
          syncVariantRowsState();
        }
        if (changed || prevSeats !== state.cartSeatsForSelected) {
          updateAddCartBtn();
        }
        updateBookingSummary();
        return state.cartSeatsForSelected;
      });
    }

    function ensureFreshSlotForAdd(slot) {
      var gates = readGatesConfig(root);
      if (gates.live_fetch_before_add === false) return Promise.resolve(slot);

      var API = window.WorkshopCityEvents;
      if (!API || typeof API.fetchLiveState !== 'function' || !slot || !slot.gid) {
        return Promise.resolve(slot);
      }

      var url =
        typeof API.resolveLiveStateApiUrl === 'function'
          ? API.resolveLiveStateApiUrl(root, resolveLiveStateCatalogUrl(root))
          : resolveLiveStateCatalogUrl(root);

      return API.fetchLiveState([slot.gid], { url: url, root: root })
        .then(function (r) {
          var merged =
            typeof API.mergeSlotWithLive === 'function'
              ? API.mergeSlotWithLive(slot, (r && r.states) || {}, r && r.as_of)
              : slot;
          if (!merged) return null;
          state.selectedSlot = merged;
          for (var i = 0; i < slotList.length; i++) {
            if (slotList[i].gid === merged.gid) {
              slotList[i] = merged;
              break;
            }
          }
          return merged;
        })
        .catch(function () {
          var CFG = window.WorkshopBookingConfig || window.WorkshopCityConfig;
          if (CFG && CFG.TEMP_DISABLE_CAPACITY_VALIDATE === true) return slot;
          if (CFG && typeof CFG.verifySoftMode === 'function' && CFG.verifySoftMode()) return slot;
          var maxStale =
            gates.max_stale_ms_before_add != null ? Number(gates.max_stale_ms_before_add) : 15000;
          if (slot.capacity_as_of && Number.isFinite(maxStale) && maxStale > 0) {
            var age = Date.now() - new Date(slot.capacity_as_of).getTime();
            if (Number.isFinite(age) && age > maxStale) return null;
          }
          return slot;
        });
    }

    function cartEventGidFromItem(item) {
      var F = window.WorkshopCityFlow;
      if (F && typeof F.eventGidFromCartLine === 'function') {
        return F.eventGidFromCartLine(item);
      }
      if (!item || !item.properties) return '';
      return String(item.properties._event_metaobject_gid || item.properties._event_id || '').trim();
    }

    function cartSeatsForSelectedPool(slot) {
      var API = window.WorkshopCityEvents;
      var gid = slot && slot.gid;
      if (!API || typeof API.fetchLiveState !== 'function' || !gid) {
        return Promise.resolve(state.cartSeatsForSelected || 0);
      }
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(rootPath + 'cart.js', { credentials: 'same-origin' })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .catch(function () {
          return null;
        })
        .then(function (cart) {
          if (!cart || !Array.isArray(cart.items)) return state.cartSeatsForSelected || 0;
          var seen = {};
          var gids = [];
          cart.items.forEach(function (item) {
            var itemGid = cartEventGidFromItem(item);
            if (itemGid && !seen[itemGid]) {
              seen[itemGid] = true;
              gids.push(itemGid);
            }
          });
          if (!seen[gid]) gids.push(gid);
          var url =
            typeof API.resolveLiveStateApiUrl === 'function'
              ? API.resolveLiveStateApiUrl(root, resolveLiveStateCatalogUrl(root))
              : resolveLiveStateCatalogUrl(root);
          return API.fetchLiveState(gids, { url: url, root: root }).then(function (r) {
            var states = (r && r.states) || {};
            var selectedLive = states[gid] || {};
            var selectedCanonical = String(
              selectedLive.canonical_event_id || slot.canonical_event_id || gid
            ).trim();
            var total = 0;
            cart.items.forEach(function (item) {
              if (item && item.properties && item.properties._workshop_addon === 'true') return;
              var itemGid = cartEventGidFromItem(item);
              if (!itemGid) return;
              var itemLive = states[itemGid] || {};
              var itemCanonical = String(itemLive.canonical_event_id || itemGid).trim();
              if (itemCanonical === selectedCanonical) total += item.quantity || 0;
            });
            return total;
          });
        })
        .catch(function () {
          return state.cartSeatsForSelected || 0;
        });
    }

    function validateCapacityBeforeAdd(slot, selectedQty) {
      var API = window.WorkshopCityEvents;
      var CFG = window.WorkshopBookingConfig || window.WorkshopCityConfig;
      var addGateEnabled =
        CFG && typeof CFG.validateGateEnabled === 'function' && CFG.validateGateEnabled(root, 'add_to_cart');
      // A missing event id is a broken selection, not a verification failure:
      // letting it through would add an unstamped line. Always block it.
      if (!slot || !slot.gid) {
        if (!addGateEnabled) return Promise.resolve({ blocked: false, slot: slot });
        return Promise.resolve({
          blocked: true,
          slot: slot,
          message: 'Please pick a date and time for this workshop before adding it to your cart.',
        });
      }
      if (!API || typeof API.fetchCapacityValidate !== 'function') {
        if (addGateEnabled && !(CFG && typeof CFG.validateFailModeOpen === 'function' && CFG.validateFailModeOpen(root))) {
          return Promise.resolve({
            blocked: true,
            slot: slot,
            message: 'We could not verify workshop capacity right now. Please try again.',
          });
        }
        return Promise.resolve({ blocked: false, slot: slot });
      }
      if (!addGateEnabled) {
        return Promise.resolve({ blocked: false, slot: slot });
      }
      return cartSeatsForSelectedPool(slot).then(function (poolQty) {
        return API.fetchCapacityValidate(root, {
          event_id: slot.gid,
          requested_total_qty: (poolQty || 0) + (selectedQty || 0),
          intent: 'add_to_cart',
        });
      }).then(function (result) {
        if (!result) {
          var CFG = window.WorkshopBookingConfig || window.WorkshopCityConfig;
          if (CFG && typeof CFG.validateFailModeOpen === 'function' && CFG.validateFailModeOpen(root)) {
            return { blocked: false, slot: slot };
          }
          if (CFG && typeof CFG.validateGateEnabled === 'function' && !CFG.validateGateEnabled(root, 'add_to_cart')) {
            return { blocked: false, slot: slot };
          }
          return {
            blocked: true,
            slot: slot,
            message: 'We could not verify workshop capacity right now. Please try again.',
          };
        }
        if (result.capacity_remaining != null && result.capacity_remaining !== '') {
          slot.capacity_remaining = result.capacity_remaining;
        }
        if (result.display_status != null && result.display_status !== '') {
          slot.display_status = result.display_status;
        }
        if (result.status != null && result.status !== '') {
          slot.status = result.status;
        }
        if (result.canonical_event_id) slot.canonical_event_id = result.canonical_event_id;
        if (result.capacity_group_id != null) slot.capacity_group_id = result.capacity_group_id;
        if (result.allowed === false) {
          return {
            blocked: true,
            slot: slot,
            message:
              result.message ||
              (Number(result.capacity_remaining) > 0
                ? 'Only ' + result.capacity_remaining + ' seat(s) remain for this session.'
                : 'This session is sold out.'),
          };
        }
        return { blocked: false, slot: slot };
      }).catch(function () {
        var CFG = window.WorkshopBookingConfig || window.WorkshopCityConfig;
        if (CFG && typeof CFG.validateFailModeOpen === 'function' && CFG.validateFailModeOpen(root)) {
          return { blocked: false, slot: slot };
        }
        return {
          blocked: true,
          slot: slot,
          message: 'We could not verify workshop capacity right now. Please try again.',
        };
      });
    }

    function onTimeSlotChosen(slot, step, opts) {
      opts = opts || {};
      if (slot && slot.gid) {
        for (var si = 0; si < slotList.length; si++) {
          if (slotList[si] && slotList[si].gid === slot.gid) {
            slot = slotList[si];
            break;
          }
        }
      }
      if (slotBookable(slot)) {
        var dk = slotDateKey(slot);
        if (dk) state.selectedDate = dk;
        state.selectedSlot = slot;
        relaxNativeVariantInventory(root, data, true);
        refreshCartSeatsForSelected(slot);
        syncLivePollContext();
        if (!opts.skipCalendar) renderCalendar();
        updateBookingSummary();
        syncBookingUrl();
        return;
      }
      state.cartSeatsForSelected = 0;
      state.selectedDate = slotDateKey(slot) || state.selectedDate;
      state.selectedSlot = slot || null;
      if (state.branch !== 'booking') state.branch = 'booking';
      if (!opts.skipCalendar) {
        renderCalendar();
        renderTimePills();
      }
      syncTimeTriggerLabel();
      updateBookingSummary();
      syncBookingUrl();
    }

    function appendTimeSlotButton(container, slot, step, compact) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wcf-time' + (compact ? ' wcf-time--compact' : '');
      btn.setAttribute('role', 'listitem');
      var label = slot.time_label || slot.display_label || 'Session';
      var bookable = slotBookable(slot);
      if (!bookable) btn.classList.add('is-soldout');
      if (state.selectedSlot && state.selectedSlot.gid === slot.gid) btn.classList.add('is-selected');
      btn.innerHTML = buildTimeSlotHtml(label, bookable, slot);
      btn.setAttribute('aria-pressed', state.selectedSlot && state.selectedSlot.gid === slot.gid ? 'true' : 'false');
      btn.addEventListener('click', function () {
        onTimeSlotChosen(slot, step);
      });
      container.appendChild(btn);
    }

    function availableDateKeys() {
      return Object.keys(daysWithEvents)
        .filter(function (k) {
          return daysWithEvents[k] && daysWithEvents[k].bookable;
        })
        .sort();
    }

    /** Dates with any session (includes sold-out-only days) for ss23 date pills. */
    function allSessionDateKeys() {
      return Object.keys(daysWithEvents)
        .filter(function (k) {
          return daysWithEvents[k] && daysWithEvents[k].any;
        })
        .sort();
    }

    function dateKeySoldOutOnly(dk) {
      var info = daysWithEvents[normalizeDateKey(dk)];
      return !!(info && info.any && !info.bookable);
    }

    function renderDatePills() {
      if (isPcwSs23() && root.querySelector('[data-pcw-month-pills]')) {
        refreshSessionPills({ applyAuto: false });
        return;
      }
      var wrap = root.querySelector('[data-wcf-date-pills]');
      if (!wrap) return;

      var keys = availableDateKeys();
      wrap.innerHTML = '';

      if (!keys.length) {
        wrap.innerHTML = '<p class="pcw-dates__empty">No sessions available</p>';
        syncDateTriggerLabel();
        syncTimeTriggerLabel();
        return;
      }

      if (state.selectedDate && keys.indexOf(normalizeDateKey(state.selectedDate)) === -1) {
        state.selectedDate = '';
        state.selectedSlot = null;
      }

      keys.forEach(function (key) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pcw-date-pill';
        btn.setAttribute('role', 'option');
        btn.setAttribute('data-wcf-date-pill', key);
        if (normalizeDateKey(state.selectedDate) === key) btn.classList.add('is-selected');
        btn.textContent = formatDatePillLabel(key);
        btn.setAttribute(
          'aria-selected',
          normalizeDateKey(state.selectedDate) === key ? 'true' : 'false'
        );
        btn.addEventListener('click', function () {
          selectDateKey(key);
          renderDatePills();
          renderTimePills();
          updateBookingSummary();
          closeAllPickers();
        });
        wrap.appendChild(btn);
      });
      syncDateTriggerLabel();
      syncTimeTriggerLabel();
    }

    function renderCalendar() {
      var open = currentOpenPicker();
      renderDatePills();
      renderCalTimeSelect();
      if (open) setPickerOpen(open, true, { silent: true });
    }

    function renderWlCalendar() {
      var y = state.wlViewMonth.getFullYear();
      var m = state.wlViewMonth.getMonth();
      var label = root.querySelector('[data-wcf-wl-cal-month-label]');
      if (label) label.textContent = MONTHS[m] + ' ' + y;

      var dowEl = root.querySelector('[data-wcf-wl-cal-dow]');
      if (dowEl) {
        dowEl.innerHTML = DOW_SHORT.map(function (d) {
          return '<span class="wcf-cal-dow">' + d + '</span>';
        }).join('');
      }

      var grid = root.querySelector('[data-wcf-wl-cal-grid]');
      if (!grid) return;
      var first = new Date(y, m, 1);
      var startPad = first.getDay();
      var daysInMonth = new Date(y, m + 1, 0).getDate();
      var html = '';
      var i;
      for (i = 0; i < startPad; i++) {
        html += '<span class="wcf-cal-day wcf-cal-day--empty"></span>';
      }
      for (var d = 1; d <= daysInMonth; d++) {
        var key =
          y +
          '-' +
          String(m + 1).padStart(2, '0') +
          '-' +
          String(d).padStart(2, '0');
        var cls = 'wcf-cal-day wcf-cal-day--pickable';
        if (state.wlDayMode === 'date' && state.wlPreferredDate === key) cls += ' wcf-cal-day--selected';
        html +=
          '<span class="wcf-cal-day-wrap"><button type="button" class="' +
          cls +
          '" data-wcf-wl-cal-day="' +
          key +
          '">' +
          d +
          '</button></span>';
      }
      grid.innerHTML = html;

      var notSureBtn = root.querySelector('[data-wcf-action="wl-not-sure"]');
      if (notSureBtn) {
        var active = state.wlDayMode === 'not_sure';
        notSureBtn.classList.toggle('is-active', active);
        notSureBtn.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    }

    root.querySelector('[data-wcf-wl-cal-prev]')?.addEventListener('click', function () {
      state.wlViewMonth = new Date(state.wlViewMonth.getFullYear(), state.wlViewMonth.getMonth() - 1, 1);
      renderWlCalendar();
    });
    root.querySelector('[data-wcf-wl-cal-next]')?.addEventListener('click', function () {
      state.wlViewMonth = new Date(state.wlViewMonth.getFullYear(), state.wlViewMonth.getMonth() + 1, 1);
      renderWlCalendar();
    });
    bindHorizontalSwipe(
      root.querySelector('[data-wcf-wl-cal-grid]') &&
        (root.querySelector('[data-wcf-wl-cal-grid]').closest('.wcf-cal-block, .wcf-wl-cal') ||
          root.querySelector('[data-wcf-wl-cal-grid]')),
      function (dir) {
        state.wlViewMonth = new Date(state.wlViewMonth.getFullYear(), state.wlViewMonth.getMonth() + dir, 1);
        renderWlCalendar();
      }
    );

    root.addEventListener('click', function (e) {
      var wlBtn = e.target.closest('[data-wcf-wl-cal-day]');
      if (!wlBtn) return;
      state.wlPreferredDate = wlBtn.getAttribute('data-wcf-wl-cal-day') || '';
      state.wlDayMode = 'date';
      renderWlCalendar();
    });

    /* —— Times —— */
    function renderTimes() {
      var step = stepEl('time');
      if (!step) return;
      var sub = step.querySelector('[data-wcf-time-sub]');
      var sel = normalizeDateKey(state.selectedDate);
      var wrap = step.querySelector('[data-wcf-times]');
      if (!wrap) return;
      var daySlots = slotsForSelectedDate();
      var allDateKeys = collectSlotDateKeys(slotList);
      var nearbyKeys = sel ? nearbyDateKeysOrdered(sel, allDateKeys) : [];
      var hasNearby = nearbyKeys.length > 0;

      if (sub) {
        if (!sel) sub.textContent = 'Select a session time';
        else if (hasNearby) sub.textContent = 'Sessions on your date, or choose a nearby day on the right';
        else sub.textContent = 'Tap a session to continue';
      }

      wrap.innerHTML = '';
      wrap.classList.toggle('wcf-times--empty', !daySlots.length && !hasNearby);
      wrap.classList.toggle('wcf-times--split', hasNearby);

      if (!daySlots.length && !hasNearby) {
        wrap.innerHTML =
          '<div class="wcf-times-empty">' +
          '<span class="wcf-times-empty__icon" aria-hidden="true">' +
          WCF_CLOCK_SVG +
          '</span>' +
          '<p class="wcf-times-empty__title">No sessions this day</p>' +
          '<p class="wcf-times-empty__text">Pick another date on the calendar or go back.</p>' +
          '</div>';
        var backBtn = step.querySelector('[data-wcf-action="back"]');
        if (backBtn) backBtn.focus();
        var toVarEmpty = step.querySelector('[data-wcf-action="to-variants"]');
        if (toVarEmpty) {
          toVarEmpty.disabled = false;
          toVarEmpty.classList.add('is-incomplete');
        }
        return;
      }

      var layout = document.createElement('div');
      layout.className = 'wcf-times-layout';

      var primary = document.createElement('div');
      primary.className = 'wcf-times-primary';

      if (sel) {
        var dateBar = document.createElement('div');
        dateBar.className = 'wcf-times-date';
        dateBar.innerHTML =
          '<span class="wcf-times-date__label">Selected date</span>' +
          '<span class="wcf-times-date__value">' +
          escapeHtml(formatSelectedDateLabel(sel)) +
          '</span>';
        primary.appendChild(dateBar);
      }

      if (daySlots.length) {
        var grid = document.createElement('div');
        grid.className = 'wcf-times-grid';
        grid.setAttribute('role', 'list');
        daySlots.forEach(function (slot) {
          appendTimeSlotButton(grid, slot, step, false);
        });
        primary.appendChild(grid);
      } else {
        var dayEmpty = document.createElement('div');
        dayEmpty.className = 'wcf-times-day-empty';
        dayEmpty.innerHTML =
          '<p class="wcf-times-day-empty__title">No sessions on this day</p>' +
          '<p class="wcf-times-day-empty__text">Choose a session on a nearby date' +
          (hasNearby ? ' →' : ' on the calendar.') +
          '</p>';
        primary.appendChild(dayEmpty);
      }

      layout.appendChild(primary);

      if (hasNearby) {
        var aside = document.createElement('aside');
        aside.className = 'wcf-times-nearby';
        aside.setAttribute('aria-label', 'Sessions on nearby dates');
        var asideTitle = document.createElement('p');
        asideTitle.className = 'wcf-times-nearby__title';
        asideTitle.textContent = 'Nearby dates';
        aside.appendChild(asideTitle);

        var groups = document.createElement('div');
        groups.className = 'wcf-times-nearby__groups';

        nearbyKeys.forEach(function (dk) {
          var otherSlots = slotsForDateKey(dk);
          if (!otherSlots.length) return;
          var group = document.createElement('section');
          group.className = 'wcf-times-day-group';
          group.setAttribute('data-wcf-nearby-date', dk);

          var head = document.createElement('header');
          head.className = 'wcf-times-day-group__head';
          head.textContent = formatShortDateLabel(dk);
          group.appendChild(head);

          var dayGrid = document.createElement('div');
          dayGrid.className = 'wcf-times-day-grid';
          dayGrid.setAttribute('role', 'list');
          otherSlots.forEach(function (slot) {
            appendTimeSlotButton(dayGrid, slot, step, true);
          });
          group.appendChild(dayGrid);
          groups.appendChild(group);
        });

        if (groups.childElementCount) {
          aside.appendChild(groups);
          layout.appendChild(aside);
        }
      }

      wrap.appendChild(layout);
      var toVar = step.querySelector('[data-wcf-action="to-variants"]');
      if (toVar) {
        toVar.disabled = false;
        toVar.classList.toggle('is-incomplete', !state.selectedSlot);
      }
    }

    function computeBookingTotalCents() {
      var total = 0;
      Object.keys(state.variantQty || {}).forEach(function (vidKey) {
        var q = state.variantQty[vidKey] || 0;
        if (!q) return;
        var v = variants.find(function (x) {
          return vQtyKey(x.id) === vQtyKey(vidKey);
        });
        if (v) total += (Number(v.price) || 0) * q;
      });
      if (state.addonQty > 0 && addonVariantId) {
        total += parseInt(root.getAttribute('data-addon-price-cents') || '0', 10) * state.addonQty;
      }
      return total;
    }

    function computeBookingCompareTotalCents() {
      var compareTotal = 0;
      var priceTotal = 0;
      var hasCompare = false;
      Object.keys(state.variantQty || {}).forEach(function (vidKey) {
        var q = state.variantQty[vidKey] || 0;
        if (!q) return;
        var v = variants.find(function (x) {
          return vQtyKey(x.id) === vQtyKey(vidKey);
        });
        if (!v) return;
        var price = Number(v.price) || 0;
        var compare = Number(v.compare_at_price) || 0;
        priceTotal += price * q;
        if (compare > price) {
          hasCompare = true;
          compareTotal += compare * q;
        } else {
          compareTotal += price * q;
        }
      });
      if (state.addonQty > 0 && addonVariantId) {
        var addonCents =
          parseInt(root.getAttribute('data-addon-price-cents') || '0', 10) * state.addonQty;
        priceTotal += addonCents;
        compareTotal += addonCents;
      }
      return hasCompare && compareTotal > priceTotal ? compareTotal : 0;
    }

    function formatBookingTotalHtml() {
      var price = computeBookingTotalCents();
      var compare = computeBookingCompareTotalCents();
      var current =
        '<span class="wcf-price-current">' + escapeHtml(formatMoney(price)) + '</span>';
      if (!compare) return current;
      return (
        '<s class="wcf-price-compare">' +
        escapeHtml(formatMoney(compare)) +
        '</s> ' +
        current
      );
    }

    function updateBookingSummary() {
      var sub = root.querySelector('[data-wcf-booking-sub]');
      if (sub) {
        if (state.selectedSlot) {
          sub.textContent = formatBookingSubLabel(state.selectedSlot);
        } else {
          sub.textContent = '';
        }
      }
      var totEl = root.querySelector('[data-wcf-total]');
      if (totEl) totEl.innerHTML = formatBookingTotalHtml();
      renderAddonUi();
      updateAddCartBtn();
    }

    /** What the guest still has to pick before the booking can be added. */
    function missingBookingChoices() {
      var missing = [];
      var qty = totalVariantQty(state.variantQty);
      if (!hasSelectedVariants(state) || qty <= 0) missing.push('variant');
      if (!normalizeDateKey(state.selectedDate)) missing.push('date');
      if (!state.selectedSlot || !slotBookable(state.selectedSlot)) missing.push('time');
      return missing;
    }

    function bookingNoticeEl() {
      if (root.__pcwNoticeEl && root.__pcwNoticeEl.isConnected) return root.__pcwNoticeEl;
      root.__pcwNoticeEl = root.querySelector('[data-pcw-booking-notice]');
      return root.__pcwNoticeEl;
    }

    function variantChoiceLabel() {
      var type = '';
      if (window.WorkshopCityFlow && typeof window.WorkshopCityFlow.resolveWorkshopType === 'function') {
        type = window.WorkshopCityFlow.resolveWorkshopType(root, data);
      }
      var title = String(root.getAttribute('data-product-title') || '').toLowerCase();
      var handle = String(root.getAttribute('data-product-handle') || type || '').toLowerCase();
      if (type === 'ceramic' || title.indexOf('ceramic') >= 0 || handle.indexOf('ceramic') >= 0) {
        return 'a ceramic style';
      }
      return 'a lamp style';
    }

    function missingChoicesMessage(missing) {
      missing = missing || [];
      if (
        selectedSlotUnbookable() &&
        missing.length === 1 &&
        missing[0] === 'time'
      ) {
        return 'This session is sold out — pick another time.';
      }
      var labels = { variant: variantChoiceLabel(), date: 'a date', time: 'a time' };
      var names = missing.map(function (k) {
        return labels[k] || k;
      });
      var list =
        names.length > 1 ? names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1] : names[0];
      return 'Please select ' + list + ' to continue.';
    }

    /** The toast fades out, but the red markers stay until the gap is filled. */
    function resetVariantMotionStyles(rail) {
      var moving = rail.querySelectorAll('.wcf-variant-row, .wcf-qty--variant, .wcf-variant-card__media');
      var i;
      for (i = 0; i < moving.length; i++) {
        moving[i].style.animation = 'none';
        moving[i].style.transform = 'none';
      }
      void rail.offsetWidth;
      for (i = 0; i < moving.length; i++) {
        moving[i].style.animation = '';
        moving[i].style.transform = '';
      }
    }

    function stopVariantAttention(rail) {
      if (!rail) return;
      rail.classList.remove('pcw-needs-motion');
      if (rail.__pcwMotionTimer) {
        window.clearTimeout(rail.__pcwMotionTimer);
        rail.__pcwMotionTimer = 0;
      }
      resetVariantMotionStyles(rail);
    }

    function bindVariantAttentionStop(rail) {
      if (!rail || rail.__pcwMotionBound) return;
      rail.__pcwMotionBound = true;
      var stop = function () {
        if (!rail.classList.contains('pcw-needs-motion')) return;
        stopVariantAttention(rail);
      };
      root.addEventListener('touchstart', stop, { passive: true, capture: true });
      root.addEventListener('touchmove', stop, { passive: true, capture: true });
      root.addEventListener('pointerdown', stop, { passive: true, capture: true });
    }

    function playVariantAttention(rail) {
      if (!rail) return;
      bindVariantAttentionStop(rail);
      stopVariantAttention(rail);
      void rail.offsetWidth;
      rail.classList.add('pcw-needs-motion');
      rail.__pcwMotionTimer = window.setTimeout(function () {
        rail.__pcwMotionTimer = 0;
        stopVariantAttention(rail);
      }, 800);
    }

    function playFieldAttention(node) {
      if (!node) return;
      node.classList.remove('pcw-needs-motion');
      if (node.__pcwMotionTimer) {
        window.clearTimeout(node.__pcwMotionTimer);
        node.__pcwMotionTimer = 0;
      }
      void node.offsetWidth;
      node.classList.add('pcw-needs-motion');
      node.__pcwMotionTimer = window.setTimeout(function () {
        node.__pcwMotionTimer = 0;
        node.classList.remove('pcw-needs-motion');
      }, 800);
    }

    function applyNeedsChoiceMarks(missing, opts) {
      var map = {
        variant: ['.pcw-variants-rail'],
        date: ['[data-pcw-date-trigger]', '.wcf-cal-sheet'],
        time: ['[data-pcw-time-trigger]', '[data-wcf-cal-time-dd-btn]'],
      };
      Object.keys(map).forEach(function (key) {
        var on = missing.indexOf(key) !== -1;
        map[key].forEach(function (sel) {
          var node = root.querySelector(sel);
          if (!node) return;
          node.classList.toggle('pcw-needs-choice', on);
          if (on && opts && opts.play && key !== 'variant') playFieldAttention(node);
        });
      });
      var rail = root.querySelector('.pcw-variants-rail');
      if (missing.indexOf('variant') !== -1) {
        if (opts && opts.play) playVariantAttention(rail);
      } else {
        stopVariantAttention(rail);
      }
      var hint = root.querySelector('[data-pcw-booking-hint]');
      if (hint) {
        hint.textContent = missing.length ? missingChoicesMessage(missing) : '';
        hint.hidden = !missing.length;
        hint.classList.toggle(
          'is-soldout-warn',
          selectedSlotUnbookable() &&
            missing.length === 1 &&
            missing[0] === 'time'
        );
      }
    }

    function hideBookingNotice() {
      var el = bookingNoticeEl();
      if (root.__pcwNoticeTimer) {
        window.clearTimeout(root.__pcwNoticeTimer);
        root.__pcwNoticeTimer = 0;
      }
      if (root.__pcwNoticeTrack) {
        window.removeEventListener('scroll', root.__pcwNoticeTrack);
        window.removeEventListener('resize', root.__pcwNoticeTrack);
        root.__pcwNoticeTrack = null;
      }
      if (!el) return;
      el.classList.remove('is-visible');
      el.hidden = true;
      el.textContent = '';
    }

    function clearBookingNotice() {
      hideBookingNotice();
      root.__pcwBookAttempted = false;
      applyNeedsChoiceMarks([]);
    }

    /** Phones centre it on screen; wider layouts sit it over the variant rail. */
    function positionBookingNotice(el) {
      var rail = root.querySelector('.pcw-variants-rail');
      if (!rail || !window.matchMedia('(min-width: 750px)').matches) {
        el.style.removeProperty('left');
        el.style.removeProperty('top');
        return;
      }
      var box = rail.getBoundingClientRect();
      el.style.top = Math.round(box.top + box.height / 2) + 'px';
      el.style.left = Math.round(box.left + box.width / 2) + 'px';
      var margin = 12;
      var self = el.getBoundingClientRect();
      var vw = document.documentElement.clientWidth || window.innerWidth || 0;
      if (self.left < margin) el.style.left = Math.round(margin + self.width / 2) + 'px';
      else if (self.right > vw - margin) el.style.left = Math.round(vw - margin - self.width / 2) + 'px';
    }

    function showBookingNotice(missing) {
      var el = bookingNoticeEl();
      root.__pcwBookAttempted = true;
      if (el) {
        // Float it on the body so no wizard ancestor can clip or offset the toast.
        if (el.parentElement !== document.body) document.body.appendChild(el);
        el.textContent = missingChoicesMessage(missing);
        el.hidden = false;
        positionBookingNotice(el);
        // The wizard is scrolled into view right after, so keep the anchor current.
        if (!root.__pcwNoticeTrack) {
          root.__pcwNoticeTrack = function () {
            positionBookingNotice(el);
          };
          window.addEventListener('scroll', root.__pcwNoticeTrack, { passive: true });
          window.addEventListener('resize', root.__pcwNoticeTrack);
        }
        window.requestAnimationFrame(function () {
          el.classList.add('is-visible');
        });
        if (root.__pcwNoticeTimer) window.clearTimeout(root.__pcwNoticeTimer);
        root.__pcwNoticeTimer = window.setTimeout(hideBookingNotice, 3600);
      }
      applyNeedsChoiceMarks(missing, { play: true });
      var focus = root.querySelector('.pcw-needs-choice');
      if (focus && focus.scrollIntoView) focus.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    function updateAddCartBtn() {
      var btn = root.querySelector('[data-wcf-action="add-cart"]');
      if (btn && btn.getAttribute('data-wcf-busy') === 'true') return;
      var max = maxBookableQty(state, root);
      var qty = totalVariantQty(state.variantQty);
      var missing = missingBookingChoices();
      var canAdd = !missing.length && qty <= max && max > 0;
      // The button stays clickable so an incomplete booking can explain itself.
      if (btn) {
        btn.disabled = false;
        btn.classList.toggle('is-incomplete', !canAdd);
      }
      if (canAdd) clearBookingNotice();
      else if (root.__pcwBookAttempted) applyNeedsChoiceMarks(missing);
      else applyNeedsChoiceMarks([]);
      var clearBtn = root.querySelector('[data-wcf-action="clear-selection"]');
      if (clearBtn) {
        clearBtn.disabled = !hasSelectedVariants(state) && !(state.addonQty > 0);
      }
    }

    function setAddCartButtonState(btn, stateName, label) {
      var buttons = [];
      if (btn) buttons.push(btn);
      document.querySelectorAll('[data-pcw-lb-add], [data-wcf-action="add-cart"]').forEach(function (el) {
        if (buttons.indexOf(el) === -1) buttons.push(el);
      });
      if (!buttons.length) return;

      buttons.forEach(function (el) {
        if (!el.__wcfDefaultLabel) el.__wcfDefaultLabel = el.textContent || 'Add to cart';
        if (stateName === 'idle') {
          el.removeAttribute('data-wcf-busy');
          el.removeAttribute('data-wcf-state');
          el.classList.remove('is-loading', 'is-added');
          el.textContent = el.__wcfDefaultLabel;
          return;
        }
        el.disabled = true;
        el.setAttribute('data-wcf-busy', 'true');
        el.setAttribute('data-wcf-state', stateName);
        el.classList.toggle('is-loading', stateName === 'loading');
        el.classList.toggle('is-added', stateName === 'added');
        el.textContent = label || (stateName === 'added' ? 'Added' : 'Adding...');
      });
      if (stateName === 'idle') updateAddCartBtn();
    }

    function clearBookingSelection() {
      state.variantQty = {};
      state.focusedVariantId = '';
      state.addonQty = 0;
      renderVariants();
      updateBookingSummary();
    }

    function findWizardVariant(id) {
      var key = vQtyKey(id);
      var sectionRoot = getSectionRoot(root, data);
      var styleIdx =
        data.styleOptionIndex != null
          ? Number(data.styleOptionIndex)
          : pickStyleOptionIndex(sectionRoot, variants);
      var list = variantsForStylePicker(variants, sectionRoot);
      for (var i = 0; i < list.length; i++) {
        if (vQtyKey(list[i].id) === key) return list[i];
      }
      return (
        variants.find(function (x) {
          return vQtyKey(x.id) === key;
        }) || null
      );
    }

    function focusVariant(id, variant) {
      id = vQtyKey(id);
      if (!id || state.focusedVariantId === id) return false;
      state.focusedVariantId = id;
      var v = variant || findWizardVariant(id);
      if (v) syncVariantToPdp(root, data, v);
      syncBookingUrl();
      return true;
    }

    function syncVariantRowsState() {
      var step = stepEl('variants');
      if (!step) return;
      step.querySelectorAll('[data-wcf-variant-qty]').forEach(function (qtyBox) {
        var id = vQtyKey(qtyBox.getAttribute('data-variant-id') || '');
        var q = getVariantQty(state, id);
        var row = qtyBox.closest('.wcf-variant-row');
        if (row) {
          row.classList.toggle('is-active', q > 0);
          row.classList.toggle('is-preview', state.focusedVariantId === id && q <= 0);
        }
        qtyBox.setAttribute('data-qty-mode', q > 0 ? 'step' : 'add');
        var val = qtyBox.querySelector('[data-wcf-qty-val]');
        if (val) val.textContent = String(q);
        var dec = qtyBox.querySelector('[data-wcf-qty-dec]');
        if (dec) dec.disabled = q <= 0;
      });
    }

    function adjustVariantQty(variantId, delta) {
      var id = vQtyKey(variantId);
      var cur = getVariantQty(state, id);
      var maxTotal = maxBookableQty(state, root);
      var others = totalVariantQty(state.variantQty) - cur;
      var room = maxTotal - others;
      var v = findWizardVariant(id);
      if (delta > 0) {
        if (room <= 0) return;
        var next = Math.min(cur + delta, room);
        setVariantQty(state, id, next);
        focusVariant(id, v);
      } else {
        setVariantQty(state, id, Math.max(0, cur - 1));
        if (getVariantQty(state, id) > 0) {
          focusVariant(id, v);
        }
      }
      syncVariantRowsState();
      updateAddCartBtn();
      updateBookingSummary();
    }

    function adjustAddonQty(delta) {
      var cur = state.addonQty || 0;
      if (delta > 0) {
        state.addonQty = clampQty(cur + delta);
      } else if (cur <= 1) {
        state.addonQty = 0;
      } else {
        state.addonQty = cur - 1;
      }
    }


    function lightboxVariantList() {
      var sectionRoot = getSectionRoot(root, data);
      var list = variantsForStylePicker(variants, sectionRoot);
      if (list.length) enrichVariantsForWizard(list, root, data);
      return list;
    }

    function closePcwLightbox() {
      var box = document.querySelector('[data-pcw-lightbox]');
      if (box && box.parentNode) box.parentNode.removeChild(box);
      document.documentElement.classList.remove('wbw-lb-open');
    }

    function lightboxPickWhenText() {
      var dateTxt = '';
      var timeTxt = '';
      var dk = normalizeDateKey(state.selectedDate);
      if (dk) {
        try {
          var p = dk.split('-');
          var d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
          dateTxt = isNaN(d.getTime())
            ? formatDatePillLabel(dk)
            : d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
        } catch (_) {
          dateTxt = formatDatePillLabel(dk);
        }
      }
      if (state.selectedSlot) timeTxt = formatSlotTimeRange(state.selectedSlot);
      if (dateTxt && timeTxt) return dateTxt + ' · ' + timeTxt;
      return dateTxt || timeTxt || '';
    }

    function lightboxSelectedTotalCents() {
      var total = 0;
      Object.keys(state.variantQty || {}).forEach(function (k) {
        var q = state.variantQty[k] || 0;
        if (!q) return;
        var item = findWizardVariant(k);
        if (!item) return;
        total += (Number(item.price) || 0) * q;
      });
      return total;
    }

    function lightboxPickInnerHtml(row) {
      var imgUrl = variantImageUrl(row.item, root, data) || row.item.image_url || '';
      var img = imgUrl
        ? '<img src="' +
          escapeHtml(imgUrl) +
          '" alt="' +
          escapeHtml(row.item.label || row.item.title || 'Workshop') +
          '">'
        : '<span class="wbw-lb__pick-ph" aria-hidden="true"></span>';
      return (
        '<span class="wbw-lb__pick-media">' +
        img +
        '</span>' +
        '<span class="wbw-lb__pick-info">' +
        '<span class="wbw-lb__pick-name">' +
        escapeHtml(row.item.label || row.item.title || 'Workshop') +
        '</span>' +
        '<span class="wbw-lb__pick-when' +
        (row.when ? '' : ' is-muted') +
        '">' +
        escapeHtml(row.when || 'Date & time not selected') +
        '</span></span>' +
        '<span class="wbw-lb__pick-qty">Qty ' +
        escapeHtml(String(row.q)) +
        '</span>'
      );
    }

    /** Coral-like: selected variants listed under title (stack on mobile). */
    function paintPcwLightboxPicks(box) {
      var host = box && box.querySelector('[data-pcw-lb-picks]');
      if (!host) return;
      var activeId = vQtyKey(box.getAttribute('data-pcw-lb-id') || '');
      var whenTxt = lightboxPickWhenText();
      var items = [];
      Object.keys(state.variantQty || {}).forEach(function (k) {
        var key = vQtyKey(k);
        var q = getVariantQty(state, key);
        if (!q) return;
        var item = findWizardVariant(key);
        if (!item) return;
        items.push({ k: key, q: q, item: item, when: whenTxt, on: key === activeId });
      });
      if (!items.length) {
        host.innerHTML = '';
        host.hidden = true;
        host.setAttribute('hidden', '');
        host.classList.remove('is-open', 'wbw-lb__picks--stack');
        host.removeAttribute('data-pcw-picks-sig');
        box._pcwPicksOpen = false;
        return;
      }
      var mobile = isMobileViewport();
      var open = !mobile || !!box._pcwPicksOpen;
      host.hidden = false;
      host.removeAttribute('hidden');
      var rows = items.map(function (row) {
        return (
          '<button type="button" class="wbw-lb__pick' +
          (row.on ? ' is-active' : '') +
          '" data-pcw-lb-pick="' +
          escapeHtml(row.k) +
          '" aria-current="' +
          (row.on ? 'true' : 'false') +
          '">' +
          lightboxPickInnerHtml(row) +
          '</button>'
        );
      });
      var listHtml =
        '<div class="wbw-lb__picks-head"><div class="wbw-lb__picks-label">Selected</div></div>' +
        rows.join('') +
        '<div class="wbw-lb__picks-foot">' +
        '<button type="button" class="wcf-btn--clear wbw-lb__clear" data-pcw-lb-clear>Clear all</button>' +
        '<span class="wbw-lb__total">Total <strong data-pcw-lb-total>' +
        escapeHtml(formatMoney(lightboxSelectedTotalCents())) +
        '</strong></span></div>';
      if (!mobile) {
        host.classList.remove('wbw-lb__picks--stack', 'is-open');
        host.removeAttribute('data-pcw-picks-sig');
        host.innerHTML = listHtml;
        return;
      }
      var stackItems = items.slice();
      var activeAt = -1;
      stackItems.forEach(function (row, i) {
        if (row.on) activeAt = i;
      });
      if (activeAt >= 0) stackItems.push(stackItems.splice(activeAt, 1)[0]);
      var peekStart = Math.max(0, stackItems.length - 3);
      var sig = stackItems
        .map(function (row) {
          return row.k + ':' + row.q + ':' + (row.when || '') + ':' + (row.on ? '1' : '0');
        })
        .join('|');
      var wasOpen = host.classList.contains('is-open');
      host.classList.add('wbw-lb__picks--stack');
      host.style.setProperty('--wbw-n', String(stackItems.length));
      host.style.setProperty('--wbw-peek-step', '0.95rem');
      host.style.setProperty('--wbw-rest', Math.min(2, stackItems.length - 1) * 0.95 + 'rem');
      if (host.getAttribute('data-pcw-picks-sig') !== sig) {
        host.setAttribute('data-pcw-picks-sig', sig);
        host.innerHTML =
          '<div class="wbw-lb__stack" data-pcw-lb-stack data-count="' +
          Math.min(3, stackItems.length) +
          '" aria-expanded="' +
          (open ? 'true' : 'false') +
          '">' +
          stackItems
            .map(function (row, i) {
              var peek = i < peekStart ? -1 : i - peekStart;
              return (
                '<button type="button" class="wbw-lb__pick wbw-lb__stack-card' +
                (row.on ? ' is-active' : '') +
                (peek < 0 ? ' is-back' : '') +
                '" data-pcw-lb-pick="' +
                escapeHtml(row.k) +
                '" style="--wbw-stack-i:' +
                i +
                ';--wbw-peek:' +
                peek +
                '" aria-current="' +
                (row.on ? 'true' : 'false') +
                '">' +
                lightboxPickInnerHtml(row) +
                '</button>'
              );
            })
            .join('') +
          '</div>' +
          '<div class="wbw-lb__picks-foot">' +
          '<button type="button" class="wcf-btn--clear wbw-lb__clear" data-pcw-lb-clear>Clear all</button>' +
          '<span class="wbw-lb__total">Total <strong data-pcw-lb-total>' +
          escapeHtml(formatMoney(lightboxSelectedTotalCents())) +
          '</strong></span></div>';
      }
      var stackEl = host.querySelector('[data-pcw-lb-stack]');
      if (stackEl) stackEl.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && !wasOpen) {
        host.classList.remove('is-open');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            host.classList.add('is-open');
          });
        });
      } else {
        host.classList.toggle('is-open', open);
      }
    }

    function paintPcwLightbox(box, id) {
      if (!box) return;
      id = vQtyKey(id || box.getAttribute('data-pcw-lb-id') || '');
      var v = findWizardVariant(id);
      box.setAttribute('data-pcw-lb-id', id);
      if (v) {
        var img = box.querySelector('[data-pcw-lb-img]');
        var title = box.querySelector('[data-pcw-lb-title]');
        var price = box.querySelector('[data-pcw-lb-price]');
        var qtyEl = box.querySelector('[data-pcw-lb-qty]');
        var url = variantLightboxImageUrl(v, root, data) || v.image_url || '';
        if (img) {
          img.src = url;
          img.alt = v.label || v.title || '';
        }
        if (title) title.textContent = v.label || v.title || 'Workshop';
        if (price) price.innerHTML = formatVariantPriceHtml(v);
        if (qtyEl) qtyEl.textContent = String(getVariantQty(state, id) || 0);
        var addBtn = box.querySelector('[data-pcw-lb-add]');
        if (addBtn && addBtn.getAttribute('data-wcf-busy') !== 'true') {
          addBtn.disabled = !(
            totalVariantQty(state.variantQty) > 0 &&
            state.selectedDate &&
            state.selectedSlot &&
            slotBookable(state.selectedSlot)
          );
        }
        box.querySelectorAll('[data-pcw-lb-thumb]').forEach(function (btn) {
          var on = String(btn.getAttribute('data-pcw-lb-thumb')) === id;
          btn.classList.toggle('is-active', on);
          if (on && btn.scrollIntoView) {
            try {
              btn.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
            } catch (_) {}
          }
        });
        fillPcwLightboxWhen(box);
      }
      paintPcwLightboxPicks(box);
    }

    function fillPcwLightboxWhen(box) {
      var dateSel = box.querySelector('[data-pcw-lb-date]');
      var timeSel = box.querySelector('[data-pcw-lb-time]');
      if (!dateSel || !timeSel) return;
      var keys = availableDateKeys();
      var keepDate = normalizeDateKey(state.selectedDate);
      dateSel.innerHTML = '<option value="">Select a date</option>';
      keys.forEach(function (dk) {
        var opt = document.createElement('option');
        opt.value = dk;
        opt.textContent = formatDatePillLabel(dk);
        if (dk === keepDate) opt.selected = true;
        dateSel.appendChild(opt);
      });
      var daySlots = keepDate ? slotsForDateKey(keepDate) : [];
      timeSel.innerHTML = '<option value="">Select a time</option>';
      daySlots.forEach(function (slot) {
        var opt = document.createElement('option');
        opt.value = slot.gid || '';
        opt.textContent = formatSlotTimeRange(slot);
        if (state.selectedSlot && state.selectedSlot.gid === slot.gid) opt.selected = true;
        if (!slotBookable(slot)) opt.disabled = true;
        timeSel.appendChild(opt);
      });
      timeSel.disabled = !keepDate || !daySlots.length;
    }

    function openPcwLightbox(variantId) {
      var list = lightboxVariantList();
      var id = vQtyKey(variantId);
      var idx = -1;
      list.forEach(function (v, i) {
        if (vQtyKey(v.id) === id) idx = i;
      });
      if (idx < 0 && list[0]) {
        id = vQtyKey(list[0].id);
        idx = 0;
      }
      var v = findWizardVariant(id);
      if (!v) return;
      focusVariant(id, v);
      closePcwLightbox();

      var box = document.createElement('div');
      box.className = 'wbw-lb';
      box.setAttribute('data-pcw-lightbox', '');
      box.setAttribute('data-wbw-lightbox', '');
      box.setAttribute('data-pcw-lb-id', id);
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Workshop design');
      var imgUrl = variantLightboxImageUrl(v, root, data) || v.image_url || '';
      box.innerHTML =
        '<button type="button" class="wbw-lb__close" aria-label="Close">&times;</button>' +
        '<div class="wbw-lb__card">' +
        '<div class="wbw-lb__stage">' +
        '<button type="button" class="wbw-lb__nav wbw-lb__nav--prev" aria-label="Previous">‹</button>' +
        '<img class="wbw-lb__img" data-pcw-lb-img src="' +
        escapeHtml(imgUrl) +
        '" alt="' +
        escapeHtml(v.label || v.title || '') +
        '">' +
        '<button type="button" class="wbw-lb__nav wbw-lb__nav--next" aria-label="Next">›</button>' +
        '</div>' +
        '<div class="wbw-lb__dock">' +
        '<div class="wbw-lb__meta">' +
        '<span class="wbw-lb__title" data-pcw-lb-title>' +
        escapeHtml(v.label || v.title || 'Workshop') +
        '</span></div>' +
        '<div class="wbw-lb__mid"><div class="wbw-lb__left">' +
        '<div class="wbw-lb__when">' +
        '<label class="wbw-lb__field"><span>Date</span><select data-pcw-lb-date><option value="">Select a date</option></select></label>' +
        '<label class="wbw-lb__field"><span>Time</span><select data-pcw-lb-time><option value="">Select a time</option></select></label>' +
        '</div></div></div>' +
        '<div class="wbw-lb__picks" data-pcw-lb-picks hidden></div>' +
        '<div class="wbw-lb__bar">' +
        '<span class="wbw-lb__price" data-pcw-lb-price>' +
        formatVariantPriceHtml(v) +
        '</span>' +
        '<div class="wbw-stepper" data-pcw-lb-stepper>' +
        '<button type="button" class="wbw-stepper__btn" data-pcw-lb-dec aria-label="Decrease">−</button>' +
        '<span class="wbw-stepper__val" data-pcw-lb-qty>' +
        String(getVariantQty(state, id) || 0) +
        '</span>' +
        '<button type="button" class="wbw-stepper__btn" data-pcw-lb-inc aria-label="Increase">+</button>' +
        '</div>' +
        '<div class="wbw-atc-wrap">' +
        '<button type="button" class="wcf-btn wcf-btn--primary wbw-lb__add" data-pcw-lb-add>Add to cart</button>' +
        '</div></div>' +
        '<div class="wbw-lb__thumbs" data-pcw-lb-thumbs>' +
        list
          .map(function (item, i) {
            var tid = vQtyKey(item.id);
            var turl = variantImageUrl(item, root, data) || item.image_url || '';
            return (
              '<button type="button" class="wbw-lb__thumb' +
              (tid === id ? ' is-active' : '') +
              '" data-pcw-lb-thumb="' +
              escapeHtml(tid) +
              '" data-pcw-lb-thumb-i="' +
              i +
              '" aria-label="' +
              escapeHtml(item.label || item.title || 'Design') +
              '">' +
              (turl
                ? '<img src="' + escapeHtml(turl) + '" alt="">'
                : '<span class="wbw-lb__thumb-ph"></span>') +
              '</button>'
            );
          })
          .join('') +
        '</div></div></div>';

      function showAt(nextIdx) {
        if (!list.length) return;
        idx = (nextIdx + list.length) % list.length;
        id = vQtyKey(list[idx].id);
        focusVariant(id, list[idx]);
        paintPcwLightbox(box, id);
      }

      box.querySelector('.wbw-lb__close').addEventListener('click', closePcwLightbox);
      box.querySelector('.wbw-lb__nav--prev').addEventListener('click', function () {
        showAt(idx - 1);
      });
      box.querySelector('.wbw-lb__nav--next').addEventListener('click', function () {
        showAt(idx + 1);
      });
      box.querySelector('[data-pcw-lb-inc]').addEventListener('click', function (e) {
        e.preventDefault();
        adjustVariantQty(id, 1);
        paintPcwLightbox(box, id);
      });
      box.querySelector('[data-pcw-lb-dec]').addEventListener('click', function (e) {
        e.preventDefault();
        adjustVariantQty(id, -1);
        paintPcwLightbox(box, id);
      });
      box.querySelector('[data-pcw-lb-add]').addEventListener('click', function (e) {
        e.preventDefault();
        addToCart();
      });
      box.addEventListener('click', function (e) {
        var clearAll = e.target.closest('[data-pcw-lb-clear]');
        if (clearAll && box.contains(clearAll)) {
          e.preventDefault();
          e.stopPropagation();
          clearBookingSelection();
          paintPcwLightbox(box, id);
          return;
        }
        if (box._pcwPicksOpen && !e.target.closest('[data-pcw-lb-picks]')) {
          box._pcwPicksOpen = false;
          paintPcwLightboxPicks(box);
        }
        var pick = e.target.closest('[data-pcw-lb-pick]');
        if (pick && box._pcwPicksOpen && box.contains(pick)) {
          var pid = String(pick.getAttribute('data-pcw-lb-pick') || '');
          var pi = -1;
          list.forEach(function (item, n) {
            if (vQtyKey(item.id) === pid) pi = n;
          });
          if (pi >= 0) showAt(pi);
          return;
        }
        var stackOpen = e.target.closest('[data-pcw-lb-stack]');
        if (stackOpen && box.contains(stackOpen)) {
          e.preventDefault();
          box._pcwPicksOpen = !box._pcwPicksOpen;
          paintPcwLightboxPicks(box);
          return;
        }
        if (!pick || !box.contains(pick)) return;
        var pid2 = String(pick.getAttribute('data-pcw-lb-pick') || '');
        var pi2 = -1;
        list.forEach(function (item, n) {
          if (vQtyKey(item.id) === pid2) pi2 = n;
        });
        if (pi2 >= 0) showAt(pi2);
      });
      box.querySelectorAll('[data-pcw-lb-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var tid = btn.getAttribute('data-pcw-lb-thumb');
          var i = -1;
          list.forEach(function (item, n) {
            if (vQtyKey(item.id) === tid) i = n;
          });
          if (i >= 0) showAt(i);
        });
      });
      var dateSel = box.querySelector('[data-pcw-lb-date]');
      var timeSel = box.querySelector('[data-pcw-lb-time]');
      if (dateSel) {
        dateSel.addEventListener('change', function () {
          var dk = normalizeDateKey(dateSel.value);
          if (dk) selectDateKey(dk);
          else {
            state.selectedDate = '';
            state.selectedSlot = null;
          }
          if (typeof refreshSessionPills === 'function') {
            refreshSessionPills({ preferredDate: dk, applyAuto: true });
          } else {
            renderDatePills();
            renderTimePills();
          }
          paintPcwLightbox(box, id);
        });
      }
      if (timeSel) {
        timeSel.addEventListener('change', function () {
          var gid = String(timeSel.value || '');
          var slot = null;
          slotsForSelectedDate().forEach(function (s) {
            if (String(s.gid) === gid) slot = s;
          });
          if (slot) onTimeSlotChosen(slot, stepEl('variants') || root);
          else state.selectedSlot = null;
          if (typeof refreshSessionPills === 'function') {
            refreshSessionPills({
              preferredDate: state.selectedDate,
              preferredGid: gid,
              applyAuto: false
            });
          }
          paintPcwLightbox(box, id);
        });
      }

      (function bindSwipe() {
        var stage = box.querySelector('.wbw-lb__stage');
        if (!stage || list.length < 2) return;
        var startX = 0;
        var startY = 0;
        var tracking = false;
        stage.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          tracking = true;
          startX = e.clientX;
          startY = e.clientY;
        });
        stage.addEventListener('pointerup', function (e) {
          if (!tracking) return;
          tracking = false;
          var dx = e.clientX - startX;
          var dy = e.clientY - startY;
          if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.15) return;
          showAt(dx < 0 ? idx + 1 : idx - 1);
        });
      })();

      function onKey(e) {
        if (e.key === 'Escape') closePcwLightbox();
        if (e.key === 'ArrowLeft') showAt(idx - 1);
        if (e.key === 'ArrowRight') showAt(idx + 1);
      }
      document.addEventListener('keydown', onKey);
      var prevClose = closePcwLightbox;
      closePcwLightbox = function () {
        document.removeEventListener('keydown', onKey);
        closePcwLightbox = prevClose;
        prevClose();
      };

      document.documentElement.classList.add('wbw-lb-open');
      document.body.appendChild(box);
      paintPcwLightbox(box, id);
    }

    /* —— Variants —— */
    function renderVariants() {
      var step = stepEl('variants');
      if (!step) return;
      if (!variants.length || !variants[0].image_url) refreshProductVariants();
      relaxNativeVariantInventory(root, data, slotBookable(state.selectedSlot));
      var wrap = step.querySelector('[data-wcf-variants]');
      if (!wrap) return;
      wrap.innerHTML = '';
      var sectionRoot = getSectionRoot(root, data);
      var styleIdx =
        data.styleOptionIndex != null ? Number(data.styleOptionIndex) : pickStyleOptionIndex(sectionRoot, variants);
      var displayVariants = variantsForStylePicker(variants, sectionRoot);
      if (displayVariants.length) enrichVariantsForWizard(displayVariants, root, data);
      if (!displayVariants.length) {
        wrap.innerHTML =
          '<div class="wcf-variants-empty">' +
          '<p class="wcf-variants-empty__title">No workshop styles found</p>' +
          '<p class="wcf-variants-empty__text">This product has no variants in the theme data. Refresh the page or check the product in Admin.</p>' +
          '</div>';
        console.warn('[popup-city-wizard] no variants to render', {
          rawCount: variants.length,
          sectionId: data.sectionId,
        });
        updateAddCartBtn();
        updateBookingSummary();
        return;
      }
      displayVariants.forEach(function (v) {
        var id = vQtyKey(v.id);
        var qty = getVariantQty(state, id);
        var active = qty > 0;
        var row = document.createElement('div');
        row.className =
          'wcf-variant-row' +
          (active ? ' is-active' : '') +
          (state.focusedVariantId === id && !active ? ' is-preview' : '');
        row.setAttribute('data-variant-id', id);

        /* div card (not <button>) so nested lightbox zoom button is valid HTML */
        var btn = document.createElement('div');
        btn.className = 'wcf-variant-card';
        btn.setAttribute('role', 'group');
        btn.setAttribute('data-variant-id', id);
        var imgUrl = variantImageUrl(v, root, data);
        var label = v.label || styleValueFromVariant(v, styleIdx) || v.title || '';
        btn.setAttribute('aria-label', label || 'Workshop style');
        var img = imgUrl
          ? '<img class="wcf-variant-card__img" src="' +
            imgUrl.replace(/"/g, '&quot;') +
            '" alt="" width="128" height="128" loading="eager" decoding="async" fetchpriority="high">'
          : '<div class="wcf-variant-card__img wcf-variant-card__img--placeholder" aria-hidden="true"></div>';
        var cardLayout = variantCardLayout(root);
        var priceHtml =
          '<div class="wcf-variant-card__price">' + formatVariantPriceHtml(v) + '</div>';
        var titleHtml = '<div class="wcf-variant-card__title">' + escapeHtml(label) + '</div>';
        var zoomBtnHtml =
          '<button type="button" class="wbw-variant-zoom" data-pcw-zoom aria-label="View larger">' +
          '<svg class="wbw-variant-zoom__icon" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<circle cx="10.5" cy="10.5" r="6.25" fill="#e7f6f4" stroke="#149a8c" stroke-width="2"></circle>' +
          '<circle cx="10.5" cy="10.5" r="2.2" fill="#149a8c"></circle>' +
          '<path d="M15.2 15.2L20 20" fill="none" stroke="#10242c" stroke-width="2.2" stroke-linecap="round"></path>' +
          '</svg></button>';
        var mediaHtml = '<div class="wcf-variant-card__media">' + img + zoomBtnHtml + '</div>';
        btn.innerHTML =
          cardLayout === 'horizontal'
            ? mediaHtml + titleHtml + priceHtml
            : titleHtml + mediaHtml;
        var zoomBtn = btn.querySelector('[data-pcw-zoom]');
        if (zoomBtn) {
          zoomBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            openPcwLightbox(id);
          });
        }
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (wrap.__pcwSuppressClick) return;
          if (e.target && e.target.closest && e.target.closest('[data-pcw-zoom]')) return;
          /* Desktop/mobile: lightbox only via top-left zoom; card selects/focuses. */
          focusVariant(id, v);
        });

        var qtyCol = document.createElement('div');
        qtyCol.className = 'wcf-variant-qty-col';
        qtyCol.innerHTML = variantQtyControlHtml(id, qty);
        qtyCol.addEventListener('click', function (e) {
          var add = e.target.closest('[data-wcf-qty-add]');
          var inc = e.target.closest('[data-wcf-qty-inc]');
          var dec = e.target.closest('[data-wcf-qty-dec]');
          if (!add && !inc && !dec) return;
          e.preventDefault();
          e.stopPropagation();
          if (dec && dec.disabled) return;
          var qtyBox = qtyCol.querySelector('[data-wcf-variant-qty]');
          if (!qtyBox) return;
          var vid = qtyBox.getAttribute('data-variant-id');
          if (!vid) return;
          if (add) {
            adjustVariantQty(vid, 1);
            return;
          }
          adjustVariantQty(vid, dec ? -1 : 1);
        });

        row.appendChild(btn);
        row.appendChild(qtyCol);
        if (cardLayout !== 'horizontal') {
          var priceEl = document.createElement('div');
          priceEl.className = 'wcf-variant-card__price wcf-variant-card__price--below-qty';
          priceEl.innerHTML = formatVariantPriceHtml(v);
          row.appendChild(priceEl);
        }
        wrap.appendChild(row);
      });
      if (state.focusedVariantId && getVariantQty(state, state.focusedVariantId) > 0) {
        /* Keep existing PDP media selection stable across rerenders. */
      } else {
        var activeKeys = Object.keys(state.variantQty).filter(function (k) {
          return (state.variantQty[k] || 0) > 0;
        });
        if (activeKeys.length === 1) {
          state.focusedVariantId = activeKeys[0];
        } else if (activeKeys.length > 1 && !state.focusedVariantId) {
          state.focusedVariantId = activeKeys[0];
        }
      }
      syncVariantRowsState();
      bindVariantGridResize(wrap);
      syncVariantsNextBtn();
      updateBookingSummary();
      if (window.AmcProductTitleFit) {
        if (typeof window.AmcProductTitleFit.scheduleFit === 'function') {
          window.AmcProductTitleFit.scheduleFit();
        } else if (typeof window.AmcProductTitleFit.fitAll === 'function') {
          window.AmcProductTitleFit.fitAll();
        }
      }
    }

    function syncAddonQtyDisplay() {
      var addonBtn = root.querySelector('[data-wcf-addon]');
      var card = root.querySelector('[data-wcf-addon-card]');
      var addonQtyWrap = root.querySelector('[data-wcf-addon-qty]');
      if (!addonBtn) return;
      var q = Math.max(0, parseInt(String(state.addonQty), 10) || 0);
      var on = q > 0;
      addonBtn.classList.toggle('is-selected', on);
      addonBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (card) card.classList.toggle('is-on', on);
      if (!addonQtyWrap) return;
      var bookingAddon = card && card.classList.contains('wcf-booking-addon');
      addonQtyWrap.hidden = bookingAddon ? false : !on;
      var controls = addonQtyWrap.querySelector('[data-wcf-addon-qty-controls]');
      if (!controls) return;
      var valEl = controls.querySelector('[data-wcf-qty-val]');
      var dec = controls.querySelector('[data-wcf-qty-dec]');
      if (valEl) valEl.textContent = String(q);
      if (dec) dec.disabled = q <= 0;
    }

    function renderAddonUi() {
      syncAddonQtyDisplay();
    }

    function buildReviewLineHtml(v, q, styleIdx, root, data) {
      var imgUrl = variantImageUrl(v, root, data);
      var label = v.label || styleValueFromVariant(v, styleIdx) || v.title || 'Workshop';
      var unit = Number(v.price) || 0;
      var lineTotal = unit * q;
      var thumb = imgUrl
        ? '<img class="wcf-review-line__thumb" src="' +
          imgUrl.replace(/"/g, '&quot;') +
          '" alt="" loading="lazy" decoding="async">'
        : '<span class="wcf-review-line__thumb wcf-review-line__thumb--ph" aria-hidden="true"></span>';
      return (
        '<div class="wcf-review-line">' +
        thumb +
        '<div class="wcf-review-line__meta">' +
        '<span class="wcf-review-line__title">' +
        escapeHtml(label) +
        '</span>' +
        '<span class="wcf-review-line__unit">' +
        formatVariantPriceHtml(v) +
        ' each</span>' +
        '</div>' +
        '<span class="wcf-review-line__qty" aria-label="Quantity">' +
        'Qty ' +
        q +
        '</span>' +
        '<span class="wcf-review-line__total">' +
        escapeHtml(formatMoney(lineTotal)) +
        '</span>' +
        '</div>'
      );
    }

    function handleQtyClick(e) {
      var add = e.target.closest('[data-wcf-qty-add]');
      var dec = e.target.closest('[data-wcf-qty-dec]');
      var inc = e.target.closest('[data-wcf-qty-inc]');
      if (!add && !dec && !inc) return false;
      e.preventDefault();
      e.stopPropagation();
      if (dec && dec.disabled) return true;
      var qtyBox = findQtyBoxFromControl(add || dec || inc);
      if (!qtyBox) return true;
      if (isAddonQtyBox(qtyBox)) {
        adjustAddonQty(add || inc ? 1 : -1);
        updateBookingSummary();
        return true;
      }
      var vidAttr = qtyBox.getAttribute('data-variant-id');
      if (vidAttr) {
        adjustVariantQty(vidAttr, add || inc ? 1 : -1);
      }
      return true;
    }

    function bindWizardViewportResize(rootEl) {
      if (rootEl.__wcfViewportResize) return;
      rootEl.__wcfViewportResize = true;
      var resizeTimer;
      /* Mobile URL bars fire resize on scroll with a height-only change; ignore those
         so an open menu is not yanked away mid-selection. */
      var lastWidth = window.innerWidth;
      window.addEventListener('resize', function () {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          syncCalTimeMobileLayout();
          if (!currentOpenPicker()) closeCalTimeDd();
          var calStep = stepEl('calendar');
          if (calStep && calStep.classList.contains('wcf-step--on')) renderCalendar();
          var vwrap = rootEl.querySelector('[data-wcf-variants]');
          if (vwrap) {
            var n = vwrap.querySelectorAll('.wcf-variant-row').length;
            if (n) applyVariantGridLayout(vwrap, n);
          }
          scheduleFitPickerLabels(rootEl);
          scheduleFitSessionPills(true);
        }, 150);
      });
    }

    function attachRootUiHandlers() {
      if (root.__wcfOnClick) root.removeEventListener('click', root.__wcfOnClick);
      if (root.__wcfOnChange) root.removeEventListener('change', root.__wcfOnChange);

      root.__wcfOnChange = function (e) {
        var timeSel = e.target.closest('[data-wcf-time-select]');
        if (timeSel && stepEl('calendar') && stepEl('calendar').contains(timeSel)) {
          var gid = timeSel.value;
          if (!gid) {
            state.selectedSlot = null;
            renderCalTimeSelect();
            return;
          }
          var slots = slotsForSelectedDate();
          var slot = null;
          for (var ti = 0; ti < slots.length; ti++) {
            if (slots[ti].gid === gid) {
              slot = slots[ti];
              break;
            }
          }
          if (slot) onTimeSlotChosen(slot, stepEl('calendar'));
          return;
        }

        var inp = e.target.closest('.wcf-qty__input');
        if (!inp) return;
        var qtyBox = findQtyBoxFromControl(inp);
        if (!qtyBox || isAddonQtyBox(qtyBox)) return;
        var vidAttr = qtyBox.getAttribute('data-variant-id');
        if (!vidAttr) return;
        var maxTotal = maxBookableQty(state, root);
        var others = totalVariantQty(state.variantQty) - getVariantQty(state, vidAttr);
        var val = Math.max(0, Math.min(maxTotal - others, parseInt(clampQty(inp.value), 10) || 0));
        setVariantQty(state, vidAttr, val);
        if (val > 0) {
          var v = variants.find(function (x) {
            return vQtyKey(x.id) === vQtyKey(vidAttr);
          });
          if (v) syncVariantToPdp(root, data, v);
        }
        renderVariants();
        updateBookingSummary();
      };

      root.__wcfOnClick = function (e) {
        if (handleQtyClick(e)) return;

        var addonToggle = e.target.closest('[data-wcf-addon]');
        if (addonToggle && !e.target.closest('[data-wcf-addon-qty-controls]')) {
          e.preventDefault();
          state.addonQty = state.addonQty > 0 ? 0 : 1;
          updateBookingSummary();
          return;
        }

        var action = e.target.closest('[data-wcf-action]');
        if (!action) return;
        var act = action.getAttribute('data-wcf-action');

        if (act === 'back') {
          goBack();
          return;
        }
        if (act === 'to-variants') {
          if (!state.selectedSlot || !slotBookable(state.selectedSlot)) {
            var calMissing = [];
            if (!state.selectedDate) calMissing.push('date');
            if (!state.selectedSlot || !slotBookable(state.selectedSlot)) calMissing.push('time');
            showBookingNotice(calMissing);
            return;
          }
          refreshCartSeatsForSelected(state.selectedSlot);
          goTo(stepsByBranch().indexOf('variants'));
          return;
        }
        if (act === 'clear-selection') {
          clearBookingSelection();
          return;
        }
        if (act === 'retry-slots') {
          if (typeof root.__wcfRetrySlots === 'function') root.__wcfRetrySlots();
          return;
        }
        if (act === 'wl-submit') {
          submitWaitlist();
          return;
        }
        if (act === 'add-cart') {
          addToCart();
        }
      };

      root.addEventListener('click', root.__wcfOnClick);
      root.addEventListener('change', root.__wcfOnChange);
    }

    attachRootUiHandlers();
    ensureAddonThumb(root);
    bindWizardViewportResize(root);
    bindCalTimeMobileDd();
    syncCalTimeMobileLayout();
    bindAddonHoverPreview(root);

    function bindAddonHoverPreview(rootEl) {
      var card = rootEl.querySelector('[data-wcf-addon-card]');
      var popup = rootEl.querySelector('[data-wcf-addon-preview]');
      if (!card || !popup || card.__wcfAddonPreviewBound) return;
      card.__wcfAddonPreviewBound = true;

      document.querySelectorAll('[data-wcf-addon-preview]').forEach(function (el) {
        if (el !== popup) el.remove();
      });

      if (popup.parentElement !== document.body) {
        document.body.appendChild(popup);
      }

      var hoverTimer = null;
      var visible = false;
      var lastEvent = null;

      function hidePreview() {
        if (hoverTimer) {
          clearTimeout(hoverTimer);
          hoverTimer = null;
        }
        visible = false;
        popup.hidden = true;
        popup.setAttribute('aria-hidden', 'true');
      }

      function positionPreview(e) {
        var ev = e || lastEvent;
        if (!ev) return;
        lastEvent = ev;
        var offset = 14;
        var x = ev.clientX + offset;
        var y = ev.clientY + offset;
        popup.style.left = x + 'px';
        popup.style.top = y + 'px';
        popup.hidden = false;
        popup.setAttribute('aria-hidden', 'false');
        var rect = popup.getBoundingClientRect();
        var pad = 8;
        var maxX = window.innerWidth - rect.width - pad;
        var maxY = window.innerHeight - rect.height - pad;
        if (rect.right > window.innerWidth - pad) {
          popup.style.left = Math.max(pad, maxX) + 'px';
        }
        if (rect.bottom > window.innerHeight - pad) {
          popup.style.top = Math.max(pad, maxY) + 'px';
        }
        if (rect.left < pad) popup.style.left = pad + 'px';
        if (rect.top < pad) popup.style.top = pad + 'px';
      }

      function showPreview(e) {
        visible = true;
        positionPreview(e);
      }

      card.addEventListener('mouseenter', function (e) {
        lastEvent = e;
        if (hoverTimer) clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(function () {
          hoverTimer = null;
          showPreview(e);
        }, 1000);
      });

      card.addEventListener('mousemove', function (e) {
        lastEvent = e;
        if (visible) positionPreview(e);
      });

      card.addEventListener('mouseleave', hidePreview);
    }

    var wlToastTimer = null;

    function hideWaitlistToast(el) {
      if (!el) return;
      el.classList.remove('is-visible');
      el.classList.add('is-leaving');
      window.setTimeout(function () {
        el.classList.remove('is-leaving', 'is-mobile');
        el.hidden = true;
      }, 320);
    }

    function showWaitlistToast(toastEl, durationMs) {
      var anchor = root.querySelector('.wcf-wl-form-wrap');
      if (!toastEl) return;
      if (wlToastTimer) {
        clearTimeout(wlToastTimer);
        wlToastTimer = null;
      }
      var okEl = root.querySelector('[data-wcf-wl-success]');
      var errEl = root.querySelector('[data-wcf-wl-error]');
      if (okEl && okEl !== toastEl) hideWaitlistToast(okEl);
      if (errEl && errEl !== toastEl) hideWaitlistToast(errEl);
      var useMobileToast = window.matchMedia('(max-width: 900px)').matches;
      toastEl.classList.toggle('is-mobile', useMobileToast);
      if (!useMobileToast && anchor) {
        var rect = anchor.getBoundingClientRect();
        var toastWidth = toastEl.offsetWidth || 168;
        var left = rect.right + 14;
        if (left + toastWidth > window.innerWidth - 12) {
          left = Math.max(12, window.innerWidth - toastWidth - 12);
        }
        toastEl.style.top = rect.top + rect.height / 2 + 'px';
        toastEl.style.left = left + 'px';
        toastEl.style.right = '';
        toastEl.style.bottom = '';
      } else {
        toastEl.style.top = '';
        toastEl.style.left = '';
      }
      toastEl.hidden = false;
      toastEl.classList.remove('is-leaving');
      void toastEl.offsetWidth;
      toastEl.classList.add('is-visible');
      wlToastTimer = window.setTimeout(function () {
        hideWaitlistToast(toastEl);
        wlToastTimer = null;
      }, durationMs || 2000);
    }

    function showWaitlistSuccessToast() {
      showWaitlistToast(root.querySelector('[data-wcf-wl-success]'), 2000);
    }

    function showWaitlistErrorToast(errEl, message) {
      if (!errEl) return;
      errEl.textContent = message;
      showWaitlistToast(errEl, 3500);
    }

    function submitWaitlist() {
      if (state.wlContext === 'api_error') return;
      var nameEl = root.querySelector('[data-wcf-wl-name]');
      var emailEl = root.querySelector('[data-wcf-wl-email]');
      var notesEl = root.querySelector('[data-wcf-wl-notes]');
      var errEl = root.querySelector('[data-wcf-wl-error]');
      var okEl = root.querySelector('[data-wcf-wl-success]');
      var nameV = nameEl ? String(nameEl.value || '').trim() : '';
      var emailV = emailEl ? String(emailEl.value || '').trim() : '';
      if (!nameV) {
        showWaitlistErrorToast(errEl, 'Please enter your name.');
        return;
      }
      if (!emailV || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailV)) {
        showWaitlistErrorToast(errEl, 'Please enter a valid email.');
        return;
      }
      var preferredDate = 'not_sure';
      var notes = notesEl ? String(notesEl.value || '').trim() : '';
      if (state.wlContext === 'sold_out' && state.selectedDate) {
        notes = (notes ? notes + ' | ' : '') + 'Sold out slot date: ' + state.selectedDate;
      }
      if (wlToastTimer) {
        clearTimeout(wlToastTimer);
        wlToastTimer = null;
      }
      hideWaitlistToast(errEl);
      hideWaitlistToast(okEl);

      var wlSubmit =
        window.WorkshopCityFlow && window.WorkshopCityFlow.submitWaitlist
          ? window.WorkshopCityFlow.submitWaitlist
          : null;
      var flow = window.WorkshopCityFlow || {};
      var workshopType = flow.resolveWorkshopType ? flow.resolveWorkshopType(root, data) : 'mosaic';
      var venueId = flow.resolveWaitlistVenueId ? flow.resolveWaitlistVenueId(root, data) : String(data.productHandle || '').trim();
      var wlSource = flow.normalizeWaitlistSource
        ? flow.normalizeWaitlistSource(state.wlContext)
        : state.wlContext === 'api_error'
          ? 'no_events'
          : state.wlContext;
      var wlPayload = {
        email: emailV,
        name: nameV,
        venue_id: venueId,
        venue_name: cityName || data.productHandle,
        shop_domain: window.Shopify && window.Shopify.shop ? String(window.Shopify.shop) : '',
        workshop_type: workshopType,
        preferred_date: preferredDate,
        notes: notes,
        source: wlSource,
      };
      var wlP = wlSubmit
        ? wlSubmit(waitlistUrl, wlPayload)
        : fetch(waitlistUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(wlPayload),
            mode: 'cors',
          }).then(function (res) {
            if (res && res.ok) return;
            return res.text().then(function (txt) {
              throw new Error(txt || 'Request failed');
            });
          });
      wlP
        .then(function () {
          showWaitlistSuccessToast();
        })
        .catch(function (err) {
          showWaitlistErrorToast(
            errEl,
            err && err.message ? String(err.message).slice(0, 200) : 'Something went wrong.'
          );
        });
    }

    function proceedAddToCart(slot) {
      if (!slot || !slot.gid || !hasSelectedVariants(state)) return;
      var props = buildEventProperties(slot, data, root);
      var sectionRoot = getSectionRoot(root, data);
      var items = [];
      var workshopRows = [];
      Object.keys(state.variantQty).forEach(function (vidKey) {
        var q = state.variantQty[vidKey] || 0;
        if (!q) return;
        var rep = variants.find(function (x) {
          return vQtyKey(x.id) === vQtyKey(vidKey);
        });
        var cartId = rep
          ? resolveVariantForSlot(rep, slot, variants, sectionRoot, root, data)
          : vidKey;
        var numericId = parseInt(String(cartId), 10);
        if (!Number.isFinite(numericId) || numericId <= 0) return;
        var cents = Number.POSITIVE_INFINITY;
        if (rep && rep.price != null) cents = Math.round(Number(rep.price) * 100);
        workshopRows.push({ numericId: numericId, q: q, cents: cents });
      });
      workshopRows.forEach(function (row) {
        var lineProps = Object.assign({}, props);
        // Per-variant base — never reuse shared props._unique across SKUs (would merge wrong lines).
        var seatBase =
          String(row.numericId) +
          ':' +
          String(lineProps._event_metaobject_gid || slot.gid || 'seat');
        // Plain qty: always one merged line (no paid/free seat split).
        lineProps._unique = seatBase;
        items.push({ id: row.numericId, quantity: row.q, properties: lineProps });
      });
      if (!items.length) return;
      if (state.addonQty > 0 && addonVariantId) {
        var addonId = parseInt(String(addonVariantId), 10);
        if (Number.isFinite(addonId) && addonId > 0) {
          var addonTitle = (root.getAttribute('data-addon-title') || 'Turkish Coffee').trim();
          items.push({
            id: addonId,
            quantity: state.addonQty,
            properties: {
              _workshop_addon: 'true',
              _addon_for_event_id: slot.gid,
              _addon_for_variant_id: String(items[0].id),
              _addon_title: addonTitle,
            },
          });
        }
      }
      var payload = { items: items };
      var sections = getCartSections();
      if (sections.length) {
        payload.sections = sections.join(',');
        payload.sections_url =
          (typeof window !== 'undefined' && window.location && window.location.pathname) || '/';
      }
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          return res.json().then(function (body) {
            return { ok: res.ok, body: body };
          });
        })
        .then(function (r) {
          if (!r.ok || r.body.status === 422) {
            window.alert(r.body.description || 'Unable to add to cart.');
            return false;
          }
          dispatchCartUi(r.body);
          try {
            if (
              window.WorkshopCityCartLive &&
              typeof window.WorkshopCityCartLive.splitMergedWorkshopLines === 'function'
            ) {
              window.WorkshopCityCartLive.splitMergedWorkshopLines();
            }
          } catch (_) {}
          return true;
        })
        .catch(function () {
          window.alert('Unable to add to cart.');
          return false;
        });
    }

    function addToCart() {
      var missing = missingBookingChoices();
      if (missing.length) {
        showBookingNotice(missing);
        return;
      }
      clearBookingNotice();
      var btn = root.querySelector('[data-wcf-action="add-cart"]');
      setAddCartButtonState(btn, 'loading', 'Adding...');

      ensureFreshSlotForAdd(state.selectedSlot)
        .then(function (freshSlot) {
          return refreshCartSeatsForSelected(freshSlot || state.selectedSlot).then(function () {
            return freshSlot;
          });
        })
        .then(function (freshSlot) {
          if (!freshSlot || !slotBookable(freshSlot)) {
            window.alert('This session is no longer available. Please choose another time.');
            if (state.branch === 'booking') {
              renderCalendar();
              renderVariants();
            }
            return;
          }
          var total = totalVariantQty(state.variantQty);
          var max = maxBookableQty(state, root);
          if (total > max || max <= 0) {
            window.alert(
              max <= 0
                ? 'This session is sold out.'
                : 'Only ' + max + ' seat(s) remain for this session.'
            );
            clampVariantQtyToCapacity();
            renderVariants();
            updateBookingSummary();
            return;
          }
          return validateCapacityBeforeAdd(freshSlot, total);
        })
        .then(function (validation) {
          if (!validation) return;
          if (validation.blocked) {
            window.alert(validation.message);
            clampVariantQtyToCapacity();
            renderVariants();
            updateBookingSummary();
            return;
          }
          return proceedAddToCart(validation.slot || state.selectedSlot);
        })
        .then(function (added) {
          if (added) {
            setAddCartButtonState(btn, 'added', 'Added');
            window.setTimeout(function () {
              setAddCartButtonState(btn, 'idle');
            }, 1200);
          }
        })
        .finally(function () {
          if (!btn || btn.getAttribute('data-wcf-state') !== 'added') {
            setAddCartButtonState(btn, 'idle');
          }
        });
    }

    function applyBranchUi() {
      relaxNativeVariantInventory(root, data, state.branch === 'booking' && slotBookable(state.selectedSlot));
      if (state.branch === 'waitlist') {
        state.branch = 'booking';
      }
      var deep =
        window.WorkshopCityFlow &&
        typeof window.WorkshopCityFlow.hasCityBookingDeepLink === 'function' &&
        window.WorkshopCityFlow.hasCityBookingDeepLink();
      if (!deep) ensureDefaultDateAndTime();
      state.stepIndex = 0;
      updateTrack();
      root.__wcfUiReady = true;
      setLoading(root, false);
      if (state.branch === 'booking') {
        refreshProductVariants();
        renderVariants();
        renderCalendar();
        renderTimePills();
        bindPickerUi();
        syncVariantsNextBtn();
        bindPdpThumbnailSync(
          getSectionRoot(root, data),
          (data && data.sectionId) || root.getAttribute('data-section-id') || ''
        );
        if (state.selectedSlot) refreshCartSeatsForSelected(state.selectedSlot);
      } else {
        renderCalendar();
      }
    }

    root.__wcfCtrl = {
      getState: function () {
        return {
          branch: state.branch,
          stepIndex: state.stepIndex,
          selectedDate: state.selectedDate,
          selectedSlot: state.selectedSlot,
          cartSeatsForSelected: state.cartSeatsForSelected,
          slotList: slotList.slice(),
          daysWithEvents: Object.assign({}, daysWithEvents),
        };
      },
      applySlots: function (newSlots, newCtx) {
        var silent = !!(newCtx && newCtx.silent);
        var prevDate = state.selectedDate;
        var prevSlotGid = state.selectedSlot && state.selectedSlot.gid;
        var prevQty = Object.assign({}, state.variantQty);
        var prevAddon = state.addonQty;
        var prevFocused = state.focusedVariantId;
        var hadUi = !!root.__wcfUiReady && state.branch === 'booking';

        slotList = Array.isArray(newSlots) ? newSlots.slice() : [];
        root.__wcfCurrentSlots = slotList.slice();
        if (newCtx && newCtx.apiError) {
          state.wlContext = 'api_error';
          root.setAttribute('data-wcf-slots-error', '1');
        } else {
          state.wlContext = 'no_events';
          root.removeAttribute('data-wcf-slots-error');
        }
        if (window.WorkshopCityFlow && typeof window.WorkshopCityFlow.syncSessionsLoadErrorUi === 'function') {
          window.WorkshopCityFlow.syncSessionsLoadErrorUi(root, newCtx && newCtx.apiError);
        }
        state.branch = 'booking';
        root.setAttribute('data-wcf-slot-count', String(slotList.length));
        root.setAttribute('data-wcf-branch', state.branch);
        rebuildDaysWithEvents();

        if ((silent || hadUi) && state.branch === 'booking') {
          state.selectedDate = prevDate;
          state.variantQty = prevQty;
          state.addonQty = prevAddon;
          state.focusedVariantId = prevFocused;
          state.selectedSlot = prevSlotGid ? slotByGid(prevSlotGid) : null;
          applyDeepLinkFromUrl();
          ensureDefaultDateAndTime();
          syncDateTriggerLabel();
          syncTimeTriggerLabel();
          updateAddCartBtn();
          updateBookingSummary();
          refreshOpenPickerPills();
          syncPcwConnectWaitlist(root, pcwCountBookableSlots(slotList));
          return;
        }

        state.stepIndex = 0;
        state.selectedSlot = null;
        state.waitlistReturnStep = null;
        state.variantQty = {};
        state.cartSeatsForSelected = 0;
        state.addonQty = 0;
        applyBranchUi();
        delete root.__wcfUrlRestoreDone;
        applyDeepLinkFromUrl();
        syncPcwConnectWaitlist(root, pcwCountBookableSlots(slotList));
      },
      refreshLiveSlots: function (mergedSlots) {
        slotList = Array.isArray(mergedSlots) ? mergedSlots.slice() : [];
        root.__wcfCurrentSlots = slotList.slice();
        rematchSelectedSlot();
        if (state.branch === 'booking' && (!state.selectedSlot || !slotBookable(state.selectedSlot))) {
          ensureDefaultDateAndTime();
        }
        rebuildDaysWithEvents();
        root.setAttribute('data-wcf-slot-count', String(slotList.length));
        syncPcwConnectWaitlist(root, pcwCountBookableSlots(slotList));
        if (state.branch !== 'booking') return;
        var qtyChanged = clampVariantQtyToCapacity();
        if (qtyChanged) syncVariantRowsState();
        syncDateTriggerLabel();
        syncTimeTriggerLabel();
        updateAddCartBtn();
        updateBookingSummary();
        refreshOpenPickerPills();
      },
    };

    startWizardLivePoll(root, function (merged) {
      if (root.__wcfCtrl && typeof root.__wcfCtrl.refreshLiveSlots === 'function') {
        root.__wcfCtrl.refreshLiveSlots(merged);
      }
    });

    applyBranchUi();
    applyDeepLinkFromUrl();
    syncPcwConnectWaitlist(root, pcwCountBookableSlots(slotList));
    if (root.__wcfPendingSilentSlots) {
      var pendingSilent = root.__wcfPendingSilentSlots;
      delete root.__wcfPendingSilentSlots;
      if (root.__wcfCtrl && typeof root.__wcfCtrl.applySlots === 'function') {
        root.__wcfCtrl.applySlots(pendingSilent, { silent: true });
      }
    }
  }

  function boot(container, options) {
    var scope = container && container.querySelectorAll ? container : document;
    scope.querySelectorAll('[data-popup-city-wizard]').forEach(function (root) {
      initRoot(root, options);
    });
  }

  function resetWizardRoot(root) {
    cleanupDeferredFetch(root);
    stopWizardLivePoll(root);
    pcwClearWaitlistWatch(root);
    delete root.__pcwWlCtxKey;
    if (root.__wcfOnClick) root.removeEventListener('click', root.__wcfOnClick);
    if (root.__wcfOnChange) root.removeEventListener('change', root.__wcfOnChange);
    delete root.__wcfOnClick;
    delete root.__wcfOnChange;
    root.__wcfBound = false;
    delete root.__wcfCtrl;
    delete root.__wcfHadSlots;
    delete root.__wcfUiReady;
    delete root.__wcfPendingSilentSlots;
    delete root.__wcfSkeletonSlots;
    delete root.__wcfCurrentSlots;
    delete root.__wcfEventJsonLdDone;
    delete root.__wcfSlotsFetchStarted;
    delete root.__wcfActiveFetchPromise;
    delete root.__wcfBookingConfig;
    delete root.__wcfLastPollIntervalMs;
    delete root.__wcfOnMergedSlots;
    delete root.__wcfRestartLivePoll;
  }

  function bootWhenReady(options) {
    if (window.WorkshopCityEvents && typeof window.WorkshopCityEvents.fetchSlots === 'function') {
      boot(undefined, options);
      return;
    }
    var attempts = 0;
    function tryBoot() {
      attempts += 1;
      if (window.WorkshopCityEvents && typeof window.WorkshopCityEvents.fetchSlots === 'function') {
        boot(undefined, options);
        return;
      }
      if (attempts < 40) window.setTimeout(tryBoot, 50);
      else {
        console.warn('[popup-city-wizard] WorkshopCityEvents never loaded');
        boot(undefined, options);
      }
    }
    tryBoot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bootWhenReady();
    });
  } else {
    bootWhenReady();
  }
  document.addEventListener('shopify:section:load', function (evt) {
    var target = evt.target;
    if (target && target.querySelectorAll) {
      target.querySelectorAll('[data-popup-city-wizard]').forEach(resetWizardRoot);
      boot(target, { sectionReload: true });
      return;
    }
    document.querySelectorAll('[data-popup-city-wizard]').forEach(resetWizardRoot);
    boot(undefined, { sectionReload: true });
  });
})();
